const resources = {
  translation: {
    DASHBOARD: {
      LOCATION_CARD: {
        HEADER: {
          SUBTITLE: {
            NO_DATA: '0',
            ALARM: '{{count}} Alarm',
            ALARM_plural: '{{count}} Alarmy',
            ALARM_noData: '0 Alarmów',
            NORMAL: 'Normalny',
},
          INFO: {
            SEPARATOR : ',',
            DEVICE: '{{count}} Urządzenie',
            DEVICE_plural: '{{count}} Urządzenia',
            SITE: '{{count}} Lokalizacja',
            SITE_plural                    : '{{count}} Lokalizacje',
            DEVICE_noData: '0 Urządzeń',
            SITE_noData  : '0 Lokalizacji',
},
},
        BODY: {
          ALARMS: '{{count}} Alarm',
          ALARMS_plural: '{{count}} Alarmy',
          EVENTS: '{{count}} Zdarzenie',
          EVENTS_plural: '{{count}} Zdarzenia',
          ALARMS_noData: '0 Alarmów',
          EVENTS_noData: '0 Zdarzeń',
},
        FOOTER: {
          VIEW_LOCATION: 'Pokaż Lokalizację',
},
},
      SITE_CARD: {
        HEADER: {
          SUBTITLE: {
            NO_DATA: '--',
},
          INFO: {
            DEVICE: '{{count}} Urządzenie',
            DEVICE_plural: '{{count}} Urządzenia',
            DEVICE_noData: '0 Urządzeń',
},
},
        BODY: {
          ONLINE_noData: '--\'',
          ALARMS: '{{count}} Alarm',
          ALARMS_plural: '{{count}} Alarmy',
          EVENTS: '{{count}} Zdarzenie',
          EVENTS_plural: '{{count}} Zdarzenia',
          ALARMS_noData: '0 Alarmów',
          EVENTS_noData: '0 Zdarzeń',
          OFFLINE: 'Offline',
          ONLINE: 'Online',
},
        FOOTER: {
          VIEW_LOCATION: 'Pokaż Witrynę',
},
},
      TIMELINE_DETAILS: {
        ACKNOWLEDGED: 'POTWIERDZONE',
        OPEN: 'AKTYWNY',
        CLOSED: 'ZAMKNIĘTE',
        EARLIER: 'Wcześniej',
        FUTURE: 'Przyszły',
        INACTIVE: 'NIEAKTYWNY',
        LAST_WEEK: 'Ostatni Tydzień',
        THIS_WEEK: 'W tym tygodniu',
        TIMELINE: 'Oś Czasu.',
        TODAY: 'Dzisiaj.',
        UNACKNOWLEDGED: 'NIEPOTWIERDZONE.',
        YESTERDAY: 'Wczoraj',
},
      ADD_BUILDING: 'Dodaj Budynek do',
      AUTO_REDIRECT_BANNER: {
        ADD_LOCATION_BUTTON: 'Dodaj Lokalizację',
        DISMISS: 'Odrzuć',
        MESSAGE: 'Zostałeś automatycznie przekierowany do {{location}}, ponieważ nie posiadasz innych lokalizacji najwyższego poziomu.',
},
      USERS_ADMIN: 'Administrator',
      USERS_ADMIN_S: 'Administratorzy',
      ADMINS_TITLE: 'Administratorzy',
      SITE_DETAILS: {
        READING_CARDS: {
          ALARM: 'Alarm',
          BATTERY: 'Bateria',
          FULL: 'Pełny',
          OFFLINE: 'Offline',
          ONLINE: 'Online',
          PENDING: 'Oczekujące',
          UNKNOWN: 'Nieznane.',
          VIEW_ALL: 'Pokaż Wszystko',
},
        ALL_DETAILS: 'Wszystkie Szczegóły',
        ALL_DEVICES: 'Wszystkie Urządzenia',
        TRENDS_CARD: {
          CHANNELS: 'Kanały',
          DAY: 'Dzień',
          DAYS: 'Dni',
          TITLE: 'Trendy.',
          TRENDVIEWER: 'Przeglądarka Trendów.',
          VIEW_ALL: 'Pokaż Pełną Przeglądarkę Trendów',
},
        DEVICES_CARD: {
          TITLE: 'Urządzenia',
          VIEW_ALL: 'Pokaż Wszystkie Urządzenia',
},
        TIMELINE_CARD: {
          TITLE: 'Oś Czasu.',
          VIEW_ALL_EVENTS: 'Pokaż Wszystkie Wydarzenia',
},
},
      ALL_BUILDINGS_COUNT: 'Wszystkie Budynki ({{count}})',
      ALL_LOCATIONS: 'Wszystkie Lokalizacje',
      ALL_ORGANIZATION: 'Wszystkie Organizacje',
      ALL_DEVICES_COUNT: 'Wszystkie Systemy ({{count}})',
      ADMINS_AND: 'i',
      DASHBOARD_ASSETS_TITLE: 'Zasoby',
      STATUS_BLOCKED: 'Zablokowane',
      STATUS_COUNT_BLOCKED: 'Zablokowane ({{count}})',
      BUILDING_CONTACT: 'Kontakt z Budynkiem',
      BUILDING_CONTACT_DETAILS_LABEL: 'Szczegóły Kontaktu Budynku',
      CHOOSE_LOCATION: 'Wybierz Lokalizację',
      CONTACT_MANAGER: 'Skontaktuj się z menedżerem konta lub',
      ADD_ORGANIZATION: 'Utwórz Organizację',
      OVERVIEW_TITLE: 'Pulpit',
      DASHBOARD_TITLE: 'Pulpit',
      DEVICES_TITLE: 'Urządzenia',
      EARLIER: 'Wcześniej',
      EDIT_CONTACT_BUTTON: 'Edytuj Szczegóły Kontaktu',
      BUILDING_DETAIL_EMAIL: 'E-mail',
      STATUS_EMPTY: 'Pusty',
      STATUS_COUNT_EMPTY: 'Pusty ({{count}})',
      ERROR_LOADING_CHANNELS: 'Błąd ładowania kanałów',
      ERROR_LOADING_DATA: 'Błąd ładowania danych',
      ERROR_LOADING_DEVICES: 'Błąd ładowania urządzeń',
      ERROR_LOADING_EVENT: 'Błąd ładowania zdarzenia',
      ERROR_LOADING_EVENTS: 'Błąd ładowania zdarzeń',
      ERROR_LOADING_LOCATION: 'Błąd ładowania lokalizacji',
      ERROR_LOADING_LOCATIONS: 'Błąd ładowania lokalizacji',
      ERROR_LOADING_ORGANIZATION: 'Błąd ładowania organizacji',
      ERROR_LOADING_SITE: 'Błąd ładowania lokalizacji',
      ERROR_LOADING_SITES: 'Błąd ładowania lokalizacji',
      ERROR_LOADING_TRENDS: 'Błąd ładowania trendów',
      EVENT_NOT_FOUND: 'Zdarzenie Nie Znalezione',
      STATUS_ANOMALY: 'W Anomalii',
      STATUS_COUNT_ANOMALY: 'W Anomalii ({{count}})',
      LAST_90_DAYS: 'Ostatnie 90 Dni',
      LATEST_LOGS: 'Najnowsze Dzienniki',
      LOCATION_NOT_FOUND: 'Lokalizacja Nie Znaleziona',
      LOCATIONS_TITLE: 'Lokalizacje',
      LOCATION: 'Lokalizacje',
      DASHBOARD_LOGBOOK_TITLE: 'Dziennik',
      MAIN_CONTACT_LABEL: 'Główny Kontakt Budynku',
      ADMINS_MORE: 'Więcej',
      DASHBOARD_MANAGE_ORGANIZATION_TITLE: 'Moje Organizacje',
      NO_FOUND: 'Nie znaleziono {{entity}}',
      NO_EVENTS: 'Brak Alarmów',
      NO_CHANNELS: 'Brak Kanałów',
      NO_CHANNELS_ENABLED: 'Brak Aktywnych Kanałów',
      NO_DATA: 'Brak Danych',
      NO_DATA_POINTS: 'Brak danych z określonego obszaru czasu',
      NO_DEVICES: 'Brak Urządzeń',
      NO_LOCATION_SELECTED: 'Nie Wybrano Lokalizacji',
      NO_LOCATIONS: 'Brak Lokalizacji',
      NO_ORGANIZATION_SELECTED: 'Nie Wybrano Organizacji',
      NO_SITES: 'Brak Lokalizacji',
      NO_TRENDS: 'Brak Trendów',
      NO_USER_DATA: 'Brak Danych Użytkownika',
      STATUS_COUNT_OFFLINE: 'OFFLINE ({{count}})',
      ORGANIZATION_TITLE: 'ORGANIZACJA',
      ORGANIZATION_NOT_FOUND: 'Nie Znaleziono Organizacji',
      ORGANIZATION: 'Organizacje',
      BUILDING_DETAIL_PHONE: 'Telefon',
      PLATFORM_USER_DASHBOARD_WARNING: 'Uzyskaj dostęp do aplikacji internetowej, aby odkryć wszystkie jej funkcje',
      PROJECT: 'PROJEKT',
      STATUS_READY: 'Gotowy',
      STATUS_COUNT_READY: 'Gotowy ({{count}})',
      DASHBOARD_REPORTS_TITLE: 'Raporty',
      SAVE_USER_DETAILS: 'Zapisz Szczegóły Użytkownika',
      SECONDARY_CONTACT_LABEL: 'Kontakt Drugorzędny w Budynku',
      SITE_NOT_FOUND: 'Nie Znaleziono Lokalizacji',
      SITE: 'lokalizacje',
      TIMELINE_TITLE: 'Oś Czasu.',
      NEW_SITE: 'Dołącz lub utwórz nowy {{entity}}.',
      UNKNOWN_DEVICE_TYPE: 'Nieznane.',
      EDIT_USER_DETAILS: 'Szczegóły Użytkownika',
      USERS_TITLE: 'Użytkownicy',
      VIEW_LOGBOOK: 'Pokaż Dziennik zdarzeń',
      USERS_VIEWER: 'Przeglądający',
      USERS_VIEWER_S: 'Przeglądający',
      NOT_ACCESS: 'Nie masz jeszcze dostępu do żadnego {{entity}}.',
      STARRED_ORGANIZATIONS: 'Pokaż Tylko Ulubione Organizacje.',
},
    EVENT_DETAILS: {
      UNKNOWN: '--',
      ACKNOWLEDGE: 'Potwierdź',
      ACKNOWLEDGED: 'Potwierdzone',
      ACKNOWLEDGE_BY: 'Potwierdzone przez {{user}} na',
      ACKNOWLWEGED_ERROR: 'Potwierdzenie nie powiodło się w komunikacji z urządzeniem końcowym w dniu {{errorDate}}. Jeśli problem się powtarza, prosimy o kontakt z naszym zespołem wsparcia pod numerem {{phoneno}} lub e-mail',
      DEVICE_MODEL: 'Model Urządzenia',
      DEVICE_SERIAL: 'Numer Seryjny Urządzenia',
      ERROR_LOADING_DEVICE_DETAILS: 'Błąd ładowania szczegółów urządzenia',
      ERROR_LOADING_EVENT_DETAILS: 'Błąd ładowania szczegółów zdarzenia',
      TITLE: 'Szczegóły Zdarzenia',
      ALARM_STATUS: 'Początkowy Status Alarmu',
      LAST_DATA_RECEIVED: 'Ostatnia Aktualizacja Alarmu Odebrana',
      NO_DEVICE_DETAILS: 'Brak Szczegółów Urządzenia',
      NO_EVENT_DETAILS: 'Brak Szczegółów Zdarzenia',
      PLEASE_RETRY: 'Spróbuj ponownie:',
      SENDING: 'Wysyłanie...',
      SET_POINT: 'Punkt Nastawczy (Próg)',
      THRESHOLD: 'Próg',
      TIME_ALARM_SENT: 'Czas Wysłania Początkowego Alarmu.',
},
    DEVICE_DETAILS: {
      EMPTY_VALUE: '--\'',
      USERS_ADMINS: 'administrator',
      USERS_VIEWER: 'Podglądający',
      FIRMWARE_AVAILABLE_GUIDE_LINK: '(Przewodnik)',
      USERS_COUNTS: '{{adminCount}} administrator, {{viewerCount}} podglądający',
      FIRMWARE_AVAILABLE_GUIDE: 'Dostępna wersja: {{availableVersion}}',
      LUMINARY_ATSD: 'ATSD #',
      CONNECTION_TYPE_BLE: 'BLE',
      BLOCK: 'Zablokowane',
      BUILDING: 'Budynek',
      CONNECTION_TYPE_CELLULAR: 'Komórkowy',
      LUMINARY_CIRCUIT: 'Obwód',
      LUMINARY_CIRCUIT_HASH: 'Nr Obwodu',
      CITY: 'Miasto',
      CONNECTED: 'Połączony',
      CONNECTION_TYPE: 'Typ Połączenia',
      DATE_COMMISSIONED: 'Data Wdrożenia',
      DEVICE_MODEL: 'Model Urządzenia',
      DEVICE_SERIAL: 'Numer Seryjny Urządzenia',
      DURATION_TEST: 'Test czasu podtrzymania',
      DURATION_TEST_DURATION: 'Czas trwania testu czasu podtrzymania',
      ERROR: 'Błąd',
      CHANNEL_DATA_ERROR: 'Błąd ładowania danych kanału',
      DEVICE_CONNECTION_ERROR: 'Błąd ładowania danych połączenia',
      DEVICE_DETAILS_ERROR: 'Błąd ładowania szczegółów urządzenia',
      CONNECTION_TYPE_ETHERNET: 'Ethernet',
      EVENT: 'Zdarzenie',
      FIRMWARE_VERSION: 'Wersja oprogramowania sprzętowego',
      FUNCTIONAL_TEST: 'Test funkcjonalny opraw awaryjnych',
      DELAY_FUNCTIONAL_TEST: 'Opóźnienie testu funkcjonalnego',
      GATEWAY_ADDRESS: 'Adres Bramki sieciowej',
      GATEWAY_NAME: 'Nazwa Bramki sieciowej',
      GATEWAY_COUNT: 'Bramka sieciowa dla {{systemCount}} systemu',
      GATEWAY_COUNT_SYSTEMS: 'Bramka sieciowa dla {{systemCount}} systemów',
      GATEWAYS: 'Bramka sieciowa',
      HOSTNAME: 'Nazwa Host',
      LUMINARY_DETAIL_INFO: 'Informacje',
      IPADDRESS: 'Adres IP',
      LAST_DATA: 'Ostatnie Dane',
      LUMINAIRE: 'Oprawa awaryjna',
      LUMINARY_ADDRESS: 'Adres Oprawy Awaryjnej',
      LUMINAIRES: 'Oprawy awaryjne',
      LUMINARIES_COUNTS: 'Oprawy awaryjne',
      MAC_ADDRESS: 'Mac Address',
      CONNECTION_TYPE_MODBUS: 'Modbus',
      LUMINARY_MODEL: 'Model',
      CONNECTION_TYPE_MQTT: 'MQTT',
      LUMINARY_NAME: 'Nazwa',
      NAME: 'Nazwa',
      NETWORK_DETAILS: 'Szczegóły Sieci',
      NEXT: 'Dalej',
      LUMINARY_DISCRIPTION: 'Nastepny test czasu podtrzymania',
      NEXT_DURATION_TEST: 'Nastepny test czasu podtrzymania',
      NEXT_FUNCTIONAL_TEST: 'Nastepny test funkcjonalny opraw',
      NO_CHANNEL_DATA: 'Brak Danych Kanału',
      NO_DEVICE_CONNECTION: 'Brak Danych Połączenia z Urządzeniem',
      NO_DEVICE_DETAILS: 'Brak Danych Szczegółów Urządzenia',
      OFFLINE: 'Offline',
      ONLINE: 'Online',
      ORGANIZATION: 'Organizacja',
      PART_NUMBER: 'Numer Części',
      PREVIOUS: 'Poprzednie',
      PREVIOUS_DURATION_TEST: 'Poprzedni Test Czasu Trwania Rozpoczęty',
      PREVIOUS_FUNCTIONAL_TEST: 'Poprzedni Test Funkcjonalny Rozpoczęty',
      READY: 'Gotowy',
      CONNECTION_TYPE_RS485: 'RS485',
      SERIAL_NUMBER: 'Numer Seryjny',
      GATEWAY_SHOW_ALL: 'Pokaż Wszystkie',
      STATUS: 'Status',
      LUMINARY_STATUS: 'Status',
      SUBNET_MASK: 'Maska Podsieci',
      SYSTEM: 'SYSTEM',
      SYSTEMS: 'Systemy',
      LUMINARY_DETAIL_TEST: 'Testy',
      TYPE: 'Typ.',
      LUMINARY_TYPE: 'Typ.',
      UPDATE_REQUIRED: 'WYMAGANA AKTUALIZACJA.',
      USERS: 'Użytkownicy',
      WARNING: 'Ostrzeżenie',
      CONNECTION_TYPE_WIFI: 'WiFi',
      CONNECTION_TYPE_WIREPASS: 'Wirepas',
},
    FORMS: {
      OPTIONAL: 'Opcjonalne',
      BUILDING_COMPANY_ADDRESS: 'Linia Adresu 1',
      BUILDING_COMPANY_ADDRESS2: 'Linia Adresu 2 (Opcjonalnie)',
      BUILDING_DETAILS: 'Szczegóły Budynku',
      CITY: 'Miasto',
      USER_ADDRESS_1: 'Linia Adresu Firmy 1',
      USER_ADDRESS_2: 'Linia Adresu Firmy 2',
      COMPANY_NAME: 'Nazwa Firmy',
      CONFIRM_PASSWORD: 'Potwierdź Hasło',
      COUNTRY: '**Kraj * **',
      HELPING_TEXT: 'Pola oznaczone gwiazdką (*) są wymagane',
      FIRST_NAME: 'Imię',
      LAST_NAME: 'Nazwisko',
      LOCAL_PRIMARY_EMAIL: 'Adres E-mail Głównego Lokalnego Kontaktu',
      LOCAL_PRIMARY_CONTACT_INFO: 'Informacje Głównego Lokalnego Kontaktu',
      LOCAL_SECONDARY_EMAIL: 'Adres E-mail Drugorzędnego Lokalnego Kontaktu',
      LOCAL_SECONDARY_CONTACT_INFO: 'Informacje Drugorzędnego Lokalnego Kontaktu',
      ORGANIZATION_ADDRESS_HEADER: 'Adres Organizacji',
      COMPANY_ADDRESS: 'Adres Organizacji Linia 1',
      ADDRESS_LINE_2: 'Adres Organizacji Linia 2',
      ORGANIZATION_DETAILS_HEADER: 'Szczegóły Organizacji',
      PASSWORD: 'Hasło',
      PASS_MATCH_ERROR: 'Hasła nie pasują ',
      PHONE_NUMBER: 'Numer Telefonu',
      INVALID_CUSTOMER_NUMBER: 'Podaj prawidłowy numer klienta',
      INVALID_EMAIL_ERROR: 'Podaj prawidłowy adres e-mail',
      INVALID_DETAILS: 'Podaj prawidłowe parametry wejściowe',
      INVALID_PHONE_NUMBER: 'Podaj prawidłowy numer telefonu',
      INVALID_POSTAL_CODE: 'Podaj prawidłowy kod pocztowy',
      INVALID_SLA_NUMBER: 'Podaj prawidłowy numer SLA, co najmniej 8 znaków',
      POSTAL_CODE: 'Kod Pocztowy',
      PRIMARY_CONTACT_INFORMATION: 'Informacje o Głównym Kontakcie',
      RESET_PASSWORD: 'Reset hasła',
      TOGGLE_PASSWORD_VISIBILITY: 'Przełącz widoczność hasła.',
      VERIFICATION_CODE: 'Kod Weryfikacyjny',
},
    DUALSMART: {
      DS_LUMINARIES_FOUND: 'Znaleziono  oprawy awaryjne',
      DS_CIRCUIT_READY: 'Obwód gotowy do pracy',
      DS_COMMUNICATION_FAILURE: 'Awaria komunikacji',
      DS_DIMM_ERROR: 'Błąd ściemniania',
      DS_OVERCURRENT: 'Przeciążenie prądowe',
      DS_SAVE_UPDATE_BUTTON: 'Zapisz aktualizację',
      DS_SYNC_DATE_AND_TIME: 'Synchronizuj Harmonogram Testów',
      DS_CONNECTED_POWER_INFO: '10W / 15VA',
      DS_SYSTEM_COMPONENTS_COUNT: '7 komponentów',
      DS_LUMINARIES_FOUND_TITLE: 'Oprawy awaryjne zostały znalezione w tym systemie',
      DS_AE_ERROR: 'Błąd AE',
      DS_ALL_STATUSES: 'Wszystkie Statusy',
      DS_ALL_TESTS_PASSED: 'Wszystkie testy zakończone powodzeniem',
      DS_ESTIMED_GUIDELINE_ONE: 'Około 10 lat w temperaturze  pracy 20 °C',
      DS_ESTIMED_GUIDELINE_THREE: 'Żywotność około 5 lat w temperaturze 30 °C',
      DS_ESTIMED_GUIDELINE_TWO: 'Około 7 lat w temperaturze pracy 25 °C',
      DS_BATTERY_CHARGER: 'Bateria / Ładowarka',
      DS_BATTERY_CHARGE: 'Ładowanie baterii',
      DS_BATTERY_OPERATION: 'Praca z baterii',
      DS_BLOCK_DEVICE: 'Zablokuj urządzenie',
      DS_BLOCK_DEVICE_INFO: 'Zablokowanie urządzenia wyłącza funkcję awaryjną i odłącza obwód',
      DS_BLOCK_SUCCESS: 'Zablokowanie zostało pomyślnie wykonane',
      DS_BULB_ERROR_AC: 'Błąd źródła światła przy AC',
      DS_BULB_ERROR_DC: 'Błąd źródła światła przy DC ',
      DS_CAPACITY: 'Pojemność',
      DS_CHARGER_LEVEL: 'Poziom Naładowania:',
      DS_CHARGING_ERROR: 'Awaria ładowania',
      DS_FUNCTIONAL_GUIDELINE: 'Wybierz czas między 20 a 800 sekund, aby system  przełączył się na działanie DC w celu przeprowadzienia testu akumulatora',
      DS_CIRCUIT: 'Obwód',
      DS_CIRCUIT_FAILURE: 'Awaria obwodu',
      DS_CIRCUITS_INFO_HEADER: 'Informacje o obwodzie:',
      DS_CIRCUITS_NO: 'Nr obwodu',
      DS_CIRCUITS: 'Obwody',
      DS_COMPONENTS_DETAIL: 'Szczegóły komponentu',
      DS_CONNECTED_POWER: 'Załączona moc:',
      DS_CRYSTALWAY: 'CrystalWay 20m',
      DS_DAYS_BETWEEN_THE_TEST: 'Dni między testami',
      DS_DC1: 'DC1',
      DS_DC2: 'DC2',
      DS_KEEP_DEEP_DISCHARGE: ' Ochrona przed głębokim rozładowaniem',
      DS_DELAY_ON_MAINS_RETURN: 'Opóźnienie po powrocie zasilania sieciowego',
      DS_ESTIMED_GUIDELINE: 'W zależności od temperatury otoczenia i warunków na miejscu:',
      DS_DESCRIPTION: 'Opis',
      DS_END_DURATION_TEST_POPUP: 'Czy chcesz zatrzymać test akumulatorów?',
      DS_DOUBLE_ADDRESS: 'Podwójny Adres',
      DS_DT_FORERUN: 'Uruchominie DT',
      DS_DEVICE_COMMISSIONING: 'Uruchomienie DualSmart',
      DS_PASSWORD: 'Hasło do DualSmart ',
      DS_DURATION: 'Czas trwania testu akumulatorów',
      DS_DURATION_TEST: 'Test akumulatorów',
      DS_DURATION_TEST_SCHEDULE: 'Harmonogram testów akumulatorów',
      DS_EDIT_BATTERY_DETAILS: 'Edytuj Szczegóły Baterii',
      DS_DASH_EMPTY: 'Pusty',
      DS_ESTIMED_LIFESPAN: 'Szacowana żywotność',
      DS_EXIT_SIGN: 'Znak Wyjścia',
      DS_FAN_OPERATING_HOURS: 'Czas pracy wentylatora',
      DS_FOUND: 'Znaleziono',
      DS_FT_FORERUN: 'Start testu FT',
      DS_FUNCTIONAL: 'Funkcjonalny',
      DS_FUNCTIONAL_LEAD_AND_TIME: 'Czas testu funkcjonalnego',
      DS_FUNCTION_TEST: 'Test funkcjonalny opraw awaryjnych',
      DS_FUNCTIONAL_TEST_SCHEDULE: 'Harmonogram rozpoczęcia testu funkcjonalnego',
      DS_SYNC_DATE_AND_TIME_SUBTITLE: 'Biuro główne „G-North”',
      DS_CIRCUITS_DESCRIPTION: 'Pomóż mi z opisem',
      DS_SEARCH_LUM_INFO_TEXT: 'Jeśli chcesz jedynie dodać oprawy oświetleniowe, użyj opcji „Szukaj nowych opraw awaryjnych”.',
      DS_SEARCH_LUMS_POPUP_SUB_TITLE: 'Jeśli chcesz jedynie dodać nowe oprawy oświetleniowe, użyj opcji „Szukaj nowych opraw awaryjnych”.',
      DS_INSTALLATION_DATE: 'Data Instalacji',
      DS_INTERVAL: 'Interwał',
      DS_CIRCUITS_INFO: 'Wymagany klucz. Obszar ograniczony! Wymagana rejestracja.',
      DS_LAST_DURATION_TEST_TIME: 'Czas ostatniego testu podtrzymania akumulatorów',
      DS_LIGHTANDBUILDING: 'Light & Building 2024',
      DS_LUMINAIRE_FAILURE: 'Awaria oprawy awaryjnej',
      DS_LUMINAIRE_NAME: 'Nazwa oprawy awaryjnej',
      DS_LUMINARIES: 'Oprawy awaryjne',
      DS_MAINS_OPERATION: 'Zasilanie sieciowe',
      DS_NEXT_TEST_DATE: 'Data następnego testu',
      DS_NO_OPERATION_POSSIBLE: 'Brak Możliwości Operacyjnych',
      DS_NORMAL_OPERATION: 'Normalna praca',
      DS_OPERATION_FAILED: 'Operacja Nie Powiodła się',
      DS_OVERTEMPERATURE: 'Za wysoka temperatura',
      DS_OVERVOLTAGE: 'Za wysokie napięcie',
      DS_PREV: 'Poprzednie',
      DS_READY_ON: 'Gotowy do pracy',
      DS_RELEASE_DEVICE: 'Zwolnij Urządzenie',
      DS_RELEASE_DEVICE_INFO: 'Zwolnienie Urządzenia Przywraca Tryb Operacyjny.',
      DS_RELASE_SUCCESS: 'Zwolnienie zakończone sukcesem',
      DS_SEARCH_LUM_WARNING_TEXT: 'Pobieranie danych. Poczekaj kilka sekund i spróbuj ponownie wyciąć lub skopiować.',
      DS_CIRCUIT_LUMINARIES_DESC: 'Pobieranie danych. Poczekaj kilka sekund i spróbuj ponownie wyciąć lub skopiować.',
      DS_SEARCH_COMPLETE: 'Wyszukiwanie zakończone',
      DS_SEARCH_GUIDLINE_ONE_TEXT: 'Wyszukaj wszystkie zainstalowane i zaadresowane oprawy awaryjne',
      DS_SEARCH_ALL_LUMINARIES: 'Wyszukaj wszystkie oprawy awaryjne',
      DS_SEARCH_LUM_TEXT: 'Wyszukiwanie wszystkich opraw awaryjnych, utworzy nową konfigurację, wykonując następujące czynności:',
      DS_SEARCH_LUMS_POPUP_TITLE: 'Rozpoczęcie wyszukiwania usunie wszystkie aktywowane oprawy z usterką z twojej konfiguracji.',
      DS_SEARCH_GUIDLINE_TWO_TEXT: 'Rozpoczęcie wyszukiwania usunie wszystkie aktywowane oprawy z usterką z twojej konfiguracji.',
      DS_STARTS: 'Rozpoczęcia',
      DS_SUMMARY_FT: 'Podsumowanie Testu Funkcjonalnego',
      DS_SYSTEM_COMPONENTS: 'Komponenty Systemu',
      DS_SYNC_DATE_AND_TIME_TITLE: 'Daty i Czas Testów',
      DS_TEST_INTERVAL: 'Interwał Testów',
      DS_TEST_LENGTH: 'Czas Trwania Testu',
      DS_VIEW_CIRCUITS: 'Pokaż Według Obwodu',
      DS_W: 'W:',
      DS_SEARCH_FOR_NEW_LUMINARIES: 'Wyszukaj nowe oprawy awaryjne',
      DS_SEARCH_LUM_NEW_TEXT: 'Wyszukaj nowe oprawy awaryjne, aby dodać je do swojej konfiguracji oświetlenia:',
      DS_SEARCH_NEW_LUM_GUIDLINE_ONE_TEXT: 'To automatycznie przypisze adresy nowym lub wymienionym oprawom w Twojej konfiguracji oświetlenia.',
      DS_SEARCH_NEW_LUM_INFO_TEXT: 'Jeśli chcesz jedynie dodać oprawy aawaryjne, użyj opcji „Szukaj nowych opraw awaryjnych”.',
      DS_NEW: 'Nowy',
      DS_MODULE_TYPE: 'Typ modułu',
      DS_SEARCH_IO_MODULES: 'Wyszukaj moduły IO',
      DS_SEARCH_FOR_IO_MODULES: 'Wyszukuj dla  modułów IO',
      DS_SEARCH_IO_MODULES_TEXT: 'Wyszukiwanie modułów IO utworzy nową konfigurację, wykonując następujące czynności:',
      DS_SEARCH_GUIDELINE_IO_MODULES_TEXT: 'Wyszukaj wszystkie zainstalowane moduły na magistrali, aby je skonfigurować i zaprogramować.',
      DS_SEARCH_IO_MODULES_BTN_TEXT: 'Wyszukuj dla  modułów IO',
      DS_SEARCH_IO_MODULES_POPUP_TITLE: 'Jeśli moduły nie są poprawnie podłączone, wpłynie to trwale na Twoją konfigurację.',
      DS_SEARCH_IO_MODULES_POPUP_SUB_TITLE: 'Upewnij się, że wszystkie połączenia są poprawne przed rozpoczęciem wyszukiwania.',
      DS_PHYSICAL_MODULES: 'Bezpośrednio podłączony',
      DS_SUBSCRIBED_MODULES: 'Subskrybowane',
      DS_MODULES_FOUND: 'Znalezione moduły',
      DS_MODULE_NUMBER: 'Nr modułu',
      DS_SEARCHING: 'Wyszukiwanie...',
      DS_TIMER: 'Timer',
      DS_SET_TIMER: 'Ustaw timer',
      DS_SUBMIT_CHANGES: 'Prześlij zmiany',
      DS_TIMER_1: 'Timer 1',
      DS_TIMER_2: 'Timer 2',
      DS_TIME_TITLE: 'Tytuł timera (opcjonalny)',
      DS_DAYS: 'Dni tygodnia i czas',
      DS_ACTIVE_DAYS: 'Wybierz dni tygodnia, w których ___ ma być aktywny.',
      DS_START_TIME: 'Czas rozpoczęcia',
      DS_END_TIME: 'Czas zakończenia',
      DS_SET_RELAY_BUZZER: 'Ustaw przekaźnikowy sygnał dźwiękowy',
      DS_RESET_TO_DEFAULT_VALUES: 'Przywróć ustawienia domyślne',
      DS_RESET_TO_DEFAULT_VALUES_INFO: 'Wybierz wyjście, aby przypisać jego funkcje. Kliknij „Zapisz” po zakończeniu.',
      DS_SEARCH_NEW_LUMINARIES_INFO: 'Nową konfigurację oprawy można udostępnić za pomocą opcji „Eksportuj”',
      DS_RELAY_NO: 'Nr przekaźnika',
      DS_RESET_RELAY_BUZZER_POPUP_TITLE: 'Proszę potwierdzić',
      DS_RESET_RELAY_ONE_TO_DEFAULT: 'Zresetuj przekaźnik 1 do wartości domyślnych',
      DS_RESET_RELAY_BUZZER_TO_DEFAULT: 'Zresetuj przekaźniki i sygnał dźwiękowy do wartości domyślnych',
      DS_UNSAVED_CHANGES_POPUP_TITLE: 'Istnieją niezapisane zmiany',
      DS_UNSAVED_CHANGES_POPUP_SUB_TITLE: 'Nie zapisałeś swoich zmian w przekaźniku 1. Czy chcesz zapisać?',
      DS_DISCARED_CHANGES: 'Odrzuć zmiany',
      DS_CIRCUIT_TITLE: 'Oprawy awaryjne, które są włączane/wyłączane w tym oknie, powrócą do swojego skonfigurowanego stanu po zakończeniu kolejnej operacji przełączania systemu.',
      DS_EMPTY: 'Wolny / w awarii',
      LUM_TITLE: 'Kliknij opraw awaryjne, aby je włączyć lub wyłączyć',
      ALL_OFF: 'Wszystko wyłączone',
      DS_RESET_TITLE: 'Przywróć do ustawień domyślnych',
      DS_CONTROL_LUM: 'Sterowanie oprawami awaryjnymi',
      DS_LUM_BUTTON: 'Włącz/Wyłącz oprawy awaryjne',
      DS_APPLY: 'Zastosuj',
      DS_SET_IO_BUS_MODULES_TITLE: 'Ustaw moduły I-Bus',
      DS_NEXT_MODULE: 'Następny moduł',
      DS_MODULE_DETAILS: 'Szczegóły modułu',
      DS_MODULE_NAME: 'Nazwa modułu',
      DS_LOCAL_ONLY: 'Tylko lokalnie',
      DS_PUBLISH: 'Opublikuj',
      DS_SUBSCRIBE: 'Subskrybuj',
      DS_ACU_BUS_ID: 'ID magistrali ACU',
      DS_BUS_MODULE: 'Moduł magistrali',
      DS_INPUTS: 'Wejścia',
      DS_CONFIGURED_MODULE_TITLE: 'Obecnie dla tego modułu nie skonfigurowano żadnych wejść monitora napięcia',
      DS_CONFIGURE_INPUTS: 'Skonfiguruj wejścia',
      DS_BLOCK: 'Zablokuj',
      DS_RELEASE: 'Zwolnij',
      DS_BLOCK_GUIDLINE: 'To blokuje funkcję awaryjną i wyłącza obwody.',
      DS_RUN_TESTS: 'Uruchom testy',
      DS_LUMINARIE_CONTROLS: 'Sterowanie oprawami awaryjnymi',
      DS_LUMINARIE_CONTROLS_GUIDELINE: 'Funkcje te zastępują zaprogramowane funkcje oświetlenia aż do ich wyłączenia.',
      DS_ALL_LUMINARIES_ON: 'Wszystkie oprawy awaryjne włączone',
      DS_INACTIVE: 'Nieaktywne',
      DS_MAINTAINED_LUMINARIES_OFF: 'Oprawy awaryjnew funkcji sieciowej wyłączone',
      DS_NON_MAINTAINED_LUMINARIES_OFF: 'Oprawy awaryjne w gotowości załaczone',
      DS_RESET_SYSTEM_STATE: 'Zresetuj stan systemu',
      DS_MANUAL_RESET: 'Reset ręczny',
      DS_RESET_ISO_FAILURE: 'Zresetuj błąd ISO',
      DS_RECHARGE_DEEP_DISCHARGE_PROTECTION: 'Zresetuj ochronę przed głębokim rozładowaniem',
      DS_SIMULATE_MAINS_FAILURE: 'Zasymuluj zanik zasilania sieciowego',
      DS_SEARCH_ISO_FAILURE: 'Wyszukaj błędy ISO',
      DS_SET_I_BUS_MODULES: 'Ustaw moduły I-Bus',
      DS_COMMISSIONING: 'Uruchamianie',
      DS_DATE_AND_TIME: 'Data i czas',
      DS_RESET_SERVICE_CENTER: 'Zresetuj interwał serwisowy',
      DS_ALERT_LEVEL: 'Poziom alertu',
      DS_DRY_CONTACT: 'Styk bezpotencjałowy',
      DS_BUILDING_MANAGMENT_SYSTEM: 'System zarządzania budynkiem (BMS)',
      DS_MODBUS: 'Modbus',
      MANAGE_INTERNET_CONNECTION: 'Zarządzaj połączeniem internetowym',
      INTERNET_CONNECTION: 'Połączenie internetowe',
      SUB_LOCATION: 'Podlokalizacja',
      TIME_PERIOD_NINTY_DAYS: 'Co 90 dni',
      DS_SEARCH_ISO_FAILURE_TITLE: 'Wyszukaj błędy izolacji ISO?',
      DS_SEARCH_ISO_FAILURE_BODY: 'Naciśnij „Szukaj”, aby określić uszkodzone obwody, jeśli otrzymujesz komunikat o błędzie ISO.',
      DS_SEARCH: 'Szukaj',
      DS_MAIN_FAILURE_MSG: 'Przejście na DC, potrwa około 5 sekund, zanim nastąpi przełączenie z powrotem na zasilanie AC',
      DS_START: 'Start',
      DS_DEEP_DISCHARGE: 'Potwierdzenie ochrony przed głębokim rozładowaniem',
      DS_DEEP_DISCHARGE_MSG: 'Wybierając „Potwierdź”, resetujesz głębokie rozładowanie.',
      DS_ACKNOWLEDGE: 'Potwierdź',
      DS_RESET_ISO: 'Zresetować błąd izolacji?',
      DS_RESET_ISO_MSG: 'Jeśli błąd ISO powtarza się i po sprawdzeniu końcowych obwodów nie można zidentyfikować przyczyny, skontaktuj się z działem serwisowym.',
      DS_RESET: 'Zresetuj',
      DS_MANUAL_RESET_TITLE: 'Wykonać reset ręczny?',
      DS_MANUAL_RESET_MSG: 'Wszystkie oprawy awaryjne powrócą do normalnej pracy zgodnie z ich zaprogramowaniem',
      DS_BLOCK_TITLE: 'Zablokować system i zakończyć test czasu pracy akumulatorów?',
      DS_CONFIRM_BLOCK: 'Potwierdź i zablokuj',
      DS_BLOCK_TEXT: 'Akumulator będzie potrzebował co najmniej 24 godzin na ponowne naładowanie  się przed wykonaniem ponownego  testu podtrzymania oświetlenia awaryjnego.',
      TRIGGERS: 'Sterowania',
      DEFAULT_TRIGGERS

   : 'Domyślne sterowanie',
      OPTIONAL_TRIGGERS: 'Opcjonalne sterowania',
      ADD_TRIGGER: 'Dodaj sterowanie',
      SELECT_TRIGGERS: 'Wybierz sterowanie',
      ASSIGN_TRIGGERS: 'Przypisać sterowania',
      SELECTED: 'Wybrano',
      INSTALLED: 'Zainstalowano',
      SCENARIO: 'Scenariusz',
      LUMINARIES_COUNT: '10 na 10 opraw awaryjnych',
      DS_INPUT_OF_PHASE_MONITOR: 'Wejście monitora fazy',
      DS_CIRCUIT_TRIGGERS_SUCCESSFULLY_LINE: 'Sterowanie dla obwodu 1 zostały pomyślnie skonfigurowane.',
      DS_SET_OTHER_CIRCUIT_TRIGGERS: 'Ustaw inne sterowania obwodu',
      DS_ASSIGN_DEFAULT_TRIGGERS_GUIDELINE: 'Kliknij lub przeciągnij oprawy awaryjne, aby przypisać je do tego sterowania.',
      DS_ASSIGN_TRIGGERS_GUIDELINE_TWO: 'Proszę potwierdzić każdy sterowanie dla obwodu 1',
      DS_NON_MAINTAINED_LIGHT: 'oprawa awaryjna w trybie gotowości',
      DS_MAINTAINED_LIGHT: 'oprawa awaryjna w trybie ciągłym',
      DS_INSTALLED_LUMINARIES: 'Zainstalowane oprawy awaryjne',
      DS_TIMER_SCHEDULE: 'Tygodniowy harmonogram',
      DS_DEEP_DISCHARGE_TITLE: 'Głębokie rozładowanie',
      DS_STIMULATE_MAIN_FAILURE: 'Zasymuluj zaniku zasilania sieciowego',
      DS_START_FUNCTIONAL_TEST: 'Start funkcjonalnego testu opraw awaryjnych',
      DS_SHORT_LEAD_TIME: 'Użyj krótkiego czasu realizacji',
      DS_ASSIGNED_PHASE_MONITORING_INPUT: 'Przypisane wejścia monitorowania fazy',
      DS_INPUT_CONFIGURATION_TITLE: 'Konfiguracja wejściowa',
      DS_ASSIGNED_FUNCTION: 'Przypisana funkcja',
      DS_PHASE_MONITORING_INPUT: 'Wejścia monitorowania fazy L1/L2/L3',
      DS_RESET_OPTION: 'Opcja resetowania',
      DS_LENGTH_OF_TIME: 'Długość czasu (minuty)',
      DS_PHASE_MONITOR: ': Monitor fazy',
      MANNUAL_RESET: 'Reset ręczny',
      DURATION_TEST_COMPLETE: 'Test czasu podtrzymania wykonany',
      FUNCTIONAL_TEST_COMPLETE: 'Test funkcjonalny wykonany',
      MODBUS: {
        MANUAL_RESET: 'Reset ręczny',
        RESET_DEEP_DISCHRGE_PROTECTION: 'Zresetuj ochronę przed głębokim rozładowaniem',
},
      DS_FINISH: 'Zakończ',
      NORMAL_OPERATION: 'Normalna praca',
      CIRCUIT_FAILURE: 'Awaria obwodu',
      DEEP_DISCHARGE: 'Głębokie rozładowanie',
      DS_BATTERY: 'Bateria',
      DS_SERIAL_NUMBER: 'Numer Seryjny',
      DS_SET_INPUT_CONFIG: {
        ASSIGNED_FUNCTION: {
          MANNUAL_RESET: 'Reset ręczny',
},
        RESET_OPTION: {
          MANNUAL_RESET: 'Reset ręczny',
},
},
      BUZZER: {
        NORMAL_OPERATION: 'Normalna praca',
        CIRCUIT_FAILURE: 'Awaria obwodu',
        DEEP_DISCHARGE: 'Głębokie rozładowanie',
},
      DS_SYSTEM_MODULE_TYPE: 'Typ.',
      EMPTY: 'Pusty',
      DS_BLOCKED: 'Zablokowane',
      DS_NAME: 'Nazwa',
},
    LOGBOOK_DETAILS: {
      LABEL_EVENT_AGO: 'temu',
      PART_NUMBER: ' PN: ',
      SERIAL_NUMBER: 'SN:',
      ADD_COMMENTS: 'Dodaj Komentarze...',
      REQUIRES_FIRMWARE_UPDATE: '1 WYMAGANA AKTUALIZACJA OPROGRAMOWANIA',
      ACKNOWLEDGE: 'Potwierdź',
      ACKNOWLEDGED: 'Potwierdzone',
      ACKNOWLEDGED_BY: 'Potwierdzone przez',
      PREVIOUS_ACKNOWLEDGED_BY: 'Potwierdzone przez:',
      ACTIVE: 'Aktywny',
      ACTIVE_ACKNOWLEDGED: 'Aktywny. Potwierdzony',
      AT: 'o',
      LABEL_CLOSED: 'zamknięte',
      CLOSED: 'Zamknięte',
      COMMENTS: 'Komentarze',
      DESCRIPTION: 'Opis',
      DEVICE: 'Urządzenie',
      EDIT: 'Edytuj',
      EVENT: 'Zdarzenie',
      LABEL_EVENT_BEGAN : 'Zdarzenie Rozpoczęte:',
      LABEL_EVENT_CLOSE: 'Zdarzenie Zakończone:',
      LOGBOOKDETAIL: 'Szczegóły Dziennika',
      NO_PREVIOUS_LOG_TITLE: 'Brak wcześniejszych zarejestrowanych zdarzeń w tym systemie',
      PARTNO: ' PN:',
      PREVIOUS_LOG_ITEM: 'Poprzedni Element Dziennika w Tym Systemie',
      PREVIOUS_LOG_TITLE: 'Poprzedni Element Dziennika w Tym Systemie',
      SERIALNO: 'SN:',
      STATUS: 'Status',
      SYSTEM: 'System',
      TIMESTAMP: 'Znacznik Czasu.',
      SYSTEM_TYPE : 'Typ:',
},
    ORGANIZATION_MANAGE: {
      BUILDING_COUNT: 'Budynek',
      BUILDING_COUNT_S: 'Budynki',
      ORGANIZATION_MANAGE: 'Budynki',
      ADMIN_COUNT: 'Administrator organizacji',
      ADMIN_COUNT_S: 'Administratorzy organizacji',
      VIEWER_COUNT: 'Podgląd organizacji',
      VIEWER_COUNT_S: 'Podglądający organizację',
      SYSTEM_COUNT: 'System',
      SYSTEM_COUNT_S: 'Systemy',
      ADD_NEW_BUILDING: 'Dodaj Nowy Budynek',
      CREATE_ORGANIZATION: 'Utwórz Organizację',
      ERROR_ADD_NEW_SYSTEM_ACTION: 'Dodaj Nowe Systemy',
      ALL: 'Wszystkie',
      SORT_TYPE_NAME: 'Alfabet',
      SORT_TYPE_CITY: 'Miasto',
      COMMENTS_HELPER: 'Komentarze, aby pomóc technikom na miejscu.',
      ORGANIZATION_NAME_HELPER: 'Tylko litery, cyfry, podkreślenia i myślniki',
      MARK_AS_FAV_API_FAILURE_MESSAGE: 'Oznacz jako nieudane',
      ERROR_NO_BUILDING_FOUND: 'Nie znaleziono budynku',
      ERROR_NO_GATEWAY_FOUND: 'Nie Znaleziono Bramki',
      ERROR_NO_LOGS_TITLE: 'Brak dzienników w tym okresie',
      ERROR_NO_LUMINARY_FOUND: 'Nie Znaleziono Opraw Oświetleniowych',
      ERROR_NO_ORG_FOUND: 'Nie znaleziono organizacji',
      ERROR_NO_REPORT_FOUND: 'Nie znaleziono raportów',
      ERROR_NO_SYSTEM_FOUND: 'Nie Znaleziono Systemu',
      ERROR_NO_USER_FOUND: 'Nie znaleziono użytkownika',
      SORT_TYPE_NUMBER_OF_SYSTEMS: 'Liczba Systemów',
      QUIT_EDIT_USER_DETAILS: 'Zakończ Edycję',
      QUIT_TITLE: 'Zakończyć edycję „{{orgName}}”?',
      ERROR_READ_INSTALLATION_MANUALS_ACTION: 'Przeczytaj Podręczniki Instalacyjne',
      SEARCH: 'Szukaj',
      SEARCH_BUILDINGS: 'Szukaj',
      SEARCH_BUILDINGS_DASHBOARD: 'Szukaj budynków',
      SEARCH_SYSTEM_DASHBOARD: 'Szukaj systemów',
      SORT_BY_HEADER: 'SORTUJ WEDŁUG',
      STARRED_ORGANIZATIONS: 'Oznaczone Organizacje',
      VIEW_ORGANIZATION: 'Pokaż Organizację',
      ERROR_NO_DEVICE_TITLE: 'Nie masz jeszcze aktywów w tej organizacji.',
      ERROR_NO_DEVICE_DESCRIPTION: 'Otrzymasz informacje o statusie oświetlenia awaryjnego natychmiast po dodaniu systemów do tej organizacji.',
      QUIT_MESSAGE: 'Twoje niezapisane zmiany zostaną utracone.',
},
    ADD_BUILDING: {
      BLDG_ORG_CONTACT: 'Kontakty',
      INVERTED_COMMAS_S: '’s',
      BLDG_ORG_CONTACTS: '’s Kontakty',
      BLDG_ADDITIONAL_DESC: 'Dodaj opcjonalne dodatkowe komentarze, aby pomóc Twojemu zespołowi serwisowemu.',
      BLDG_ADD_DESCRIPTION: 'Dodatkowe Opisy',
      BLDG_ADDRESS: 'adres',
      BLDG_CREATTION: 'Budynek Utworzony',
      BUILD_CREATE_SUCESS: 'Budynek został utworzony pomyślnie',
      BLDG_HEADER: 'Utwórz Nowy Budynek dla',
      BLDG_LOCATION_MESSAGE: 'Przeciągnij mapę, aby umieścić znacznik w pobliżu lokalizacji budynku. Ułatwi to inżynierom dotarcie na miejsce w przyszłości.',
      BLDG_EDIT_BTN: 'Edytuj Szczegóły Kontaktu',
      BLDG_NAMELENGTH: 'Np. Główne Biuro, Magazyn',
      BLDG_INITILIZING_NETWORK: 'Inicjalizacja Sieci...',
      BLDG_INSIDE: 'Wewnątrz',
      BLDG_LOCAL_CONTACT: 'Lokalny Kontakt Budynku',
      BLDG_CONTACT_TITLE: 'Szczegóły Lokalnego Kontaktu Budynku',
      BLDG_LOCATE_ON_MAP: 'Znajdź na Mapie zamiast tego',
      BLDG_LOCATION: 'Lokalizacja',
      BLDG_ADDTIONAL_DETAILS: 'Teraz dodajmy dodatkowe szczegóły, aby zakończyć konfigurację dla',
      ORG_CREATE_SUCESS: 'Organizacja utworzona pomyślnie',
      BLDG_ADDITION_ERROR: 'Wprowadź prawidłowy adres.',
      BLDG_PRIMARYCONTACT: 'Główny Kontakt',
      BLDG_PRIMARY_LOCAL_CONTACT: 'Główny Lokalny Kontakt',
      BLDG_SECONDARYCONTACT: 'Drugorzędny Kontakt (Opcjonalnie)',
      BLDG_SECONDARY_LOCAL_CONTACT: 'Lokalny Kontakt Drugorzędny',
      BLDG_NO_POSTAL_ADDRESS: 'Wybierz tę opcję, jeśli adres pocztowy nie jest dostępny',
      BLDG_CREATED_MESSAGE: 'Pomyślnie Utworzono',
      BLDG_ORGANIZATION_FOR: 'Użyj organizacji',
      BLDG_ADD_CONTACT: 'Do kogo powinni się zgłosić elektrycy w sprawie „Main Office”?',
      SAVE_CHANGES_MSG: 'Twoje zmiany zostały zapisane.',
},
    USER_SETTINGS: {
       AUTOMATIC_LOGOUT_SUBTITLE: 'Wyłącz automatyczne wygasanie sesji po 15 minutach',
      ALARMS: '.',
      PHONE_NO_TEXT: 'Numer telefonu komórkowego jest wymagany do otrzymywania powiadomień SMS.',
      ACCOUNT: 'Konto',
      ACCOUNT_CREATED_DATE: 'Konto Utworzone',
      ADDRESS: 'Adres',
      ALARMS_TITLE: 'Alarmy',
      APPLICATION_THEME_COLOR: 'Kolor Tematu Aplikacji',
      AUTOMATIC_LOGOUT: 'Automatyczne Wylogowanie',
      UNITS_DESCRIPTION: 'Brytyjskie Jednostki Imperialne',
      BUILDING_NAME: 'Nazwa Budynku',
      TIMEZONE_DESCRIPTION: 'Czas Środkowoeuropejski (GMT-1:00)',
      CHANGE_PASSWORD: 'Zmień Hasło',
      COMPANY_ADDRESS: 'Adres Firmy',
      COMPANY_NAME: 'Nazwa Firmy',
      COMPANY_PHONE_NUMBER: 'Numer Telefonu Firmy',
      DATE_FORMAT: 'Format Daty',
      DATEFORMAT_DESCRIPTION: 'DD/MM/RRRR',
      DELETE_ACCOUNT: 'Usuń Konto',
      STATUS_UPDATES: 'Urządzenie jest w trybie blokady, trybie awaryjnym, konserwacja wymagana',
      AUTOMATIC_LOGOUT_TITLE: 'Wyłącz automatyczne wylogowanie',
      EMAIL: 'Adres E-mail',
      EMAIL_NOTIFICATION: 'Powiadomienia E-mail',
      TEXT_NOTIFICATION_TITLE: 'Włącz Powiadomienia Tekstowe (SMS)',
      ENABLED: 'Włączone',
      TEXT_NOTIFICATION_BODY: 'Włączenie powiadomień SMS może wiązać się z dodatkowymi opłatami za wiadomości tekstowe naliczanymi przez dostawcę usług komórkowych. Opłaty te nie są uwzględnione w Umowie Serwisowej Eaton.',
      LANGUAGE_DESCRIPTION: 'Angielski - Wielka Brytania',
      HEALTH_REPORT_TITLE: 'raport o stanie',
      LANGUAGE: 'Język',
      HEALTH_REPORT: 'Raportowanie Miesięczne',
      PRODUCT_UPDATES: 'Nowe wersje, dostępna aktualizacja oprogramowania układowego',
      NOTIFICATIONS_HEADER: 'Powiadomienia',
      APP_THEME_DESCRIPTION: 'Motyw Systemu Operacyjnego',
      ORGANIZATION: 'Organizacja',
      ORGANIZATION_NAME: 'Nazwa Organizacji',
      PASSWORD: 'Hasło',
      PHONE_NUMBER: 'Numer Telefonu',
      PREFERENCES_HEADER: 'Preferencje',
      PRODUCT_UPDATES_TITLE: 'Aktualizacje Produktu',
      STATUS_UPDATES_TITLE: 'Aktualizacje Statusu',
      TEXT_NOTIFICATION: 'Powiadomienia SMS',
      AUTOMATIC_LOGOUT_BODY: 'Ta funkcja zastępuje standardową funkcję zabezpieczeń aplikacji, która uniemożliwia dostęp do przerwanej sesji. Należy pamiętać, że użytkownik jest odpowiedzialny za ochronę tego systemu przed nieautoryzowanym dostępem i nigdy nie powinien pozostawiać tej aplikacji otwartej bez nadzoru.',
      TIME_ZONE: 'Strefa Czasowa.',
      UNITS: 'Jednostki.',
      ORG_ADDRESS: 'Użyj Adresu Organizacji',
      ORG_CONTACT_DETAILS: 'Użyj Danych Kontaktowych Organizacji',
      EDIT_USER_DETAILS: 'Szczegóły Użytkownika',
      NAME: 'Nazwa Użytkownika',
      USER_NAME: 'Nazwa Użytkownika',
      WARNING: 'OSTRZEŻENIE',
},
    EDITUSER: {
       PROMOTE_CONFIRMATION: 'Jeśli to było zamierzone, prosimy o zgłoszenie zmiany.',
      DEMOTE_CONFIRMATION: 'Jeśli to było zamierzone, wprowadź zmiany poniżej w sekcji Rola/Lokalizacja tego formularza.',
      DEMOTE: 'Zmieniłeś rolę administratora tej organizacji. Jeśli nie chciałeś tego zrobić, wybierz „Anuluj.”',
      PROMOTE: 'Awansowałeś tego użytkownika na Administratora Organizacji. Jeśli nie chciałeś tego zrobić, wybierz „Anuluj.”',
},
    ADDUSER: {
      INVITEUSER: 'Zaproś użytkownika',
      TITLE: 'Dodaj Użytkownika',
      ASTERIKSINFO: 'Pola oznaczone gwiazdką (*) są wymagane do zaproszenia użytkownika.',
      INVITESUCCESS: 'Zaproszenie zostało przyjęte!',
      SELECTROLE: 'Wybierz Rolę dla Lokalizacji',
      ACCOUNTCREATED: 'Zaproszenie do utworzenia konta zostało zrealizowane pomyślnie.',
      EMAILRECEIVE: 'Użytkownik otrzyma zaproszenie e-mail do utworzenia swojego konta w ciągu 5-10 minut. Nie będziesz mógł zobaczyć statusu, dopóki nie zostanie zaakceptowane twoje zaproszenie.',
      ADDUSERINFORMATION: 'Informacje o Profilu Konta Użytkownika',
},
    GATEWAY: {
      MANAGE_CELLULAR_CONNECTION: 'Zarządzaj połączeniem komórkowym',
      TRANSFER_SYSTEM: {
        TRANSFER_SYSTEM_SELECTION_PAGE_TITLE: 'Systemy bramki {{gatewayName}} ({{systemCount}})',
        TRANSFER_SYSTEM_USERCONFIRMATION_TITLE: 'Systemy bramki {{gatewayName}} zostaną przeniesione do następujących użytkowników:',
        ADD_ANOTHER_USER: 'Dodaj Kolejnego Użytkownika',
        ADMIN_RIGHT_REQUIRED: 'Prawa Administratora są wymagane, aby zaprosić użytkownika',
        REGISTER_USER_REQUIRED: 'Do transferu wymagany jest co najmniej jeden zarejestrowany użytkownik',
        EMAIL_ID_DUPLICATE: 'Identyfikator e-mail jest zduplikowany lub nieprawidłowy',
        ADMIN_RIGHT_REQUIRED_FOR_SYSTEM_TRANSFER: 'Prawa administratora wymagane do transferu jednostek użytkownika',
        DUPLICATE_ENTITY_ID: 'Identyfikator jest zduplikowany lub nieprawidłowy.',
        TRANSFER_SYSTEM_EXISTING_USER: 'Istniejący Użytkownicy',
        INVALID_ENTITY_TYPE: 'Nieprawidłowy typ jednostki. Proszę podać prawidłowy typ.',
        TRANSFER_SYSTEM_LOGED_IN_USER_MSG: 'Nieprawidłowy użytkownik. Dodaj innego użytkownika.',
        INVITE_AS_COLLEAGUE: 'Zaproś jako współpracownika',
        TRANSFER_SYSTEM_NEW_USER: 'Nowi Użytkownicy',
        TRANSFER_SYSTEM_ADD_EXISTING_USER: 'Dodaj co najmniej jednego istniejącego użytkownika, aby przenieść encje.',
        INVALID_EMAIL_ADDRESS: 'Podaj prawidłowy adres e-mail',
        INVALID_GATEWAY_ID: 'Podaj prawidłowy identyfikator bramki sieciowej',
        TRANSFER_SYSTEM_INFO: 'Wybierz istniejącego użytkownika lub dodaj nowego',
        TRANSFER_SYSTEM_SYSTEM_SELECTION_HEADER: 'Wybierz system(y), które chcesz przenieść',
        NO_DATA_FOUND: 'Nie znaleziono zażądanych danych',
        TRANSFER_SYSTEM_SYSTEM_TRANSFER: 'Transfer Systemu',
        TRANSFER_SYSTEM_CONFIRMATION_NEW_USER: 'Ten użytkownik nie będzie mógł monitorować systemów, dopóki nie zaakceptuje zaproszenia wysłanego na wskazany adres e-mail.',
        TRANSFER_SYSTEM_PRIVILEGES: 'Przenieś Uprawnienia Systemu.',
        TRANSFER_TO: 'Przenieś do.',
        TRANSFER_USER_ALREADY_ADDED: 'Użytkownik został już dodany.',
        TRANSFER_SYSTEM_ALREADY_ADDED_USER: 'Użytkownik już dodany do listy. Proszę dodać innego użytkownika.',
        TRANSFER_SYSTEM_USER_SELECTION_HEADER: 'Komu chcesz przekazać te systemy?',
        ADD_USERS: 'Dodaj użytkownika',
},
      ENTRY_PASSWORD_TITLE: 'Dostęp dla',
      ADD_GATEWAYS: 'Dodaj Urządzenie',
      ADDING_GATEWAY_TITLE: 'Dodawanie "{{gatewayName}}" do {{orgName}}',
      CONNECT_TO_ELSYSTEM_FAILED_UREACHABLE_MSG: 'Bramka próbuje połączyć się z systemem, co może zająć więcej czasu. Sprawdź status w zakładce System.',
      RESET_GATEWAY_PASSWORD_SUCCESS: 'Resetowanie hasła bramki zakończone powodzeniem.',
      BLE: {
        ERROR: {
          INVALID_IP_AADRESS: 'Nieprawidłowy adres IP',
          CHANGE_FAILURE_MESSAGE: 'Wystąpił błąd podczas zmiany parametrów',
          NOT_FETCHING_SYSTEM_DETAILS: 'Nie można pobrać szczegółów systemu',
          BUILDING_ALREADY_EXISTS: 'Nazwa budynku już istnieje',
          RESET_PASSWORD_FAILED: 'Żądanie zresetowania hasła nie powiodło się. Spróbuj ponownie',
          INVALID_CONNECTION_STRING: 'Nieprawidłowy ciąg połączenia',
          INVALID_UUID: 'Nieprawidłowy UUID',
          ORGANIZATION_ALREADY_EXISTS: 'Nazwa Organizacji już istnieje',
          REQUEST_FAILED_TITLE: 'Żądanie Nie Powiodło Się',
          REQUEST_FAILED_GATEWAY_ADD: 'Nie udało się dodać bramki.',
          REQUEST_FAILED_MESSAGE: 'Nie udało się dokończyć operacji. Poczekaj kilka minut i spróbuj ponownie.',
          UNAUTHORIZED_ACCESS: 'Nieautoryzowany dostęp. Proszę zalogować się ponownie.',
          INVALID_DEVICE: 'Nieprawidłowe urządzenie.',
          GATEWAY_UNRECHABLE: 'System jest niedostępny',
          MAX_LIMIT_SYSTEM_REACHED_TITLE: 'Osiągnięto maksymalną liczbę systemów',
          REQUEST_FAILED_WIRELESS_GATEWAY_ADD: 'Nie udało się dodać bramy bezprzewodowej.',
          REQUEST_FAILED_LP_SMART_ADD: 'Nie udało się dodać Dualsmart.',
          REQUEST_SUCCESS_BLE_DEVICE_ADD: 'Żądanie nie powiodło się, aby dodać urządzenie',
          DUPLICATE_SYSTEM_TITLE: 'Duplikat systemu',
},
        DEVICE_STATUS: {
          ALARM: 'Alarm',
          BLOCKED: 'Zablokowane',
          NOT_PROVISIONED: 'Nie Skonfigurowano',
          OFFLINE: 'Offline',
          ONLINE: 'Online',
          PROVISIONED: 'Skonfigurowane',
          READY: 'Gotowy',
          READY_FOR_COMMISSION: 'Gotowy do Uruchomienia',
          WARNING: 'Ostrzeżenie',
},
        DEVICE_TYPE: {
          ATPLUS_CONTROLLER: 'AT+ Kontroler',
          COMMON_GATEWAY: 'Wspólna Bramka sieciowa',
          DGS: 'DGS',
          LPSMART: 'LPSmart',
          WIRELESS_GATEWAY: 'Bramka Bezprzewodowa',
},
        SET_PASSWORD_STATUS: {
          INVALID_LENGTH: 'Nieprawidłowa długość',
          INVALID_PASSWORD: 'Nieprawidłowe hasło',
          PASSWORD_CHANGE_FAILURE: 'Niepowodzenie zmiany hasła',
          PASSWORD_CHANGE_SUCCESS: 'Sukces zmiany hasła',
          PASSWORD_COMPARISON_FAIL: 'Porównanie haseł nie powiodło się',
},
        DEFAULT_LOGIN_STATUS: {
          LOGIN_DEFAULT_SUCCESS: 'Logowanie zakończone sukcesem',
          LOGIN_FAILURE: 'Błąd logowania',
          LOGIN_MAX_ATTEMPTS_EXCEEDED: 'Przekroczono maksymalną ilość prób logowania',
          LOGIN_SUCCESS_ADMIN: 'Zalogowany jako "Administrator"',
          LOGIN_SUCCESS_SERVICE: 'Zalogowany jako "Serwis"',
          LOGIN_SUCCESS_USER: 'Zalogowany jako "Użytkownik"',
          LOGOUT: 'Wyloguj się',
},
        NULL_VALUE: 'Brak Odpowiedzi',
        TURN_ON_BLE_MSG: 'Włącz Bluetooth, aby umożliwić „Managerowi Bezpieczeństwa Budynku” dostęp do lokalnych systemów.',
        DISCONNECT_ALERT_SUBTITILE: '„Nie jesteś już połączony z Bluetooth „”{{gatewayName}}””. Upewnij się, że jesteś w zasięgu Bluetooth, aby kontynuować.,',
        SUCCESS: {
          REQUEST_SUCCESS_GATEWAY_ADD: 'Brama została pomyślnie dodana',
          REQUEST_SUCCESS_WIRELESS_GATEWAY_ADD: 'Brama bezprzewodowa została pomyślnie dodana',
          REQUEST_SUCCESS_LP_SMART_ADD: 'Dualsmart został pomyślnie dodany',
          REQUEST_SUCCESS_BLE_DEVICE_ADD: 'Urządzenie dodano pomyślnie',
},
        LOST_BLE_CONNECTION: 'Utracono Połączenie Bluetooth',
},
      INVALID_SYSTEM_NUMBER: 'Nieprawidłowy numer systemu',
      INVALID_USER_ACCESS_SYSTEM_UNLINK: 'Nieprawidłowy użytkownik. Nie masz dostępu do odłączenia systemu.',
      GATEWAY_DISCONNECT_ALERT: 'Czy na pewno chcesz się rozłączyć?',
      DISCARD_CHANGES_ALERT: 'Czy na pewno chcesz odrzucić zmiany?',
      UNLINKEXISTING_SYSTEM_ALERT: 'Czy na pewno chcesz odłączyć istniejący system?',
      GATEWAY_UNREGISTER_ALERT: 'Czy na pewno chcesz wyrejestrować bramkę?',
      AUTOMATICALLY_CONFIG_IP: 'Automatyczna konfiguracja adresu IP',
      BACKUP_CONNECTION: 'Połączenie Zapasowe',
      TIMELINE_VIEW: {
        BUILDING: 'Budynek',
        OPTINAL: 'Opcjonalne',
        ORGANIZATION: 'Organizacja',
        SELECT_BUILDING: 'Wybierz Budynek',
        SELECT_ORGANIZATION: 'Wybierz organizację',
        SUB_LOCATION: 'Podlokalizacja',
        SET_BACKUP_INTERNET_TITLE: 'Skonfiguruj kopię zapasową połączenia internetowego',
        SET_PRIMARY_INTERNET_TITLE: 'Ustaw główne połączenie internetowe',
        INTERNET_CONNECTION_LABLE: 'Proszę wybrać…',
        SET_INTERNET_CONNECTION_MSG: 'Najpierw połącz się z internetem',
        SUB_LOCATION_LABLE: 'Nazwa podlokalizacji…',
        DESCRIPTION_LABLE: 'Obszar notatek',
        SEARCH_ALL_LUMINAIRES_TITLE: 'Wyszukaj wszystkie oprawy awaryjne',
},
      BLUETOOTH_SCAN_ERROR: 'Nie możesz znaleźć swojej bramki? Sprawdź',
      CARRIER_NAME: 'Nazwa Operatora',
      CELLULAR: 'Komórkowy',
      CELLULAR_PROCESS_FAILED_MSG: 'Proces konfiguracji sieci komórkowej nie powiódł się. Spróbuj ponownie.',
      CELLULAR_PROCESS_SUCCESS_MSG: 'Sieć komórkowa skonfigurowana pomyślnie.',
      CELLULAR_CONNECTION: 'Połączenie komórkowe',
      NO_BLUETOOTH_SUPPORT: 'Bluetooth nie jest obsługiwany na tym urządzeniu',
      CHANGE_CONNECTION_METHOD: 'Zmień Metodę Połączenia',
      CHECK_FOR_UPDATES: 'Sprawdź Aktualizacje',
      CONFIGURE_WI_FI_CONNECTION: 'Konfiguruj Ustawienia Ethernet',
      CONFIGURE_CELLEULAR_CONNECTION: 'Skonfiguruj To Połączenie Komórkowe',
      COMMISSION_NEW_GATEWAY: 'Połącz z Urządzeniem Oświetlenia Awaryjnego Eaton.',
      CONNECT_TO_ELSYSTEM_FAILED_MSG: 'Nie udało się połączyć z systemem EL. Spróbuj ponownie.',
      CONNECTED: 'POŁĄCZONY',
      CONNECTED_TO: 'połączono z',
      CONNECTION_METHOD: 'Metoda Połączenia',
      GATEWAY_CONNECTION_PRIORITY: 'Priorytet Połączenia',
      CONNECTIONS: 'Połączenia',
      GATEWAY_ADD_BUILDING_VALUE: 'Utwórz nowy budynek',
      GATEWAY_ADD_ORGANIZATION_VALUE: 'Utwórz nową organizację',
      SET_DATE_TIME_SUCCESS: 'Data i czas zostały pomyślnie ustawione',
      DEFAULT_PASSWORD_ADMIN_CHANGED: 'DEFAULT_PASSWORD_ADMIN_CHANGED',
      DEFAULT_PASSWORD_USER_CHANGED: 'DEFAULT_PASSWORD_USER_CHANGED',
      DISCONNECTED: 'Urządzenie jest odłączone lub nie można nawiązać połączenia, spróbuj ponownie',
      DISCONNECTED_SUCCESS: 'Urządzenie zostało odłączone pomyślnie',
      GATEWAY_UNREGISTER_SUCCESS: 'Informacje o rejestracji urządzenia zostały pomyślnie usunięte',
      GATEWAY_UNREGISTER_FAILURE: 'Informacje o rejestracji urządzenia zostały pomyślnie usunięte',
      DGS_NOT_COMMUNICATING: 'DGS nie komunikuje się',
      DGS_UNREACHABLE: 'DGS Nieosiągalny',
      DHCP: 'DHCP',
      DISABLE_WIFI_RATIO_STATUS: 'Wyłączanie wifi dla Bramki',
      DNS: 'DNS',
      CONNECT_TO_ELSYSTEM_SUCCESS_MSG: 'System EL został pomyślnie połączony.',
      ENABLE_LOCATION_FOR_MAP: 'Włącz, aby znaleźć Twoją Obecną Lokalizację, włącz, aby załadować widok mapy',
      ENABLE_WIFI_RATIO_STATUS: 'Włączanie wifi dla Bramki',
      WIFI_CREDENTIALS_MESSAGE: 'Wprowadź poprawne hasło',
      ENTER_WIFI_CREDENTIALS: 'Wprowadź Dane Logowania do Wi-Fi',
      RESET_GATEWAY_PASSWORD: 'Czy na pewno chcesz zresetować hasło bramki?',
      INVALID_EPAS_SERIAL_NUMBER: 'Numer seryjny EPAS jest nieprawidłowy.',
      ETHERNET: 'Ethernet',
      ETHERNET_CONFIGURATION: 'Konfiguracja Ethernet',
      ETHERNET_PROCESS_FAILED_MSG: 'Proces konfiguracji sieciowej nie powiódł się. Spróbuj ponownie.',
      ETHERNET_CONNECTION: 'Połączenie Ethernet',
      FAIL_LINK_SYSTEM: 'Nie udało się połączyć systemu z bramką',
      FAIL_UNLINK_SYSTEM: 'Nie udało się odłączyć systemu od bramki',
      FAIL_UNREGISTER_GATEWAY: 'Nie udało się wyrejestrować bramki',
      FINISH: 'Zakończ',
      CHANGE_PASSWORD_INFO: 'Ze względów bezpieczeństwa zmień domyślne hasło.',
      GATEWAY_ACTIVATED: 'Bramka sieciowa Aktywowana',
      GATEWAY_ADDED: 'Bramka sieciowa Dodana',
      GATEWAY_COMMISSIONING: 'Uruchamianie Bramki sieciowej ',
      GATEWAY_CONNECTED: 'Bramka Połączona',
      GATEWAY_DETAILS: 'Szczegóły Bramki',
      GATEWAY_NAME: 'Nazwa Bramki sieciowej*',
      GATEWAY_PASSWORD: 'Hasło Bramki sieciowej',
      GATEWAY_PASSWORD_INCORRECT: 'Nieprawidłowe hasło bramki sieciowej',
      GATEWAY_NAME_DESCRIPTION: 'Nadaj tej bramce lepszą nazwę i opis',
      SUCCESSFULLY_ADDED: 'został pomyślnie dodany',
      INCOMPLETE_SETUP: 'Niekompletna Konfiguracja',
      INTERNET_SETTINGS: 'Ustawienia Internetu',
      INVALID_GUID: 'Nieprawidłowy identyfikator urządzenia, wprowadź prawidłowy GUID',
      FACTORY_RESET: 'Reset do Ustawień Fabrycznych',
      FACTORY_RESET_SUCCESS: 'Polecenie resetu fabrycznego zostało pomyślnie wykonane',
      FACTORY_RESET_FAILURE: 'Polecenie resetu fabrycznego nie powiodło się. Spróbuj ponownie.',
      GATEWAY_FACTORY_RESET_ALERT: 'Czy na pewno chcesz wykonać Reset Fabryczny dla Bramki?',
      LAST_CONNECTED: 'Ostatnio Połączony: 12:34:56 12 maja 2024',
      CELLULAR_CONNECTION_TYPE_LTE: 'LTE',
      CELLULAR_CONNECTION_TYPE_NON_LTE: 'NON-LTE',
      INVALID_LATITUDE: 'Nieprawidłowa szerokość geograficzna. Proszę podać prawidłową szerokość geograficzną.',
      INVALID_LONGITUDE: 'Nieprawidłowa długość geograficzna. Proszę podać prawidłową długość geograficzną.',
      INVALID_USER: 'Nieprawidłowy użytkownik',
      SUBLOCATION_NAME_LENGTH: 'Tylko litery, myślniki, cyfry',
      LINK_NEW_DEVICE: 'Połącz Nowe Urządzenie',
      LINK_NEW_SYSTEM: 'Połącz Nowy System',
      LINK_SYSTEM: 'POŁĄCZ SYSTEM',
      LINK_ANOTHER_SYSTEM: 'Połącz Inny System',
      LINK_MORE_SYSTEM: 'Połącz Więcej Systemów',
      LINK_SYSTEM_MSG: 'Połączenie Systemu z \'{{gatewayName}}\' w toku',
      LINK_SYSTEMS: 'Połącz Systemy',
      LOCATION: 'Lokalizacja',
      DENIED_LOCATION_PERMISSION: 'Odmowa uprawnień do lokalizacji, włącz je, aby wykonać skanowanie Bluetooth w poszukiwaniu pobliskich urządzeń',
      DENIED_LOCATION_PERMISSION_FOR_MAP: 'Odmowa uprawnień do lokalizacji, włącz je, aby załadować widok mapy',
      CONNECTION_TYPE_VALUE: 'LTE/WCDMA/GSM',
      MANAGE_ETHERNET_CONNECTION: 'Zarządzaj Połączeniem Ethernet',
      MANAGE_WIFI_CONNECTION: 'Zarządzaj Połączeniem Wifi',
      MANUALLY_CONFIG_IP: 'Ręczne Wprowadzanie Adresu IP',
      SET_NAME_DESCRIPTION_SUCCESS: 'Nazwa i Opis ustawione pomyślnie',
      NO_DEVICE_FOUND: 'Nie Znaleziono Urządzeń',
      UNLINK_SYSTEM_ERROR: 'Brak Bramki do Wyrejestrowania',
      NO_GATEWAY_NAME_FOUND: 'Nie Znaleziono Nazwy',
      NO_SYSTEM_YET: 'Brak Systemów',
      WIFI_NETWORK_NOT_AVAILABLE: 'Brak Dostępnych Sieci Wi-Fi',
      DHCP_OFF: 'Wyłączone',
      DHCP_ON: 'Włączone',
      NO_SYSTEM_YET_DESCRIPTION: 'Po połączeniu systemów z tą bramką zobaczysz tutaj listę wszystkich systemów.',
      ONLINE_TEXT: 'Online.',
      ORGANIZATION_TREE: 'Drzewo Organizacji',
      OTHER_NETWORK: 'Inna Sieć...',
      BLUETOOTH_INSTRUCTIONS: 'Nasze Instrukcje',
      CHOOSE_GATEWAY_CONNECTION_METHOD: 'Wybierz metodę połączenia Bramki',
      CONFIRM_SELECTION: 'Potwierdź Wybór',
      ENTER_ADMIN_CHANGE_PASSWORD: 'Wprowadź zmienione hasło administratora',
      ENTRY_GATEWAY_CHANGED_PASSORD: 'Proszę wprowadzić zmienione hasło do bramki sieciowej',
      ENTRY_GATEWAY_DEFAULT_PASSORD: 'Proszę wprowadzić domyślne hasło bramki sieciowej',
      ENTRY_PASSWORD: 'W przypadku pilnych problemów z kontem prosimy o kontakt pod numerem telefonu {{phone}}."',
      PLEASE_ENTER_NEW_PASSWORD_AGAIN_RECONNECT: 'Wprowadź ponownie nowe hasło, aby połączyć się z bramką sieciową.',
      MOVE_CAMERA_OVER_QR_CODE: 'Przesuń kamerę\n nad kod QR.',
      INVALID_BUILDING_ID: 'Podaj prawidłowy identyfikator budynku',
      INVALID_DEVICE_ID: 'Podaj prawidłowy identyfikator urządzenia',
      INVALID_DEVICE_NAME: 'Podaj prawidłową nazwę urządzenia',
      INVALID_DEVICE_STATUS: 'Podaj prawidłowy status urządzenia',
      INVALID_DEVICE_TYPE: 'Podaj prawidłowy typ urządzenia',
      INVALID_PROJECT_ID: 'Podaj prawidłowy identyfikator projektu',
      INVALID_SYSTEM_ID: 'Podaj prawidłowy identyfikator systemu',
      PLEASE_WAIT: 'Proszę czekać',
      PRIMARY_CONNECTION: 'Podstawowe Połączenie',
      GATEWAY_PRIORITY: 'Priorytet',
      PROXY: 'Proxy (opcjonalne)',
      PULL_REFRESH_TEXT: 'Przeciągnij w dół, aby odświeżyć',
      QUATERNARY_CONNECTION: 'Czwartorzędne Połączenie',
      REMOVE_CONNECTION: 'Usuń Połączenie',
      REMOVE_PRIMARY_CONNECTION: 'Usuń Główne Połączenie',
      REQUIRE_GATEWAY_CONNECTED_TO_INTERNET: 'Wymaga połączenia bramki z internetem',
      SAVE_TO_CLOUD: 'Zapisz do Chmury',
      SAVE_WI_FI_CREDENTIALS: 'Zapisz dane Wi-Fi dla dodatkowych urządzeń',
      SCAN_QR_CODE: 'Skanuj kod QR',
      QR_CODE_SCAN: 'Skanuj Kod QR',
      SCANNING_FOR_NEAR_BY_BLE: 'Skanowanie urządzeń BLE w pobliżu...',
      SCANNING_FOR_NEAR_BY_WIFI: 'Skanowanie Wi-Fi w pobliżu...',
      SEARCH_ALL_LUMINARIES: 'Szukaj Wszystkich Opraw Awaryjnych',
      SEARCH_VIA_BLUETOOTH: 'Szukaj za pomocą Bluetooth',
      SEARCHING_FOR_NEARBY_WIFI: 'Skanowanie Wi-Fi w pobliżu...',
      SEARCH_VIA_BLUETOOTH_EllIPSE: 'Skanowanie za pomocą Bluetooth...',
      SECONDARY_CONNECTION: 'Drugorzędne Połączenie',
      SELECT_PRIMARY_CONNECTION: 'Wybierz Główną Metodę Połączenia',
      SERIAL_NUMBER_NULL_OR_EMPTY: 'Proszę wprowadzić numer seryjny. Wartość nie może być równa 0. Pole nie może być puste.',
      SET_DATE_TIME_CONFIG: 'Nieprawidłowa konfiguracja Daty i Czasu',
      SET_DATE_TIME_FAILURE: 'Niepowodzenie konfiguracji Daty i Czasu',
      SET_NAME_DESCRIPTION_INCORRECT_CONFIG: 'Nieprawidłowa konfiguracja Nazwy i Opisu',
      SET_NAME_DESCRIPTION_FAILURE: 'Niepowodzenie konfiguracji Nazwy i Opisu',
      SET_EL_SYSTEM_PORT: 'Ustaw Port Systemu EL',
      SET_GATEWAY_PORT: 'Ustaw Port Bramki',
      STATIC: 'Statyczny',
      STATUS: 'Status',
      STEP_THREE_OF_THREE: 'Krok 3 z 3',
      SYNC_DATE_TIME: 'Synchronizuj Datę i Czas',
      SYSTEM_UNLINK_SUCCESS: 'System odłączony pomyślnie',
      SYSTEM_UNLINKED: 'System Odłączony',
      SYSTEMS: 'Systemy',
      UNLINK_SYSTEM_SUCCESS: 'Systemy wyrejestrowane pomyślnie.',
      TERTIARY_CONNECTION: 'Połączenie Trzeciorzędne',
      GATEWAY_NOT_EXISTS: 'Bramka sieciowa nie istnieje',
      ADDING_GATEWAY_SUBTITITLE: 'Proces może zająć około 2 minut.',
      UNLINK_ANOTHER_SYSTEM: 'Odłącz Inny System.',
      UNLINK_EXISTING_SYSTEM: 'Odłącz Istniejący System.',
      UNLINK_EXIST_SYSTEM: 'Wyrejestruj Bramkę.',
      USE_WI_FI_PASSWORD: 'Użyj Hasła Wi-Fi',
      USE_WPA2_KEY: 'Użyj Klucza WPA2',
      SCANNING_FAILED_TRY_AGAIN: 'Weryfikowanie urządzenia...',
      CARRIER_NAME_VALUE: 'Vodafone NL 3G',
      WI_FI: 'Wi-Fi',
      WIFI_PROCESS_FAILED_MSG: 'Proces konfiguracji Wi-Fi nie powiódł się. Spróbuj ponownie.',
      GATEWAY_WIFI_CONFIG: 'Konfiguracje Wi-Fi',
      WI_FI_NETWORK: 'Sieć Wi-Fi',
      WI_FI_NETWORK_NAME: 'Nazwa Sieci Wi-Fi',
      WI_FI_PASSWORD: 'Hasło Wi-Fi',
      GATEWY_INTERNET_SETTING_OPTIONAL_FIELD_MSG: 'Możesz pominąć którykolwiek z tych kroków, ale będą musiały zostać ukończone później, aby zakończyć konfigurację.',
      VERIFYING_DEVICE: 'Weryfikowanie urządzenia...',
      GATEWAY_OF: 'Bramka  sieciowa z',
      SYSTEM_LOCATION: 'Lokalizacja systemu',
      LOCATION_PERMISSION_TITLE: 'Zgoda na Lokalizację.',
      LOCATION_REQUIRED_MESSAGE: 'Ta aplikacja wymaga dostępu do Twojej lokalizacji.',
      PERMISSION_DENIED_TITLE: 'Zgoda na lokalizację została odrzucona.',
      PERMISSION_DENIED_MULTIPLE_MSG: 'Odmówiłeś zgody na lokalizację wielokrotnie. Aplikacja może nie działać poprawnie bez niej.',
      MAINTAINED_MODE: 'Tryb sieciowy',
      NON_MAINTAINED_MODE: 'Tryb awaryjny',
      UNREGISTER_GATEWAY: 'Zresetuj Geteway',
      CHOOSE_CONNECTION_TYPE: 'Jakiego typu połączenia chcesz użyć, aby połączyć się z DG-S?',
      REACHED_MAXIMUM_SUPPORTED_SYSTEM_ERROR_MSG: 'Nie można dodać więcej systemów. Osiągnięto limit maksymalnej liczby systemów obsługiwanych przez Gateway',
      DUALSMART_NAME: 'Nazwa Dualsmart *',
      WIRELESS_GATEWAY_NAME: 'Nazwa bramy bezprzewodowej *',
      DUPLICATE_SYSTEM_ERROR_MSG: 'System o tym adresie IP jest już połączony z bramą sieciową.',
      DIRECT_CONNECT_OPTION_SELECT_MSG: 'Upewnij się, że adres IP systemu jest ustawiony, a protokół DHCP jest wyłączony',
      DESCRIPTION: 'Opis',
},
    ERROR_MESSAGES: {
      GENERIC_ERROR_CONTACT_DETAILS: 'lub zadzwoń pod',
      GENERIC_ERROR: 'Wystąpił niesprecyzowany błąd. Jeśli problem będzie się powtarzał, prosimy o kontakt z Eaton Support.',
      9003: 'Żądana operacja nie może zostać wykonana, skontaktuj się z administratorem.',
      2002: 'Link rejestracyjny użytkownika wygasł lub został już wykorzystany.',
      2018: 'Nie możemy ukończyć Twojej rejestracji. Twoja organizacja przekroczyła liczbę użytkowników przypisanych do subskrypcji. Jeśli Twoja organizacja potrzebuje dodatkowych użytkowników, skontaktuj się z pomocą techniczną CST za pośrednictwem e-maila pod adresem',
},
    FORGOT_PASSWORD: {
      INSTRUCTIONS: 'Proszę podać adres e-mail powiązany z kontem. Jeśli e-mail jest powiązany z kontem w Systemie Zarządzania Bezpieczeństwem, otrzymasz odpowiedź w ciągu jednego dnia roboczego. W przypadku pilnych spraw zadzwoń.',
      ERROR: 'Nie można zresetować hasła w tej chwili.',
      RESET_CODE_ERROR: 'Wystąpił błąd z kodem resetu.',
},
    ACCOUNT_SETTING: {
      UPDATES_AVAILABLE: 'DOSTĘPNE AKTUALIZACJE',
      ACCOUNT_CREATED: 'Konto Utworzone',
      ACCOUNT_PREFERENCES: 'Preferencje Konta',
      ADDRESS_LINE2: 'Linia Adresu 2 (Opcjonalnie)',
      ALARAM: 'Alarmy',
      ALL_BUILDINGS: 'Wszystkie Budynki',
      ALL_SYSTEM_FIRMWARE: 'Wszystkie Firmware Systemowe',
      ALL_SYSTEMS: 'Wszystkie Systemy',
      APPLICATION_THEME_COLOR: 'Kolor Tematu Aplikacji',
      AUTOMATIC_LOG_OUT: 'Automatyczne Wylogowanie',
      AUTOMATIC_UPDATES: 'Automatyczne Aktualizacje',
      AUTOMATIC_UPDATES_INFO: 'Automatyczne pobieranie najnowszej wersji oprogramowania sprzętowego na Twoje urządzenie.',
      CHANGE_PASSWORD: 'Zmień Hasło',
      STORAGE_FIRMWAREFILE_INFO: 'Wybierz sposób przechowywania plików oprogramowania sprzętowego na swoim urządzeniu',
      CITY: 'Miasto',
      COMPANY_ADDRESS: 'Adres Firmy',
      COMP_ADDRESS: 'Adres Firmy*',
      COMPANY_DETAILS: 'Szczegóły Firmy',
      COMPANY_NAME: 'Nazwa Firmy',
      COMP_NAME: 'Nazwa Firmy',
      COMPANY_PHONE_NUMBER: 'Numer Telefonu Firmy',
      CODE: 'Kod',
      DATE_FORMAT: 'Format Daty',
      DELETE_ACCOUNT: 'Usuń Konto',
      DELETE_CUSTOMER: 'Usuń Klienta',
      DEVICE_BLOCKING: 'Urządzenie jest w trybie blokady, trybie awaryjnym, konserwacja wymagana',
      EDIT_CUSTOMER_INFO: 'Edytuj Informacje o Kliencie',
      EMAIL: 'E-mail',
      EMAIL_ADDRESS: 'Adres E-mail',
      REQUIRED_FIELD: 'Pola oznaczone gwiazdką (*) są wymagane do kontynuacji.',
      FIRMWARE_FILE: 'Pliki oprogrmowania sprzętowego',
      FIRMWARE_UPDATES: 'Aktualizacja oprogramowania',
      FIRST_NAME: 'Imię',
      FT_DT_FAIL: 'FT niepowodzenie, DT niepowodzenie, rozłączono, awaria baterii, awaria oprawy, awaria ATSD',
      HEALTH_REPORT: 'raport o stanie',
      LANGUAGE: 'Język',
      LAST_NAME: 'Nazwisko',
      MONTHLY_REPORTING: 'Raportowanie Miesięczne',
      NEW_RELEASE_FIRMWARE_UPDATE: 'Nowe wersje, dostępna aktualizacja oprogramowania ',
      NOTIFICATIONS: 'Powiadomienia',
      ORGAN_UPDATED_SUCCESSFULLY: 'Organizacja zaktualizowana pomyślnie',
      PASSWORD: 'Hasło',
      PERSONAL_DETAILS: 'Dane Osobiste',
      PHONE_NUMBER: 'Numer Telefonu',
      VALID_FIRSTNAME_ERROR: 'Wprowadź imię',
      POSTAL_CODE: 'Kod Pocztowy',
      PREFERENCES: 'Preferencje',
      PRIMARY_CONTACT: 'Główny Kontakt',
      PRIMARY_CONTACT_EMAIL_ADDRESS: 'Adres E-mail Głównego Kontaktu',
      PRIMARY_CONTACT_PHONE_NUMBER: 'Numer Telefonu Głównego Kontaktu',
      PRIMARY_EMAIL_ADDRESS: 'Główny Adres E-mail',
      PRIMARY_PHONE_NUMBER: 'Numer Telefonu Głównego Kontaktu',
      PRODUCT_UPDATE: 'Aktualizacje Produktu',
      SAVE_CHANGES: 'Zapisz Zmiany',
      SECONDARY_CONTACT: 'Drugorzędny Kontakt',
      SECONDARY_CONTACT_EMAIL_ADDRESS: 'Adres E-mail Kontaktu Drugorzędnego',
      SECONDARY_CONTACT_PHONE_NUMBER: 'Numer Telefonu Kontaktu Drugorzędnego',
      SECONDARY_EMAIL_ADDRESS: 'Drugorzędny Adres E-mail',
      SECONDARY_PHONE_NUMBER: 'Numer Telefonu Drugorzędnego',
      SLA_DETAILS: 'Szczegóły SLA',
      STATUS_UPDATE: 'Aktualizacje Statusu',
      STORAGE: 'Pamięć',
      TIME_ZONE: 'Strefa czasowa.',
      UNITS: 'Jednostki.',
      USER_NAME: 'Nazwa Użytkownika',
      USER_UPDATED_SUCCESSFULLY: 'Użytkownik zaktualizowany pomyślnie.',
      VERSION: 'Wersja',
      EST: 'EST',
      DD_MM_YYYY: 'DD',
      OFFLINE_MODE_ENABLED: 'Włączone',
      OPERATING_SYSTEM_THEME: 'Motyw Systemu Operacyjnego',
},
    CHANGE_PASSWORD: {
      EMAIL_CONFIRM_MESSAGE: 'Wysłaliśmy e-mail z potwierdzeniem na adres {{email}}',
      PROBLEM_OCCURRED: 'Wystąpił problem:',
      PASSWORD: 'Zmień Hasło',
      OLD_PASSWORD: 'Stare hasło',
      PASSWORD_CHANGED: 'Hasło zostało zmienione',
      PASSWORD_INFO: 'Hasło musi mieć co najmniej 8 znaków, zawierać co najmniej jedną wielką literę, jedną małą literę, jedną cyfrę i jeden znak specjalny.',
      ERROR_MESSAGR: 'Twoje informacje nie pasują do naszych zapisów. Wprowadź swoje dane ponownie, aby spróbować ponownie.',
      SUCCESS_MESSAGE: 'Twoje hasło zostało pomyślnie zaktualizowane! Aby zapewnić bezpieczeństwo konta, zaloguj się do aplikacji, używając zaktualizowanych danych logowania.',
},
    SYSTEM_DETAIL: {
      GUIDE: '(Przewodnik)',
      USERS_DATA: '5 administratorów, 1 przeglądający',
      ACTIVATE_CONNECTIONS: 'Aktywuj połączenia w chmurze',
      ADD_ANOTHER_CELLULAR: 'Dodaj Zapasowe Połączenie Komórkowe',
      ADD_SLA: 'Dodaj SLA',
       SYSTEM_DETAILS_TITLE: 'Szczegóły Systemu',
      ALL_CONTACTS: 'Wszystkie Kontakty',
      ALL_PEOPLE_IN_THIS_BUILDING: 'Wszyscy Ludzie w tym budynku',
      ALL_SYSTEMS_IN_THIS_BUILDING: 'Wszystkie Systemy w tym Budynku',
      BOTH_PORTS_CANNOT_BE_ON_SAME_SUBNET: 'Oba porty nie mogą znajdować się w tej samej podsieci',
      BUILDING: 'Budynek',
      BUILDING_INFO: 'Informacje o Budynku',
      BUILDING_TYPE: 'Typ Budynku',
      BUYER: 'Kupujący',
      CONNECTION_TYPE: 'Typ Połączenia',
      CONTACT_PERSON_Onsite: 'Osoba Kontaktowa na Miejscu',
      CONTACT_TYPE: 'Typ Kontaktowy',
      CUSTOMER_DETAILS: 'Szczegóły Klienta',
      CUSTOMER_INFO: 'Informacje o Kliencie',
      CUSTOMER_NUMBER: 'Numer Klienta',
      DATE_COMMISSIONED: 'Data Wdrożenia',
      DISABLE: 'Wyłącz',
      DURATION_TEST: 'Czas trwania testu akumulatorów',
      DURATION_TEST_FAILED: 'Czas trwania testu akumulatorów niezaliczony',
      DURATION_TEST_PASSED: 'Czas trwania testu akumulatorów zaliczony',
      ENABLED: 'Włączone',
      ENTER_VALID_GATEWAY_ADDRESS: 'Wprowadź poprawny adres bramki',
      ENTER_VALID_IP_ADDRESS: 'Wprowadź poprawny adres IP',
      ENTER_VALID_SUBNET_MASK: 'Wprowadź poprawną maskę podsieci',
      ETHERNET_PORT_ONE: 'Port Ethernet A',
      ETHERNET_PORT_TWO: 'Port Ethernet B',
      EXPIRY_DATE: 'Data Wygaśnięcia',
      FIRMWARE_VERSION: 'Wersja oprogramowania sprzętowego',
      FOR_BUILDINGS: 'Dla Budynków',
      FOR_SYSTEMS: 'Dla Systemów',
      FUNCTIONAL_TEST: 'Test funkcjonalny opraw awaryjnych',
      FUNCTIONAL_TEST_FAILED: 'Test funkcjonalny nie powiódł się',
      FUNCTIONAL_TEST_PASSED: 'Test funkcjonalny zaliczony',
      GATEWAY: 'Bramka sieciowa',
      GATEWAY_ADDRESS: 'Adres Bramki sieciowej ',
      GATEWAY_ADDRESS_REQUIRED: 'Adres Bramki sieciowej*',
      GATEWAY_NAME: 'Nazwa Bramki sieciowe',
      SYSTEM_UNLINKED_GATEWAY: 'został odłączony od',
      SYSTEM_LINKED_GATEWAY: 'został połączony do',
      HOST_NAME: 'Nazwa Host',
      INTIALIZE_CONNECTION: 'Inicjalizacja połączenia',
      INTIALIZE_NETWORK: 'Inicjalizacja Sieci...',
      IP_ADDRESS: 'Adres IP',
      IP_ADDRESS_REQUIRED: 'Adres IP*',
      IP_GATEWAY_NOT_IN_SAME_SUBNET: 'Adres IP i bramka nie znajdują się w tej samej masce podsieci',
      ETHERNET_CONNECTED: 'jest teraz połączony z\ninternetem',
      SYSTEM_LINKING_TITLE: 'Czy to jest system, do którego się podłączasz?',
      SYSTEM_UNLINKING_TITLE: 'Czy to jest system, który chesz rozłączyć?',
      SYSTEM_LINK_TITLE: 'Połącz System z',
      LUMINAIRES: 'Oprawy awaryjne',
      LUMINARIES_LIST: 'Lista opraw awaryjnych',
      MAC_ADDRESS: 'Mac Address',
      MAIN_CONTACT: 'Główny Kontakt',
      NETWORK_INFORMATION: 'Informacje o Sieci',
      NO_SYSTEM_FOUND: 'Brak Dostępnych Systemów',
      OFFICE: 'Biuro',
      ORGANIZATION: 'Organizacja',
      OTHER_STEPS: 'Inne kroki, jeśli to konieczne',
      OTHER_SYSTEMS: 'Inne Systemy',
      PART_NUMBER: 'Numer Części',
      SETPORT_SYSTEM_DETAILS_DESCRIPTION: 'Konfiguracji Ethernet, uzpełnij szczegóły',
      SYSTEM_DETAILS_DESCRIPTION: 'Znajdź te szczegóły na ekranie HMI  w szafie systemu.',
      PORT_NUMBER: 'Numer Portu',
      PREV: 'Poprzednie',
      PROJECT_LEAD: 'Lider Projektu',
      REGISTER_ACTIVATE_GATEWAY: 'Zarejestruj i aktywuj bramkę',
      SERIALNO_VALUE: 'Uruchom Test Czasu Trwania',
      SERIAL_NUMBER: 'Numer Seryjny',
      SETPORT_SYSTEM_LINK_TITLE: 'Ustaw Port do Połączenia Systemu z',
      SLA_NUMBER_TITLE: 'SLA#',
      SLAVE_NUMBER: 'Numer Podrzędny',
      SUBNET_MASK: 'Maska Podsieci',
      SUBNET_MASK_REQUIRED: 'Maska Podsieci',
      SYN_DATE_TIME: 'Synchronizuj Datę i Czas',
      SYSTEM: 'System',
      SYSTEM_NAME: 'Nazwa Systemu',
      SYSTEM_TYPE: 'Typ Systemu',
      TECHNICAL_PERSON: 'Osoba Techniczna',
      STATUS_DESCRIPTION: 'To jest długi opis. Może opisywać lokalizację urządzenia i osobę, z którą należy się skontaktować.',
      TOTAL_SLA: 'Łączna liczba SLA.',
      TRANSFER_ORGANIZATION: 'Przenieś tę organizację i jej aktywa do innego użytkownika (opcjonalnie).',
      SYSTEM_UNLINK_TITLE: 'Odłącz System z.',
      UPDATE_REQUIRED: 'wymagana aktualizacja.',
      UPLOAD_DETAILS: 'Prześlij szczegóły za pomocą Bluetooth',
      FIRMWARE_VERSION_VALUE: 'v12.34-56',
      VERSION_AVAILABLE: 'v123.457 Dostępne',
      VIEW_ALL: 'Pokaż Wszystko',
      VIEW_ALL_LUMINARIES: 'Pokaż Wszystkie Oprawy',
      PARTNO_VALUE: 'xx xx xx xx',
      ETHERNET_SUBTITLE: 'Teraz możesz uzyskać dostęp do swojej bramki przez Internet. Opis można dostosować.',
      NO_CUSTOMER_TEXT: 'Ten system nie jest powiązany z klientem',
      CONFIG_LUMNS_DECS: 'Mozesz wklejac dane z Excela bezposrednio do tej tabeli.',
      LINK_TO_CUSTOMER_BUTTON: 'Połącz z Klientem',
},
    USER_INVITATION_MANAGEMENT: {
      YOU: '(Ty)',
      INVITATION_MESSAGE_UPDATE_COUNT: '{{updatedInvitationCount}} zaproszenia zostały{{inviteStatus}} zatwierdzone pomyślnie, {{rejectedInvitationCount}}zaproszenia zostały odrzucone {{inviteStatus}}.',
      SUCCESS_COUNT: '{{updatedInvitationCount}} zaproszenia zostały x{{inviteStatus}} zatwierdzone pomyślnie.',
      INVITE_ACCEPT: 'Akceptuj',
      INVITE_ACCEPT_INVITATION: 'Zaakceptuj zaproszenie',
      INVITE_ACCEPTED: 'zaakceptowano',
      INVITE_ACCEPTED_BUTTON: 'Zaakceptowano',
      INVITE_ACCEPT_INVITATION_DESCRIPTION_1: 'Zaakceptowanie tego zaproszenia doda następujący element do Twojego profilu:',
      ADMIN_APPROVE: 'Zatwierdź żądanie',
      COMPANY: 'Firma',
      DECLINE_INVITATION: 'Odrzuć Zaproszenie',
      TABLE_HEADER_DENIED_TITLE: 'Odrzucone przeze mnie ({{count}})',
      INVITE_DENIED: 'odmówiono',
      INVITE_DENY: 'Odmów',
      ADMIN_DECLINE_INVITATION: 'Odrzuć Żądanie',
      TABLE_HEADER_EXPIRED_AT: 'Wygaszenie',
      TABLE_HEADER_EXPIRED_TITLE: 'Wygasłe Zaproszenia ({{count}})',
      INVITE_HISTORY: 'Historia Zaproszeń',
      INVITATION_SUCCESS_MESSAGE: 'Zaproszenie zakończone pomyślnie {{inviteStatus}}.',
      JOIN: 'Dołącz',
      JOINALL: 'Dołącz Wszystkie',
      LEAVE_ORGANIZATION: 'Opuść Organizację',
      TABLE_HEADER_NAME: 'Nazwa',
      INVITE_PENDING: 'Oczekujące',
      INVITE_REQUEST_ACCESS_DESCRIPTION_2: 'Poproś administratora o dostęp, aby dodać ten element do swojego profilu',
      TABLE_HEADER_INVITE_DATE: 'Otrzymano',
      REMOVE_USER: 'Usuń Użytkownika',
      INVITE_REQUEST: 'Żądanie',
      INVITE_REQUEST_ACCESS: 'Zażądaj Dostępu',
      REQUESTEDBY: 'Zażądane przez',
      INSTRUCTIONS: 'Wybierz, aby dodać elementy do swojego profilu lub odrzucić zaproszenie do ich dodania.',
      ADMIN_INSTRUCTIONS: 'Wybierz, aby zaakceptować lub odrzucić ich prośbę o dostęp:',
      SENTBY: 'Wysłane przez',
      TABLE_HEADER_INVITE_BY: 'Wysłane przez',
      TABLE_HEADER_TOTAL_ACCEPTED_NO_DATA_FOUND: 'Obecnie brak zaakceptowanych zaproszeń.',
      TABLE_HEADER_DENIED_NO_DATA_FOUND: 'Obecnie brak odrzuconych zaproszeń.',
      TABLE_HEADER_EXPIRED_NO_DATA_FOUND: 'Obecnie brak wygasłych zaproszeń.',
      INVITATION_TEXT: 'Będą potrzebować zaproszenia, aby ponownie dołączyć.',
      INVITE_REQUEST_ACCESS_DESCRIPTION_1: 'To zaproszenie wygasło i nie może być już dodane do twojego profilu.',
      TABLE_HEADER_TOTAL_COUNT: 'Łączna liczba zaakceptowanych zaproszeń ({{count}}).',
      TABLE_HEADER_TOTAL_ACCEPTED_COUNT: 'Łączna liczba zaakceptowanych zaproszeń ({{count}}).',
      SUCCESS_MESSAGE: 'Powodzenie zaproszenia użytkownika {{count}}',
      ERROR_MESSAGE: 'Żądanie użytkownika dotyczące aktualizacji zaproszenia nie powiodło się.',
      VIEW_ALL_ACCESS_RIGHTS: 'Pokaż Wszystkie Prawa Dostępu',
      TITLE: 'Witamy, {{username}}.',
      SUBTITLE: 'Zostałeś zaproszony do następujących projektów:',
      ADMIN_SUBTITLE: 'Masz żądania dostępu do wygasłych zaproszeń:',
},
    INACTIVITY: {
      LOGOUT: 'Zostaniesz wylogowany.',
      INACTIVE_LOGOUT: 'Wylogowano z powodu bezczynności',
      TITLE: 'Limit Czasu Sesji',
      WARNING : 'To okno było nieaktywne przez 15 minut. Jeżeli nie zostaną podjęte żadne działania',
},
    ATPLUS: {
      ATPLUS_FAILURE_COUNT: '{{count}} Awaria',
      ATPLUS_DATETIME_TWENTYFOUR_HOUR: 'Czas 24-godzinny',
      ATPLUS_TWO_MINUTE_AGO: '2 minuty temu',
      ATPLUS_ACTIVATION: 'Aktywacja',
      ADMIN: 'Administrator',
      ADMINVIEWER: 'Admin i Przeglądający',
      ATPLUS_ADMIN_ACCESS: 'Dostęp Administratora',
      ATPLUS_ALERT_LEVEL: 'Poziom Alertu',
      ATPLUS_ALERTSETTING_HEADER: 'Ustawienia Poziomu Alertu',
      ATPLUS_SEARCHLUMINAIRE_WARNING: 'Wszystkie oprawy oświetleniowe zostaną przypisane do nowego adresu i utworzą nową konfigurację.',
      ATPLUS_LOGIN_FAILURE: 'Wystąpił błąd podczas zmiany parametrów',
      ATPLUS_DATETIME_AUTO_DATE_TIME_HEADER: 'Automatyczna Data i Czas',
      ATPLUS_AUTOMATIC_RESET: 'Automatyczny Tryb gotowości',
      ATPLUS_AUTOMATIC_REST_MODE_MSG: 'Automatyczny tryb gotowości przełączy oprawy oświetleniowe w tryb gotowości, jeśli główne zasilanie lokalne zostanie wyłączone.',
      ATPLUS_BATTERYFAILURE: 'Awaria Baterii',
      ATPLUS_CHANGE_ADMIN_PASSWORD: 'Zmień Hasło Administratora',
      ATPLUS_CHANGE_PASSWORD_FAILURE: 'Zmiana hasła nie powiodła się',
      ATPLUS_CHANGE_PASSWORD_SUCCESS: 'Zmiana hasła zakończona sukcesem',
      ATPLUS_CHANGE_SERVICE_PARTNER_PASSWORD: 'Zmień Hasło Partnera Serwisowego',
      ATPLUS_CHANGE_PASSWORD: 'Zmień Hasło Systemu',
      SYSTEMPASSWORD: 'Zmień Hasła Systemu',
      ATPLUS_CHANGE_VIEWER_PASSWORD: 'Zmień Hasło Podglądającego',
      ATPLUS_SYNC_TEST_SCHEDULE_INFO: 'Kliknij „Zsynchronizuj Harmonogram Testów”, aby ustawić Testy Funkcyjne Opraw na dokładnie 7 dni od teraz i Testy Czasu Podtrzymania Baterii na 10 tygodni od teraz.',
      ATPLUS_INFO_TAG_CLOSED: 'ZAMKNIĘTE',
      ATPLUS_COMISSIONING: 'Rozruch',
      ATPLUS_COMMANDS: 'Polecenia',
      ATPLUS_COMMSFAILURE: 'Awaria Komunikacji',
      ATPLUS_CONFIGRATION_CREATED: 'Konfiguracja Utworzona.',
      ATPLUS_CONFIGRATION_DETAIL: 'Szczegóły Konfiguracji.',
      ATPLUS_CONFIGRATION_NAME: 'Nazwa Konfiguracji.',
      ATPLUS_CREATE_CONFIGRATION: 'Utwórz Konfigurację.',
      ATPLUS_DATETIME_CURRENT_TIME: 'Aktualna Data i Czas',
      ATPLUS_DEVICE_DATETIME_CURRENT_TIME: 'Aktualna Data i Czas Urządzenia Mobilnego',
      ATPLUS_CURRENT_TEST_SCHEDULE: 'Aktualny Harmonogram Testów',
      ATPLUS_REFRESH_LUMINAIRES: 'Aktualnie pobierane są najnowsze statusy dla wszystkich opraw oświetleniowych w budynku {{atplus}}.',
      ATPLUS_DATETIME: 'Data i Czas',
      ATPLUS_DRYCONTACT_DEFAULT_SETTINGS: 'Domyślne Ustawienia',
      ATPLUS_DETAILS: 'Szczegóły',
      ATPLUS_DRY_CONTACT: 'Bezpotencjałowy styk',
      ATPLUS_DRYCONTACT_INPUT: 'Wejście bezpotencjałowego styku',
      ATPLUS_ALERTSETTING_DRY_CONTACT_INPUT: 'Wejście bezpotencjałowego styku aktywowane',
      ATPLUS_DRYCONTACT_OUTPUT: 'Wyjście bezpotencjałowego styku',
      ATPLUS_ALERTSETTING_DRY_CONTACT_OUTPUT: 'Wyjście bezpotencjałowego styku aktywowane',
      ATPLUS_DRYCONTACT_HEADER: 'Ustawienia styku bezpotencjałowego',
      ATPLUS_DRYCONTACT_STATUS: 'Status styku bezpotencjałowego',
      ATPLUS_DURATION_TEST_TITLE: 'Czas trwania testu akumulatorów\n Test',
      ATPLUS_DTSUCCESS: 'Test czasu podtrzymania wykonany',
      ATPLUS_DTFAILEDTITLE: 'Błąd testu czasu podtrzymania',
      ATPLUS_DTINPROGRESS: 'Test czasu podtrzymania w trakcie',
      SERVICE: 'Serwis Eaton',
      ATPLUS_ELSYSTEM_SYSTEM_TIME: 'Czas Lokalny Systemu EL',
      ATPLUS_EMC_HEADER: 'Test EMC',
      ATPLUS_EMERGENCY: 'Awaryjne',
      ATPLUS_FW_UPDATE_EROOR: 'Błąd podczas aktualizacji oprogramowania. Spróbuj ponownie.',
      ATPLUS_EXPORT_CONFIG: 'Eksportuj Konfigurację',
      ATPLUS_EXPORT_CONFIGRATION_FAIL: 'Eksportowanie konfiguracji nie powiodło się.',
      ATPLUS_FAILED_LUMINAIRE: 'Oprawy Oświetleniowe z Błędem',
      ATPLUS_DRYCONTACT_FAILURE_THRESHOLD: 'Przekroczono Próg Awarii',
      ATPLUS_FAILURETYPE: 'Typy Awarii',
      ATPLUS_FILE_ALREADY_EXIST_TITLE: 'Plik już istnieje.',
      ATPLUS_FILE_ALREADY_EXIST_MSG: 'Plik o tej samej nazwie już istnieje. Zmień nazwę pliku.',
      ATPLUS_FIRMWARE_FILE_FOR: 'Oprogramowanie sprzętowe dla wersji',
      ATPLUS_FIRMWARE_UPDATE: 'Aktualizacja oprogramowania sprzętowego',
      ATPLUS_FW_UPDATE_COMPLETE: 'Aktualizacja oprogramowania sprzętowego kompletna',
      ATPLUS_FW_UPDATE_INPROGRESS: 'Trwa aktualizacja oprogramowania sprzętowego',
      ATPLUS_FUNCTIONAL_TEST_TITLE: 'Test Funkcjonalny\n Test',
      ATPLUS_FTSUCCESS: 'Test funkcjonalny wykonany',
      ATPLUS_FTINPROGRESS: 'Test funkcjonalny w toku...',
      CHANGEPASSWORDFOR: 'Muszę zmienić hasło dla',
      ATPLUS_IMPORT_CONFIG: 'Importuj Konfigurację',
      ATPLUS_INEMERGENCYMODE: 'W Trybie Awaryjnym',
      ATPLUS_INFAILURE: 'W Awarii',
      ATPLUS_INRESTMODE: 'W Trybie Odpoczynku',
      ATPLUS_INTESTMODE: 'W Trybie Testowym',
      ATPLUS_REFRESH_INCOMPLETE: 'Niekompletne Dane',
      ATPLUS_CHANGE_PASSWORD_INCORRECT_PASSWORD: 'Niepoprawne Bieżące Hasło',
      ATPLUS_DRYCONTACT_STATUS_INPUT: 'Wejście',
      ATPLUS_EXPORT_CONFIGRATION_INVALID_NAME: 'Nieprawidłowa nazwa konfiguracji.',
      GWCDATPLUSHEADER: 'Czy jest to urządzenie EL, które konfigurujesz?',
      ATPLUS_LAMPFAILURE: 'Awaria Oprawy',
      ATPLUS_CONFIGRATION_FILE_TITLE_INFO: 'Tylko litery, cyfry, podkreślenia i myślniki.',
      ATPLUS_ALERTSETTING_LOCAL_MAIN_FAILURE: 'Awaria Głównego Zasilania Lokalnego',
      ATPLUS_LOAST_CONNECTION: 'Utracono Połączenie - Spróbuj Ponownie',
      ATPLUS_ALERTSETTING_LUMINAIRE_ALERTS: 'Alerty Oprawy Awaryjnej',
      ATPLUS_DTFAILEDDESCRIPTION: 'Awaria oprawy awaryjnej',
      ATPLUS_LUMINAIRE: 'Oprawy awaryjne',
      ATPLUS_FOUNDLUMINAIRE: 'Znaleziono oprawy awaryjne',
      ATPLUS_FOUNDWERELUMINAIRE: 'Znaleziono oprawy awaryjne',
      ATPLUS_MAIN_OFFICE: 'Główne Biuro',
      ATPLUS_DRYCONTACT_SUBHEADER: 'Główne Biuro',
      ATPLUS_MANAGE_CONFIG: 'Zarządzaj Konfiguracjami',
      ATPLUS_LOGIN_MAX_ATTEMPTS_EXCEEDED: 'Osiągnięto maksymalną liczbę prób',
      ATPLUS_MINIMIZE: 'Minimalizuj',
      ATPLUS_MULTIPLE_FAILURES: 'Wiele Awarii',
      ATPLUS_FOUNDNEWLUMINAIRE: 'Znaleziono nowe oprawy oświetleniowe.',
      ATPLUS_NEW_TEST_SCHEDULE: 'Nowy Harmonogram Testów',
      ATPLUS_DATETIME_SELECTED_TZ_PLACEHOLDER: 'Nowy Jork',
      ATPLUS_NEXT_SCHEDULES_DTTEST: 'Data Następnego Testu akumulatorów',
      ATPLUS_NEXT_SCHEDULES_FTTEST: 'Data Następnego Testu Funkcjonalmnego opraw',
      ATPLUS_NO_FW_FILES: 'Brak pliku oprogramowania dla tej wersji',
      ATPLUS_NO_LUMINAIRES_INSTALLED: 'Brak Zainstalowanych Opraw Oświetleniowych',
      ATPLUS_NO_LUMINAIRES_YET: 'Brak Opraw Oświetleniowych',
      ATPLUS_DRYCONTACT_RADIO_CLOSED: 'Normalnie Zamknięty',
      ATPLUS_DRYCONTACT_RADIO_OPEN: 'Normalnie Otwarty',
      ATPLUS_NEWLUMINAIRES_HEADLINE: 'Wyszukaj tylko nowo dodane lub wymienione oprawy w „Głównym Biurze”, aby automatycznie przypisać do nich adresy.',
      ATPLUS_OPENSNACK: 'Otwórz',
      ATPLUS_OPERATIONS: 'Operacje',
      ATPLUS_ALERTSETTING_OTHER_ALERTS: 'Inne Alerty',
      ATPLUS_DRYCONTACT_STATUS_OUTPUT: 'Wyjście',
      ATPLUS_DRYCONTACT_OUTPUT_DEFAULT_SETTINGS: 'Domyślne Ustawienia Wyjścia',
      ATPLUS_ALERTSETTING_CHOOSE_NUMBER: 'Wybierz od 1 do 10 opraw oświetleniowych',
      ATPLUS_ADDITIONALPASSWORDINSTRUCTION: 'Utwórz nowe hasła dla użytkowników z dostępem na poziomie Serwisu, Administratoram, Obsługi z ograniczonym dostępem',
      ATPLUS_DONT_MOVE: 'Proszę Nie Oddalać się',
      ATPLUS_DOWNLOAD_FW_FILES: 'Pobierz plik ponownie i spróbuj...',
      ATPLUS_BLE_DISCONNECT_SUBTITILE: 'Upewnij się, że jesteś w zasięgu Bluetooth i spróbuj ponownie.',
      ATPLUS_RELOGINPASSWORDINSTRUCTION: 'Proszę ponownie wprowadzić nowe hasło, aby  połączyć się z',
      ATPLUS_RELOGIN_MESSAGE: 'Wprowadź ponownie nowe hasło, aby połączyć się z bramką sieciową.',
      ATPLUS_ENTRY_MESSAGE: 'Wprowadź swoje dane uwierzytelniające, aby zmienić poniższe hasła',
      ATPLUS_EXPORT_CONFIGRATION_INFO: 'Nazwij plik, aby zapisać i wyeksportować najnowszą utworzoną konfigurację.',
      ATPLUS_STAY_WHERE: 'Pozostań na miejscu',
      ATPLUS_ALERTSETTING_NOTIFY: 'Użyj poniższych ustawień, aby dostosować preferencje powiadomień',
      ATPLUS_REFRESH_COMPLETE: 'Odświeżenie Zakończone',
      ATPLUS_REFRESHLUMINAIRE_TEST: 'Odśwież Oprawy Oświetleniowe',
      ATPLUS_REFRESH_LUMINAIRES_PAGETITLE: 'Odśwież Oprawy Oświetleniowe',
      ATPLUS_REFRESH_LUMINAIRES_PROGRESS: 'Trwa Odświeżanie Opraw Oświetleniowych...',
      ATPLUS_USE_RELIGHT: 'Relight jest dostępny tylko dla opraw w trybie spoczynku.',
      ATPLUS_DRYCONTACT_INPUT_RELIGHT: 'Relight JOUR',
      ATPLUS_RELIGHT_SUCCESS: 'Tryb Relight został pomyślnie aktywowany.',
      ATPLUS_RESTMODE: 'Spoczynek',
      ATPLUS_REST_SUCCESS: 'Tryb Spoczynku został pomyślnie aktywowany.',
      ATPLUS_DURATION_TEST: 'Rozpocznij test czasu podtrzymania',
      ATPLUS_FUNCTIONAL_TEST: 'Rozpocznij test funkcjonalny',
      ATPLUS_SEARCHALL_LUMINAIRE: 'Szukaj Wszystkich Opraw Awaryjnych',
      ATPLUS_SEARCH_ALL_LUMINAIRES: 'Wyszukaj wszystkie oprawy awaryjne',
      ATPLUS_SEARCH_NEWLUMINAIRES: 'Szukaj tylko nowych opraw awaryjnych',
      ATPLUS_SEARCHNEW_LUMINAIRE: 'Wyszukaj nowe oprawy awaryjne',
      ATPLUS_SERVICE_ACCESS: 'Dostęp do Usługi',
      ATPLUS_SERVICEPARTNERPASSWORD: 'Partner Serwisowy',
      ATPLUS_CHANGEPASSWORD_INSTRUCTION: 'Ustaw hasło dla użytkowników z',
      ATPLUS_ADDITIONALPASSWORD: 'Ustaw Dodatkowe Hasła',
      ATPLUS_DATE_TIME: 'Ustaw Datę i Czas',
      ATPLUS_DATETIME_HEADER: 'Ustaw Datę i Czas',
      ATPLUS_ALERTSETTING_LUMINAIRE_ALERTS_INFO: 'Ustaw liczbę uszkodzonych opraw awaryjnych przy, których system musi aktywować alert.',
      ATPLUS_SHOW_CONNECTED_LUMINAIRE: 'Pokaż Podłączone Oprawy',
      ATPLUS_SHOW_REGISTERED_LUMINAIRE: 'Pokaż Zarejestrowane Oprawy',
      SIGN_IN: 'Zaloguj się',
      SIGN_IN_AS: 'Zaloguj się jako...',
      ATPLUS_RELIGHT: 'Uruchom Tryb Relight',
      ATPLUS_REST: 'Uruchom Tryb Spoczynku',
      ATPLUS_STARTSEARCH: 'Rozpocznij Wyszukiwanie',
      ATPLUS_START_TEST: 'Rozpocznij Test',
      ATPLUS_VISIBILITY_TEST: 'Rozpocznij Widoczność Plus',
      ATPLUS_DRYCONTACT_INPUT_VISIBILITY: 'Rozpocznij Widoczność+',
      ATPLUS_STARTDT: 'Rozpoczynanie Testu Czasu Trwania...',
      ATPLUS_STARTFT: 'Rozpoczynanie Testu Funkcjonalnego...',
      ATPLUS_STARTDTSNACK: 'Zatrzymaj Test',
      ATPLUS_EMC: 'Przełącz na Test EMC',
      ATPLUS_SYNCH_TEST: 'Synchronizuj Harmonogram Testów',
      ATPLUS_SYNC_TEST_SCHEDULE: 'Synchronizuj Harmonogram Testów',
      ATPLUS_SYNC_TEST_SCHEDULED_INFO: 'Synchronizuj harmonogram testów funkcjonalnych i czasów trwania dla wszystkich opraw w budynku',
      TELECOMMANDPASSWORD: 'Hasło Telekierowania',
      ATPLUS_TEST: 'Test',
      ATPLUS_SYNC_TEST_TIME: 'Czas Testu:',
      ATPLUS_DRYCONTACT_INPUT_READONLY: 'Wejście bezpotencjałowe jest zabezpieczone przed zapisem, ale można je ręcznie skonfigurować za pomocą przełącznika DIP.',
      ATPLUS_DRYCONTACT_STATUS_READONLY: 'Status jest tylko do odczytu, ale można go ręcznie skonfigurować za pomocą przełącznika DIP.',
      ATPLUS_LUMINAIRE_INSTALL: 'Ta akcja spowoduje miganie wszystkich opraw w instalacji.',
      ATPLUS_SHOW_CONNECTED_LUMINAIRE_INFO: 'Ta akcja spowoduje miganie każdej oprawy, która jest prawidłowo podłączona i połączona z kontrolerem.',
      ATPLUS_SEARCHLUMINAIRE_HEADLINE: 'Wyszukaj wszystkie oprawy w „Głównym menu”, aby automatycznie przypisać im adresy.\nTa czynność spowoduje trwałą zmianę adresu już zainstalowanych oraz nowych opraw oświetleniowych i utworzy nową konfigurację. Tej czynności nie będzie można cofnąć.',
      ATPLUS_SHOW_REGISTERED_LUMINAIRE_INFO: 'Ta czynność spowoduje miganie tylko tymi oprawami, które są uwzględnione w konfiguracji oświetlenia.',
      ATPLUSSYNC_TEST_SCHEDULED_TIME_INFO: 'Ta czynność spowoduje synchronizację następnego testu funkcjonalnego dokładnie za tydzień, a testów czasu podtrzymania akumulatorów za 10 tygodni.',
      ATPLUS_AUTOMATIC_REST_MODE_INFO: 'Ta informacja jest tylko do odczytu, ale można ją skonfigurować ręcznie na przełączniku DIP.',
      ATPLUS_LOAST_CONNECTION_INFO: 'To urządzenie mobilne musi pozostać w zasięgu Bluetooth i być połączone z Systemem AT+ podczas Testu Funkcjonalnego.',
      ATPLUS_DEVICE_RANGE: 'To urządzenie mobilne musi pozostać w zasięgu Bluetooth G-North TLAT+ podczas tej operacji. \n Proces może potrwać kilka minut.',
      ATPLUS_TOMANYLUMINAIREHEADER: 'Ten system może obsłużyć tylko do 64 opraw. Tylko pierwsze 64 wykryte urządzenia będą częścią twojej konfiguracji.\nProszę użyć funkcji „Wyszukaj zarejestrowane oprawy” w oknie uruchamiania, aby znaleźć oprawy, które nie są uwzględnione w Twojej konfiguracji.',
      ATPLUS_CURRENT_LUMINAIRES_CONFIGURATION: 'Spowoduje to zastąpienie obecnej konfiguracji opraw awaryjnych',
      ATPLUS_TIMEREMAINS: 'Szacowany Czas.',
      ATPLUS_TIMEREMAINING: 'Pozostały Czas,',
      ATPLUS_DATETIME_TIMEZONE: 'Strefa Czasowa.',
      ATPLUS_TIMEZONE_HEADER: 'Strefa Czasowa.',
      TLU_ATPLUS_PASSWORD_INCORRECT: 'Nieprawidłowe hasło TLU AT+.',
      ATPLUS_TOMANYLUMINAIRE: 'Znaleziono Zbyt Wiele Opraw.',
      ATPLUS_FIRMWARE_UPDATING: 'Aktualizowanie Oprogramowania Układowego...',
      ATPLUS_USE_REST: 'Użyj trybu Spoczynku dla opraw, które nie są już podłączone do głównego zasilania.',
      ATPLUS_FINISHSEARCH: 'Użyj tych wyników, aby utworzyć i udostępnić nową konfigurację za pomocą opcji „Eksportuj.”',
      ATPLUS_DATETIME_AUTO_DATE_TIME_SUBTEXT: 'Użyj daty, czasu i strefy czasowej urządzenia mobilnego, aby automatycznie synchronizować z Systemem TLAT+. Wyłącz tę funkcję, aby ręcznie ustawić datę, czas i strefę czasową.',
      ATPLUS_VIEWLOGBOOK: 'Pokaż Dziennik zdarzeń',
      VIEWER: 'Przeglądający',
      ATPLUS_VIEWER_ACCESS: 'Przeglądający Dostęp',
      ATPLUS_LOGIN_MAX_ATTEMPTS_EXCEEDED_BODY: 'Możesz spróbować zalogować się do tego',
      ATPLUS_DT_DIALOG: 'Możesz utracić dane podczas testu długiego podtrzymania jeśli oddalisz się za daleko od systemu AT+\n\nSzacowany pozostały czas to: 01:00:00"',
      ATPLUS_FT_DIALOG: 'Możesz utracić dane podczas testu krótkiego, sprawności opraw jeśli oddalisz się za daleko od systemu AT+\n\nSzacowany pozostały czas to: 00:02:00"',
      ATPLUS_NO_LUMINAIRES_YET_DESCRIPTION: 'Będziesz musiał użyć funkcji „Szukaj Wszystkich Opraw” i aktywować swój TLAT+, aby zobaczyć tutaj swoje oprawy.',
      ATPLUS_CONFIGRATION_CREATED_MESSAGE: 'Twoja konfiguracja została pomyślnie utworzona.',
      ATPLUS_RELOGIN_SUCCESS_MESSAGE: 'Twoje nowe hasła zostały zapisane.',
      ATPLUS_DEVICE_UNREGISTERED: 'To urządzenie jest niezarejestrowane.',
      ATPLUS_DEVICE_NEEDCOMMISSIONIG: 'To urządzenie jest niezarejestrowane w Chmurze i wymaga ponownej konfiguracji.',
      SAVE_TO_CLOUD: 'Zapisz w Chmurze.',
      EXPORT: 'Eksportuj.',
      ATPLUS_IMPORT_CONFIG_SETTING_DEVICE_NAME: 'Zapisz nazwę urządzenia',
      TPLUS_IMPORT_CONFIG_LOADING_LUM_CONFIGRATION: 'Wczytaj konfigurację oprawy…',
      ATPLUS_IMPORT_CONFIG_SETTING_DRY_CONTACT_CONFIGURATION: 'Zdefiniuj styki bezpotencjałowe',
      ATPLUS_IMPORT_CONFIG_PROGRESS_ALERT_TITLE: 'Wyjście spowoduje utratę ustawień',
      TPLUS_IMPORT_CONFIG_PROGRESS_ALERT_SUBTITLE: 'Jeśli zamkniesz ten ekran, proces importowania zostanie przerwany i będziesz musiał rozpocząć go od nowa.',
      ATPLUS_START_VISIBILITY_PLUS: 'Rozpocznij Visibility Plus',
      ATPLUS_VISIBILITY_PLUS: 'Visibility Plus',
      ATPLUS_VISIBILITY_PLUS_FAILED: 'Visibility Plus Failed',
      DS_SEARCH_FOR_IO_MODULES: 'Wyszukaj moduły IO',
      ATplUS_ACTIVATION_PENDING: 'Oczekujące',
      ATPLUS_ALERTSETTING_ZONE_ALERTS_INFO: 'Ustaw liczbę uszkodzonych opraw awaryjnych przy, których system musi aktywować alert.',
      ATPLUS_ALERTSETTING_LINE_ALERTS_INFO: 'Ustaw liczbę uszkodzonych opraw awaryjnych przy, których system musi aktywować alert.',
      ATPLUS_IDENTIFICATION_CONNECTED_LUMINAIRE_INFO: 'Ta akcja spowoduje miganie każdej oprawy, która jest prawidłowo podłączona i połączona z kontrolerem.',
      ATPLUS_IDENTIFICATION_REGISTERED_LUMINAIRE_INFO: 'Ta czynność spowoduje miganie tylko tymi oprawami, które są uwzględnione w konfiguracji oświetlenia.',
      ATPLUS_SPEC_DATE_COMMISSIONED: 'Data Wdrożenia',
      ATPLUS_SPEC_TOTAL_LUMINAIRES: 'Łączna liczba opraw.',
      ATPLUS_SPEC_LUMINAIRE: 'Oprawy awaryjne',
},
    USERLIST: {
      DELETECONFIRMATION: 'Konto e-mail {{email}} i wszystkie jego dane zostaną trwale usunięte. Usunięcie tego konta nie wpłynie na organizację, urządzenia ani dane wcześniej zapisane.',
      ACCOUNT_DELETE: 'Konto Usunięte',
      ALL_LOCATION: 'Wszystkie Lokalizacje',
      DELETEACCOUNT: 'Usunąć to Konto?',
      COL_EMAIL: 'E-mail',
      COL_LOCATION: 'Lokalizacja',
      COL_ROLE: 'Rola',
      COL_STATUS: 'Status',
      DELETE_SUCCESS: 'Konto użytkownika {{email}} zostało pomyślnie usunięte.',
      COL_USERNAME: 'Nazwa Użytkownika',
},
    REPORTS: {
      ISSUES: '{{issueCount}} raport o usterkach',
      MONTHLY_REPORT: 'Raport Miesięczny',
      NO_ISSUES: 'Brak problemów w tym okresie',
      REPORT_DOWNLOAD_FAILED: 'Pobranie pliku raportu nie powiodło się',
      REPORT_DOWNLOAD_SUCCESSFULLY: 'Plik raportu pobrany pomyślnie',
},
    MAP: {
      MAP_COORDINATES: '{{latitude}} N, {{longitude}} E',
      BLOCKED: 'ZABLOKOWANE',
      MAP_COORDINATES_LABEL: 'Współrzędne',
       MAP_ADDRESS_DISPLAY: 'Wyświetl adres na mapie',
      MAP_DRAG_MARKER: 'Przeciągnij na mapie, aby umieścić znacznik',
      ERROR: 'BŁĄD',
      OFFLINE: 'OFFLINE',
      READY: 'GOTOWY',
      MAP_ENABLE_ON_COUNTRY: 'Wybierz kraj, aby włączyć mapę',
      SYSTEM: 'System',
      SYSTEMS: 'Systemy',
      WARNING: 'OSTRZEŻENIE',
},
    MAINTENANCE_DETAILS: {
      ADD_DOC: 'Dodaj Dokument',
      ADD_NOTES: 'Dodaj Notatki',
      ADD_DOCUMENT_BUTTON: 'Dodaj Dokument lub Zdjęcie',
      NEW_MAINTENANCE: 'Nowa Konserwacja',
      CREATE_MAINTAINENCE_BUTTON: 'Przypisz i Powiadom',
      TECHNICIAN_INPUT_LABEL: 'Przypisane Do',
      STATUS_COMPLETED: 'Zakończone',
      CUSTOMER_CONTACT: 'Kontakty Klienta',
      DATE_CREATED: 'Data Utworzenia',
      DELETE_REQ: 'Usuń Żądanie',
      COMMENTS_LABEL: 'Opis (Opcjonalnie)',
      DOCUMENTATION: 'Dokumentacja',
      STATUS_DUE: 'Należny',
      EMERGENCY: 'Awaryjne',
      STATUS_EXPIRED: 'Wygasło',
      HIGH: 'Wysoki',
      IN_DUE: 'ZA {{differenceInDays}} DNI',
      UPLOAD_DOCUMENT_ERROR_MESSAGE_INVALID_TYPE: 'Nieprawidłowy typ pliku. Dozwolone są tylko PDF, JPEG i PNG.',
      SUPPORT_TYPE_INPUT_LABEL: 'Rodzaj problemu',
      LIFECYCLE_MAINTAINANCE: 'Okres konserwacji konserwacja ',
      LIFECYCLE_MAINTENANCE: 'Okres konserwacji konserwacja ',
      LOCATION: 'Lokalizacje',
      LOW: 'Niski',
      MAINTENANCE_HISTORY: 'Historia Konserwacji',
      MAINTENANCE_REQUEST: 'Żądanie Konserwacji',
      MEDIUM: 'Średni',
      NO_CUSTOMER_LINKED: 'Brak powiązanego klienta',
      NO_DOC_ADDED: 'Nie Dodano Dokumentacji',
      NO_MAINTENACE_FOUND: 'Brak zgłoszeń konserwacyjnych',
      NO_NOTES_ADDED: 'Nie Dodano Notatek',
      NOTES: 'Notatki',
      UPLOAD_DOCUMENT_ERROR_MESSAGE_INVALID_FILE_SIZE: 'Jeden lub więcej plików przekracza limit rozmiaru 2 MB.',
      PAST_DUE: 'Przeterminowane',
      PRIORITY: 'Priorytet',
      STATUS_REJECTED: 'Odrzucono',
      REOPEN_SERVICE_TICKET: 'Ponowne Otwarcie Zgłoszenia Serwisowego',
      REQUEST_PRIORITY_INPUT_LABEL: 'Priorytet Żądania',
      REQ_MAINTENANCE: 'Zażądana Konserwacja',
      REQUESTED_MAINTAINANCE: 'Zażądana Konserwacja',
      SCHEDULED: 'Zaplanowano',
      STATUS_SCHEDULED: 'Zaplanowano',
      SCH_SERVICE_DATE: 'Data Zaplanowanej Usługi',
      SEARCH: 'Szukaj po numerze zgłoszenia',
      SERVICE_DATE: 'Data Usługi',
      SERVICE_TICKET_NO: 'Numer Zgłoszenia Serwisowego',
      SERVICE_TYPE: 'Typ Usługi',
      SUPPORT_TECHNICIAN: 'Technik Wsparcia',
      SYS_FAILURE: 'Awaria Systemu',
      SYSTEM_FAILURE: 'Awaria Systemu',
      TICKET_CLOSED: 'Zamknięcie Zgłoszenia.',
      TICKET_NO: 'Numer Zgłoszenia.',
      STATUS: 'Status Zgłoszenia: Wszystkie.',
      TODAY: 'DZISIAJ.',
      UPLOAD_DOCUMENT_ERROR_MESSAGE_MAX_3_FILES: 'Możesz wybrać maksymalnie 3 pliki.',
      EDIT_SERVICE_TICKET: 'Edytuj zgłoszenie serwisowe',
      MAINTENANCE_OPERATIONS: 'Operacje Konserwacyjne.',
      SCHEDULED_MAINTENANCE: 'Planowana Konserwacja.',
      RECENT_MAINTENANCE: 'Ostatnia Konserwacja.',
      CLOSE_SERVICE_TICKET: 'Zamknij Zgłoszenie Serwisowe.',
      CLOSE_TICKET: 'Zamknij Zgłoszenie.',
      DESCRIBE_ACTION: 'Opisz podjęte działania w celu rozwiązania problemu.',
      TICKET_RESOLUTION: 'Rozwiązanie Zgłoszenia.',
      CLOSED_BY: 'Zamknięte przez.',
},
    ASSETS_DETAILS: {
      ADD_BUILDINGS: 'Dodaj Budynek',
      ADD_SYSTEMS: 'Dodaj System',
      NEW_MAINTAINENCE: 'Nowa Konserwacja',
      BUILDINGS: 'Budynki',
      CUSTOMER_MAINTAINENCE_HEADER: 'Szczegóły Klienta',
      CUSTOMER_INFO_HEADER: 'Informacje o Kliencie',
      DOWNLOAD_AS: 'Pobierz Jako…',
      FIRMWARE: 'Oprogramowanie sprzętowe',
      GATEWAYS: 'Bramka sieciowa',
      LINK_TO_CUSTOMER_BUTTON: 'Połącz z Klientem',
      MAIN_CONTACT: 'Główny Kontakt',
      RIGHT_MAINTAINENCE_HEADER: 'Szczegóły Konserwacji',
      MOST_RECENT_STATUS: 'Najnowszy Status',
      NOTIFY_USERS_MAINTAINENCE_HEADER: 'Powiadom Użytkowników:',
      SUBHEADER_TEXT_MAINTAINENCE: 'Sprawdź informacje, przypisz technika i dodaj pomocne szczegóły dotyczące rozwiązania problemu.',
      PREVIOUS_SYSTEM_STATUS: 'Poprzedni Status Systemu',
      CREATE_MAINTAINENCE_HEADER: 'Zaplanuj Nową Operację Konserwacyjną',
      ADD_BUILDING_ASSET: 'Wybierz organizację, aby utworzyć budynek',
      SELECT_ORGANIZATION_LABEL: 'Wybierz organizację',
      SHOW_FAVORITE_BUILDINGS: 'Pokaż Tylko Oznaczone Budynki',
      SHOW_FAVORITE_GATEWAYS: 'Pokaż Tylko Oznaczone Bramki',
      SHOW_FAVORITE_SYSTEMS: 'Pokaż Tylko Oznaczone Systemy',
      SLA_SUBTITLE: 'SLA#',
      LEFT_MAINTAINENCE_HEADER: 'Szczegóły Systemu',
      SYSTEM_NAME_TYPE_SUBTITLE: 'Nazwa i Typ Systemu',
      SYSTEMS: 'Systemy',
      HELPER_TEXT_MAINTAINENCE: 'To żądanie powiadomi główne i dodatkowe kontakty {{customerName}}. Domyślnie zawiera ono odpowiednią lokalizację, urządzenie, alarm i informacje o zdarzeniach.',
      NO_CUSTOMER_TEXT: 'Ten system nie jest powiązany z klientem',
},
    COMMON: {
      SYNC_NOW_TIME: '=--min. temu',
      REQUIRES_FIRMWARE_UPDATE: '1 wymaga aktualizacji oprogramowania',
      NOTIFICATION_REPORT_MESSAGE_BODY: 'Nowy miesięczny raport dla: \n {{bodytext}} jest dostępny do wglądu.',
      ACCESS: 'Dostęp',
      ACTIVE: 'Aktywny',
      ALERT: 'Alert!',
      DOWNLOAD_PERMISSION: 'Zezwól na zapisanie plików na Twoim urządzeniu',
      GO_BACK: 'WRÓĆ',
      NOTIFICATION_EVENT_OCCURED: '{{logType}} wystąpił w następującym systemie',
      ASSETS: 'Zasoby',
      BACK: 'Wróć',
      BLOCKED: 'ZABLOKOWANE',
      CANCEL: 'Anuluj',
      CANNOT_REFRESH_TOKEN: 'Nie można odświeżyć tokenu',
      CLOSE: 'Zamknij',
      SET_ETHERNET: 'Konfiguruj Ustawienia Portu',
      CONFIRM: 'Potwierdź',
      CONNECT: 'Połącz',
      CONNECTION: 'Połączenie',
      CSV: 'CSV',
      DASHBOARD: 'Pulpit',
      DESCRIPTION: 'Opis',
      DISCARD: 'Odrzuć',
      DISCARD_UNSAVED_CHANGE: 'Odrzuć niezapisane zmiany?',
      DONE: 'Gotowe',
      DOWNLOAD: 'Pobierz',
      DOWNLOAD_FAILED: 'Pobieranie nie powiodło się, spróbuj ponownie',
      COMPANY: 'Eaton',
      EDIT: 'Edytuj',
      APP_NAME: 'Menedżer Bezpieczeństwa Budynku',
      EMPTY: 'PUSTY',
      EXCEL: 'Plik Excel',
      EXIT: 'Wyjście',
      EXTEND: 'Przedłuż',
      DOWNLOAD_SUCCESS: 'Plik pobrany pomyślnie.',
      ANOMALY: 'W ANOMALII',
      INACTIVE: 'Nieaktywny',
      INCOMPLETE: 'Niekompletne',
      INFO: 'Informacje',
      INTERVAL: 'Interwał',
      KEEP_EDITING: 'Kontynuuj Edycję',
      LAST_RETREIVED: 'Ostatnio pobrano:',
      LAST_RETRIEVED: 'Ostatnio pobrano: -- minut temu',
      LINK: 'Link',
      LOCATE: 'Zlokalizuj',
      LOGBOOK: 'Dziennik',
      LOGGED_IN_SUCCESSFULLY: 'Zalogowano pomyślnie',
      NOTIFICATION_NEW_REPORT_AVAILABLE: 'Dostępny Nowy Raport',
      NEWUSER: 'Nowy Użytkownik',
      NEXT: 'Dalej',
      NODATA: 'Brak Danych',
      OFF: 'Wyłączone',
      OFFLINE: 'Offline',
      OK: 'ok',
      ON: 'włączone',
      PASSWORD: 'Hasło',
      PDF: 'PDF',
      SELECT_PREFERRED_LANGUAGE: 'Wybierz Preferowany Język',
      POWERED_BY_BRIGHTLAYER: 'Obsługiwane przez Brightlayer',
      READY: 'GOTOWY',
      RECOONECTTOGATWAY: 'Połącz Ponownie z Bramką',
      REFRESH: 'Odśwież',
      REMOVE: 'Usuń',
      RETURNTODASHBOARD: 'Wróć do Pulpitu',
      NAVIGATION_HEADER: 'S3ri4l-Num63r',
      SAVE: 'Zapisz',
      REFRESH_TOKEN_ERROR: 'Token bezpieczeństwa nie może być pusty ani nie może być wpisane zero.',
      SESSION_ALERT_TITLE: 'Limit Czasu Sesji',
      SET: 'Ustaw',
      SETTINGS: 'Ustawienia',
      VIEW_ALL_SYSTEM: 'Pokaż Wszystkie',
      SKIP: 'Pomiń',
      STOP: 'Zatrzymaj',
      PERMISSION_ERROR: 'Brak Udzielonego Dostępu do Pamięci',
      SYNC: 'Synchronizacja',
      SYNCH_OFFLINE_DATABASE: 'Synchronizuj Offline Bazę Danych',
      SYSTEM: 'System',
      SESSION_ALERT_SUBTITLE: 'To okno było nieaktywne przez 15 minut. Jeżeli w ciągu {{extendTime}} nie zostanie podjęta żadna czynność, nastąpi wylogowanie.',
      TIME: 'Czas.',
      TRYAGAIN: 'Spróbuj ponownie.',
      DOWNLOAD_FAIL: 'Nie można pobrać, spróbuj ponownie.',
      UNAUTHORIZED_ACCESS: 'Nieautoryzowany dostęp.',
      UNLINK: 'Odłącz.',
      USERS: 'Użytkownicy',
      VIEW: 'Podgląd',
      WELCOME: 'Witamy.',
      YES: 'Tak',
      EMPTY_SYSTEM_TITLE: 'Nie masz jeszcze aktywów w tej organizacji.',
      EMPTY_SYSTEM_SUBTITLE: 'Otrzymasz informacje o statusie oświetlenia awaryjnego natychmiast po dodaniu systemów do tej organizacji.',
      ERROR_OCCURED: 'Wystąpił błąd w.',
      OOPS: 'Ups!',
      THERE_IS_ERROR: 'Wystąpił błąd.',
      NEW_VERSION_AVAILABLE: 'Nowa wersja aplikacji dostępna za.',
      UNDER_MAINTENANCE: 'Trwają prace konserwacyjne aplikacji.',
      UNDER_MAINTENANCE_TITLE: 'Trwają prace konserwacyjne aplikacji.',
      UPDATE_AVAILABLE_TITLE: 'Aktualizacja dostępna.',
      UPDATE_REQUIRED_TITLE: 'Wymagana aktualizacja.',
      UPDATE_NOW: 'Zaktualizuj teraz.',
      ASK_ME_LATER: 'Zapytaj Mnie Później.',
      EMPTY_TRIGGERS_LINE: 'Nie skonfigurowano żadnych opcjonalnych sterowań',
      ASSIGN: 'Przypisać',
      OKTA_LOGOUT_ALERT: 'Czy na pewno chcesz zrezygnować z subskrypcji usługi Okta?',
      OKTA_LOGIN_BUTTON: 'Zaloguj się przez Okta',
      CANNOT_PROCCED_LOGIN: 'Nie masz uprawnień. Proszę zarejestruj się.',
      UNAUTHORIZED_ACCESS_OKTA: 'Błąd uwierzytelniania',
      SCAN: 'Szukaj',
      NO: 'Nie',
      ACKNOWLEDGE: 'Potwierdź',
      DAYS: 'Dni',
      VALID_EMAIL_ERROR: 'Wprowadź prawidłowy e-mail',
      TRANSFER_LUMINARIES: 'Przenieś.',
      TRIGGERS: 'Sterowania',
      SELECTED: 'Wybrano',
      NAME: 'Nazwa',
},
    PASSWORD_REQUIREMENTS: {
      LENGTH: '8-16 Znaków',
      LOWER: 'Jedna mała litera',
      NUMBERS: 'Jedna cyfra',
      SPECIAL: 'Jeden znak specjalny',
      UPPER: 'Jedna wielka litera',
},
    AUTH_TRANSLATION: {
      FORGOT_PASSWORD: {
        LINK_SENT_ALT: 'Link do zresetowania hasła został wysłany na <1>{{email}}</1>.',
        LINK_SENT: 'Link do zresetowania hasła został wysłany na <b>{{email}}</b>.',
        ERROR: 'Nie można zresetować hasła w tej chwili.',
        INSTRUCTIONS_ALT: '„Wprowadź adres e-mail powiązany z kontem.\nJeśli dla tego adresu e-mail istnieje  inne konto Eaton, odpowiedź otrzymasz w ciągu <b>jednego dnia roboczego</b>.\nW przypadku pilnych problemów z kontem prosimy o kontakt pod numerem telefonu {{phone}}."',
        INSTRUCTIONS: '„Wprowadź adres e-mail powiązany z kontem.\nJeśli dla tego adresu e-mail istnieje  inne konto Eaton, odpowiedź otrzymasz w ciągu <b>jednego dnia roboczego</b>.\nW przypadku pilnych problemów z kontem prosimy o kontakt pod numerem telefonu {{phone}}."',
        RESET_CODE_ERROR: 'Wystąpił błąd z kodem resetu.',
},
      MESSAGES: {
        USER_PHONE_NUMBER_INVALID: 'Numer telefonu jest nieprawidłowy.',
        CONGRATS: 'Gratulacje!',
        CONTACT: 'Skontaktuj się z Przedstawicielem Wsparcia Eaton',
        EMAIL_SENT: 'E-mail Wysłany',
        ERROR: 'Błąd!',
        FAILURE: 'Awaria',
        INVALID_VERIFICATION_CODE: 'Kod weryfikacyjny jest nieprawidłowy lub długość powinna być mniejsza niż 6 znaków.',
        LOADING: 'Ładowanie...',
        GENERIC_ERROR_MESSAGE: 'Skontaktuj się z administratorem, jeśli żądana operacja nie może zostać ukończona.',
        EMAIL_ENTRY_ERROR: 'Wprowadź prawidłowy e-mail',
        USER_EMAIL_INVALID: 'Podaj prawidłowy adres e-mail',
        REQUEST_ERROR: 'Przepraszamy, wystąpił problem z wysłaniem twojego żądania.',
        SUCCESS: 'Sukces',
        WELCOME: 'Witamy.',
        LOGIN_MESSAGE: 'Jesteś zalogowany.',
},
      CHANGE_PASSWORD: {
        PROBLEM_OCCURRED: 'Wystąpił problem:',
        CANCEL: 'Anuluj',
        PASSWORD: 'Zmień Hasło',
        CONFIRM_NEW_PASSWORD: 'Potwierdź nowe hasło',
        OLD_PASSWORD: 'Stare hasło',
        PASSWORD_CHANGED: 'Hasło zostało zmienione',
        PASSWORD_INFO: 'Hasło musi mieć co najmniej 8 znaków, zawierać co najmniej jedną wielką literę, jedną małą literę, jedną cyfrę i jeden znak specjalny.',
        UPDATE: 'Aktualizuj.',
        EMAIL_CONFIRM_MESSAGE: 'Wysłaliśmy e-mail potwierdzający na {{email}}.',
        ERROR_MESSAGE: 'Twoje informacje nie pasują do naszych zapisów. Wprowadź swoje dane ponownie, aby spróbować ponownie.',
        SUCCESS_MESSAGE: 'Twoje hasło zostało pomyślnie zaktualizowane! Aby zapewnić bezpieczeństwo konta, zaloguj się do aplikacji, używając zaktualizowanych danych logowania.',
},
      SELF_REGISTRATION: {
        VERIFY_EMAIL: {
          MESSAGE: 'Kod weryfikacyjny został wysłany na podany adres e-mail. Kliknij w link lub wprowadź kod poniżej, aby kontynuować. Kod jest ważny przez 30 minut.',
          VERIFICATION_CODE_PROMPT: 'Nie otrzymałeś kodu?',
          RESEND: 'Wyślij Ponownie E-mail Weryfikacyjny',
          VERIFICATION: 'Kod Weryfikacyjny',
},
        ALREADY_REGISTERED_USER: 'Użytkownik już zarejestrowany',
        INSTRUCTIONS: 'Aby zarejestrować konto w Eaton, wprowadź wymagane informacje poniżej. Musisz zweryfikować swój adres e-mail, aby kontynuować.',
},
      REGISTRATION: {
        STEPS: {
          COMPLETE: 'Konto Utworzone!',
          ACCOUNT_DETAILS: 'Szczegóły Konta',
          COMPANY_ADDRESS: 'Adres Firmy',
          COMPANY_DETAILS: 'Szczegóły Firmy',
          CREATE_ACCOUNT: 'Utwórz Konto',
          PASSWORD: 'Utwórz Hasło',
          LICENSE: 'Umowa Licencyjna',
          VERIFY_EMAIL: 'Zweryfikuj E-mail',
},
        EULA: {
          DEUTSCH: 'Niemiecki',
          ENGLISH: 'Angielski',
          AGREE_TERMS: 'Przeczytałem i zapoznałem się z Regulaminem',
          LANGUAGE_SUCCESS: 'Język Zaktualizowany Pomyślnie',
          LOADING: 'Ładowanie Umowy Licencyjnej Użytkownika Końcowego...',
},
        INSTRUCTIONS: {
          ACCOUNT_DETAILS: 'Wprowadź swoje dane poniżej, aby zakończyć tworzenie konta.',
          COMPANY_DETAILS: 'To pomaga Eaton zapewnić wsparcie serwisowe dla rozwiązania awaryjnego oświetlenia. Jeśli inicjujesz projekt dla swojego klienta, proszę wprowadzić informacje o swojej firmie, a nie klienta.',
          COMPANY_ADDRESS: 'To pomaga Eaton zapewnić wsparcie serwisowe dla rozwiązania awaryjnego oświetlenia. Jeśli inicjujesz projekt dla swojego klienta, proszę wprowadzić informacje o swojej firmie, a nie klienta.',
},
        UNKNOWN_EMAIL: 'Nieznany e-mail.',
        UNKNOWN_ORGANIZATION: 'Nieznana organizacja',
        FAILURE_MESSAGE: 'Nie udało się dokończyć rejestracji. Aby zakończyć proces, kliknij „Dalej” poniżej.',
        SUCCESS_MESSAGE_ALT: '„Twoje konto zostało pomyślnie utworzone przy użyciu adresu e-mail <1>{{email}</1>. Twoje konto zostało już dodane do organizacji <3>{{organization}</3>. Kliknij „Dalej” poniżej, aby zakończyć proces.',
        SUCCESS_MESSAGE: 'Twoje konto zostało pomyślnie zarejestrowane pod następującym adresem e-mail. Zostałeś dodany do organizacji.',
        SUCCESS_EXISTING: 'Twoje konto zostało pomyślnie utworzone. Zaloguj się, podając adres e-mail i hasło swojego konta Eaton.',
        SUCCESS_SYNCED_MESSAGE: 'Twoje konto EL Digital zostało pomyślnie zsynchronizowane z informacjami Bright Layer Cloud powiązanymi z adresem e-mail <b>{{email}}</b>.',
        SUCCESS_FINISH: 'Kliknij „Potwierdź”, aby się zalogować.',
        SUCCESS_DASHBOARD: 'Aby uzyskać dostęp do swojego konta, kliknij „Mój panel”.',
},
      ACTIONS: {
        BACK: 'Wróć',
        CANCEL: 'Anuluj',
        CHANGE_LANGUAGE: 'Zmień Język tutaj!',
        CLICK_BUTTON: 'Kliknij przycisk',
        UPDATE_REDUX: 'Kliknij przycisk, aby zaktualizować wartość sklepu redux!',
        CONTINUE: 'Kontynuuj',
        DONE: 'Gotowe',
        FINISH: 'Zakończ',
        GO_HOME: 'Przejdź do Strony Głównej',
        GO_DASHBOARD: 'Przejdź do Mojego Pulpitu',
        GO_TEST: 'Przejdź do Strony Testowej',
        LOG_IN: 'Zaloguj się',
        LOG_OUT: 'Wyloguj się',
        NEXT: 'Dalej',
        OKAY: 'okay',
        REMEMBER: 'Zapamiętaj mnie',
        RESEND: 'Wyślij ponownie',
        SEND_AGAIN: 'Wyślij Ponownie',
        SEND_EMAIL: 'Wyślij E-mail',
        CREATE_ACCOUNT: 'Zarejestruj się',
        UPDATE: 'Aktualizuj.',
},
      FORMS: {
        COMPANY_NAME: 'Nazwa Firmy',
        CONFIRM_PASSWORD: 'Potwierdź Hasło',
        COUNTRY: 'Kraj',
        CURRENT_PASSWORD_ERROR: 'Obecne Hasło nie pasuje',
        FIRST_NAME: 'Imię',
        RESET_PASSWORD: 'Zapomniałeś Hasła',
        LAST_NAME: 'Nazwisko',
        ORGANAIZATION_ADRESS: 'Adres Organizacji Linia 1*',
        PASSWORD: 'Hasło',
        PASS_MATCH_ERROR: 'Hasła nie pasują ',
        PHONE_NUMBER: 'Numer Telefonu',
        TOGGLE_PASSWORD_VISIBILITY: 'Przełącz widoczność hasła.',
},
      LABELS: {
        CURRENT_PASSWORD: 'Aktualne hasło',
        EMAIL: 'Adres E-mail',
        FORGOT_PASSWORD: 'Zapomniałeś swoje hasło?',
        NEED_ACCOUNT: 'Potrzebujesz konta?',
        NEW_PASSWORD: 'Nowe Hasło',
        OPTIONAL: 'Opcjonalne',
        PASSWORD: 'Hasło',
        USERNAME: 'Nazwa użytkownika',
},
      LOGIN: {
        INCORRECT_CREDENTIALS: 'Niepoprawny E-mail lub Hasło',
        GENERIC_ERROR: 'Twoje żądanie nie mogło zostać przetworzone w tym momencie.',
        INVALID_CREDENTIALS: 'Kombinacja nazwy użytkownika/hasła nie została rozpoznana.',
},
      GATEWAY_COMMISSION_STEP: {
        STEP_NUMBER: 'Krok {{stepNo}} z 4',
},
},
    REGISTRATION: {
      STEPS_MESSAGE: {
        CREATE_ACCOUNT_VERIFY_EMAIL: 'Kod weryfikacyjny został wysłany na podany adres e-mail. Kliknij w link lub wprowadź kod poniżej, aby kontynuować. Kod jest ważny przez 30 minut.',
        CREATE_ACCOUNT_USER_DETAILS: 'Wprowadź swoje dane poniżej, aby zakończyć tworzenie konta.',
        CREATE_ACCOUNT_COMPANY_DETAILS: 'To pomaga Eaton zapewnić wsparcie serwisowe dla rozwiązania awaryjnego oświetlenia. Jeśli inicjujesz projekt dla swojego klienta, proszę wprowadzić informacje o swojej firmie, a nie klienta.',
        CREATE_ACCOUNT_ENTER_EMAIL: 'Aby zarejestrować konto w Systemie Zarządzania Bezpieczeństwem, wprowadź wymagane informacje poniżej. Musisz zweryfikować swój adres e-mail, aby kontynuować.',
},
      STEPS: {
        COMPLETE_OTHER_ADOPTER: 'Konto Potwierdzone!',
        COMPLETE: 'Konto Utworzone!',
        ACCOUNT_DETAILS: 'Szczegóły Konta',
        COMPANY_ADDRESS: 'Adres Firmy',
        COMPANY_DETAILS: 'Szczegóły Firmy',
        CREATE_ACCOUNT: 'Utwórz Konto',
        PASSWORD: 'Utwórz Hasło',
        FORGOT_PASSWORD: 'Zapomniałeś Hasła',
        LICENSE: 'Umowa Licencyjna',
        VERIFY_EMAIL: 'Zweryfikuj E-mail',
},
      STEPS_ERROR_MESSAGE: {
        USER_ALREADY_EXIST_MESSAGE: 'Użytkownik już zarejestrowany',
        USER_INVALID_ENTRY: 'Parametry wejściowe nie mogą być puste ani zerowe.',
        GENERIC_ERROR_MESSAGE: 'Skontaktuj się z administratorem, jeśli żądana operacja nie może zostać ukończona.',
        USER_EMAIL_INVALID: 'Podaj prawidłowy adres e-mail.',
        VERIFICATION_CODE_EXPIRED_MESSAGE: 'Kod wygasł. Kliknij poniższy przycisk, aby zażądać kolejnego e-maila weryfikacyjnego.',
},
      EULA: {
        LOADING: 'Ładowanie Umowy Licencyjnej Użytkownika Końcowego...',
        LANGUAGE: 'Wybierz Preferowany Język',
        FRENCH: 'Francuski',
},
      FAILURE_MESSAGE: 'Nie udało się dokończyć rejestracji. Kliknij „Dalej” poniżej, aby przejść do oprogramowania Eaton Building Safety Management.',
      SUCCESS_MESSAGE: 'Twoje konto zostało pomyślnie utworzone z adresem e-mail {{email}}.',
      SUCCESS_MESSAGE_OTHER_ADOPTER: 'Twoje konto EL Digital zostało pomyślnie zsynchronizowane z informacjami Bright Layer Cloud powiązanymi z adresem e-mail <2>{{email}}</2>.',
},
    USER_INVITATION_REGISTRATION: {
      ACCEPT: 'Akceptuj',
      DENY: 'Odmów',
      INSTRUCTIONS: 'Jeśli ten e-mail jest powiązany z kontem Eaton, otrzymasz odpowiedź w ciągu <3>jednego dnia roboczego</3>.<br/><br/>W przypadku pilnych problemów z kontem, zadzwoń.',
      TITLE: 'System Zarządzania Bezpieczeństwem',
      INVITATION_VALIDATION_ERROR: 'Wystąpił błąd z kodem zaproszenia.',
},
    DASHBORAD: {
      ACCEPT_BUTTON: 'Zaakceptuj Zaproszenie',
      ACCEPT_HEADER: 'Zaakceptować Zaproszenie?',
      ACCEPTED_INVITATION: 'Zaakceptowane Zaproszenia',
      ACCEPT_TITLE: 'Zaakceptowanie zaproszenia doda następujący element do Twojego profilu:',
      ADD_NEW_ORGANIZATION: 'Dodaj Nową Organizację...',
      ADD_ANOTHER_ORGANIZATION: 'Dodaj Inną Organizację',
      ALL_BUILDINGS: 'Wszystkie Budynki',
      ALL_CITIES: 'Wszystkie Miasta',
      ALL_COMPANIES: 'Wszystkie Firmy',
      ALL_COUNTRIES: 'Wszystkie Kraje',
      ALL_CUSTOMER_ID: 'Wszystkie ID Klienta',
      ALL_GATEWAYS: 'Wszystkie Bramki',
      ALL_ORGANIZATIONS: 'Wszystkie Organizacje',
      ALL_STATUSES: 'Wszystkie Statusy',
      ALL_STATUS: 'Wszystkie Statusy',
      ALL_TYPES: 'Wszystkie Typy',
      BLOCKED: 'Zablokowane',
      BUILD_DETAILS: 'Szczegóły Budynku',
      BUILDINGS: 'Budynki',
      CUSTOMERS: 'Klienci',
      DECLINE: 'Odrzuć',
      DECLINED_INVITATION: 'Odrzucone Zaproszenia',
      DISPLAY_ADDRESS_ON_MAP: 'Wyświetl adres na mapie',
      MAP_DRAG_TITLE: 'Przeciągnij na mapie, aby umieścić znacznik',
      REQUEST_ACCESS_SENT: 'Zaproszenie do uzyskania dostępu zostało wysłane do użytkownika.',
      ERROR: 'Błąd',
      EVENT: 'Zdarzenie',
      EXPIRED_INVITATION: 'Wygasłe Zaproszenia',
      EXPORT_REPORT: 'Eksportuj Raport',
      GATEWAY: 'Gateways',
      IN_ANOMALY: 'W Anomalii',
      INFORMATION: 'Informacje',
      INVITATION_HISTORY: 'Historia Zaproszeń',
      ISSUES: 'Problemy',
      JOIN: 'Dołącz',
      LIST_VIEW: 'Widok Listy',
      MAP_VIEW: 'Widok Mapy',
      MONTHLY_REPORT: 'Raport Miesięczny',
      NO_ISSUES_DURING_THIS_PERIOD: 'Brak problemów w tym okresie',
      ORG_DETAILS: 'Szczegóły Organizacji',
      PENDING_INVITATION: 'Oczekujące Zaproszenia',
      CHOOSE_REPORT_YOU_WOULD_LIKE_TO_SAVE_SHARE: 'Wybierz raport, który chcesz zapisać lub udostępnić.',
      PLEASE_MAKE_A_SELECTIONS: 'Wybierz opcję.',
      REQUEST_SUBTITLE: 'Poproś osobę, która wysłała zaproszenie, o dostęp, aby dodać ten element do swojego profilu',
      INVITATION_BODY: 'Wybierz elementy, które chcesz dodać do swojego profilu lub odrzuć zaproszenie',
      READY: 'Gotowy',
      NO_CONTENT: 'Zastąp tę stronę swoją własną treścią',
      REPORTS: 'Raporty',
      REQUEST_BUTTON: 'Zażądaj Dostępu',
      REQUEST_HEADER: 'Zażądaj Dostępu?',
      CHECK_INVITATIONS: 'Skanowanie zaproszeń...',
      SELECT_ALL: 'Wybierz Wszystkie',
      SELECTIONS_CONFIRMED: 'Wybór Potwierdzony',
      SERVICE_MANAGERS: 'Menedżerowie Serwisu',
      SYSTEMS: 'Systemy',
      TECHNICIANS: 'Technicy',
      EMPTY_ACCEPTED_INVITATION: 'Obecnie brak zaakceptowanych zaproszeń.',
      EMPTY_DECLINED_INVITATION: 'Obecnie brak odrzuconych zaproszeń.',
      EMPTY_EXPIRED_INVITATION: 'Obecnie brak wygasłych zaproszeń.',
      EMPTY_REQUESTED_INVITATION: 'Obecnie brak żądanych zaproszeń.',
      REQUEST_TITLE: 'To zaproszenie wygasło i nie może być już dodane do twojego profilu.',
      TOTAL_ACCEPTED_INVITATIONS: 'Łączna liczba zaakceptowanych zaproszeń.',
      TOTAL_LUMINAIRES: 'Łączna liczba opraw.',
      TOTAL_SYSTEMS: 'Łączna liczba systemów.',
      UPDATING_PROFILE: 'Aktualizowanie Twojego Profilu...',
      VIEW_ALL: 'Pokaż Wszystko',
      VIEW_ALL_ACCESS_RIGHTS: 'Pokaż Wszystkie Prawa Dostępu',
      VIEW_ALL_BUIDINGS: 'Pokaż Wszystkie Budynki',
      VIEW_ALL_SYSTEM: 'Pokaż Wszystkie Systemy',
      WARNING: 'Ostrzeżenie',
      INVITATION_SUB_HEADING: 'Zostałeś zaproszony do następujących projektów:',
      REPORTS_BUILDINGS: 'Budynki',
      REPORTS_SYSTEMS: 'Systemy',
      EMPTY_ZONE: 'Pusty',
      TEST_ZONE: 'Test',
},
    TRANSFER_BUILDINGS: {
      PASSWORD: 'Hasło do Konta',
      ERRORMESSAGE: 'Przekroczono limit prób logowania. Spróbuj ponownie później.',
      HEADER: 'Na stałe przenieś wszystkie {{buildingCount}} budynki, w tym wszystkie bramki X i {{systemCount}} systemy pod nie, do innej organizacji. Musisz być administratorem organizacji w obu organizacjach, aby wykonać tę akcję.',
      ACTION: 'Wpisz hasło do swojego konta, aby potwierdzić akcję.',
      TRANSFER_TO: 'Przenieś do...',
},
    MERGE_ASSETS: {
      PASSWORD: 'Hasło do Konta',
      MERGE_DELETE: 'Scal i Usuń',
      MERGE_ASSETS_TITLE: 'Scal zasoby do innego budynku',
      SUCCESS: 'Pomyślnie scalono zasoby budynku',
      ACTION: 'Wpisz hasło do swojego konta, aby potwierdzić akcję.',
      HEADER: 'Przenieś wszystkie {{gateway Count}} bramki i {{systems Count}} systemy do innego budynku i trwale usuń bieżący.',
      TRANSFER_TO: 'Przenieś do...',
},
    DRAWER: {
      ACCOUNTPREFERENCES: 'Preferencje Konta',
      RIGHTS_RESERVED: 'Wszelkie Prawa Zastrzeżone',
      ASSETS: 'Zasoby',
      COPYRIGHT: 'Prawa autorskie © Eaton',
      DASHBOARD: 'Pulpit',
      OVERVIEW: 'Pulpit',
      DEVICES: 'Urządzenia',
      HELP: 'Pomoc',
      HELPANDFEEDBACK: 'Pomoc i informacja zwrotna',
      LEGAL: 'Legalne',
      LOCATIONS: 'Lokalizacje',
      LOGBOOK: 'Dziennik',
      MAINTENANCE: 'Konserwacja',
      MANAGELOCATION: 'Zarządzaj Lokalizacjami i Witrynami',
      MANAGEUSER: 'Zarządzaj Użytkownikami',
      ORGSETTINGS: 'Moje Organizacje',
      MYPROFILE: 'Mój Profil',
      EMERGENCY_LIGHT: 'Obsługiwane przez Brightlayer',
      REPORTS: 'Raporty',
      ELDIGITAL: 'Uruchom Test Funkcjonalny',
      SELECT_ACCOUNT: 'Wybierz Konto',
      SETTINGS: 'Ustawienia',
      TIMELINE: 'Oś Czasu.',
      USERS: 'Użytkownicy',
},
    SETTINGS: {
      TITLE: 'Preferencje Konta',
      SUBTITLE: 'Poziom Administratora - Użytkownicy',
},
    NAVIGATION_DRAWER: {
      ACCOUNT_PREFERENCES: 'Preferencje Konta',
      ALL_RIGHTS_RESERVED: 'Wszelkie Prawa Zastrzeżone',
      CHANGE_PASSWORD: 'Zmień Hasło',
      COPYRIGHT: 'Prawa autorskie',
      HELP_AND_FEEDBACK: 'Pomoc i informacja zwrotna',
      LEGAL: 'Legalne',
      LOGOUT: 'Wyloguj się',
      PROJECT_SETTINGS: 'Moje Organizacje',
      REPORTS: 'Raporty',
      USERS: 'Użytkownicy',
},
    USER_MENU: {
      ACCOUNT_SETTING: 'Ustawienia Konta',
      CONTACT_US: 'Skontaktuj się z nami',
      LOG_OUT: 'Wyloguj się',
},
    USER_DETAIL: {
      ACTIVE: 'AKTYWNY',
      COMPANY_ADRESS: 'Adres Firmy',
      COMPANY_DETAIL: 'Szczegóły Firmy',
      COMPANY_NAME: 'Nazwa Firmy',
      COMPANY_PHONE_NUMBER: 'Numer Telefonu Firmy',
      EMAIL_ID: 'Adres E-mail',
      INACTIVE: 'NIEAKTYWNY',
      PERSONAL_ADRESS: 'Nazwa stanowiska pracy',
      LEAVE_ORGANISATION: 'Opuść Organizację',
      JOB_TITLE: 'Adres Osobisty',
      PERSONAL_PHONE_NUMBER: 'Numer Telefonu Osobistego',
      PHONE_NUMBER: 'Numer Telefonu',
      REMOVE_USER: 'Usuń Użytkownika',
      USER_NAME: 'Nazwa Użytkownika',
},
    FILTER: {
      ACTIVE_LOGS_ONLY: 'Tylko Aktywne Logi',
      ALL: 'Wszystkie',
      ALL_LOG_TYPES: 'Wszystkie Rodzaje Logów',
      CUSTOM: 'Niestandardowe...',
      PAST_TWELVE_MONTHS: 'Ostatnie 12 miesięcy',
      PAST_SIX_MONTHS: 'Ostatnie 6 miesięcy',
      SINCE_THE_BEGINNING_OF_YEAR: 'Od Początku {{currentyear}}',
},
    LOGBOOK: {
      LOGBOOK_ACTIVELOG: 'Tylko Aktywne Logi',
      LOGBOOK_ALL: 'Wszystkie',
      LOGBOOK_ALLLOG: 'Wszystkie Rodzaje Logów',
      CUSTOM_LOGBOOK_RANGE: 'Niestandardowy Zakres Dziennika',
      CUSTOM: 'Niestandardowe...',
      END_DATE: 'Data Zakończenia',
      LOGBOOK_GROUPBY: 'Grupuj Według:',
      PAST_TWELVE_MONTHS: 'Ostatnie 12 miesięcy',
      PAST_SIX_MONTHS: 'Ostatnie 6 miesięcy',
      FILTER_DOWNLOAD_TEXT: 'Zastosuj filtr, aby pobrać dziennik.',
      LOGBOOK_SHOW: 'Pokaż:',
      SINCE_THE_BEGINNING_OF_YEAR: 'Od Początku {{currentyear}}',
      START_DATE: 'Data Rozpoczęcia',
      LOGBOOK_TIME_RANGE: 'Zakres Czasu:',
},
    BUILDING_DETAILS: {
      ADD_BUILDING: 'Dodaj Budynek do',
      ALL_SYSTEMS: 'Wszystkie Systemy',
      VIEW_ALL_GATEWAYS: 'Pokaż Wszystkie Bramki',
},
    ADD_ORGANIZATION: {
      ORG_ADD_DESCRIPTION: 'Dodaj opcjonalne dodatkowe komentarze, aby pomóc Twojemu zespołowi serwisowemu.',
      ADDITIONAL_DESC: 'Dodatkowy Opis',
      ORG_ADD_BLDG_BELONGS: 'należy do',
      CREATE_ORGANIZATION_TITLE: 'Utwórz Organizację',
      ORG_SUBTITLE: 'Tworzenie organizacji pozwala grupować budynki i koordynować nadzór nad systemami EL.',
      DETAILS_FOR: 'Szczegóły dla',
      ORG_FOR: 'dla',
      INVALID_CHARACTER: 'Nieprawidłowy znak',
      ORG_NAMELENGTH: 'Tylko litery(+), cyfry(+), podkreślenia i myślniki(-)',
      ORG_ADD_BLDG: 'Teraz dodajmy budynek, w którym',
      ORGANIZATION_CREATED: 'Organizacja Utworzona',
      VALID_EMAIL_ERROR: 'Wprowadź prawidłowy e-mail',
      ORG_PRIMARYCONTACT: 'Główny Kontakt',
      ORG_PROVIDED_DETAILS: 'Podaj szczegóły, jeśli xxx jest konieczne.',
      ORG_SECONDARYCONTACT: 'Drugorzędny Kontakt (Opcjonalnie)',
      ORG_SKIPBUTTON: 'Pomiń Teraz',
      ORG_SKIPMESSAGE: 'Pomiń, aby wypełnić szczegóły kontaktu osobno dla każdego budynku.',
      ORG_SUCCESS: 'Organizacja utworzona pomyślnie',
      ALPHABET_INPUT: 'Akceptuje Alfabet jako Dane Wejściowe',
      ALPHANUMERIC_INPUT: 'Akceptuje Alfanumeryczne jako Dane Wejściowe',
      ALPHANUMERIC_DASH_UNDERSCORE_INPUT: 'Akceptuje Alfanumeryczne, myślnik, podkreślenie jako Dane Wejściowe',
      ORG_HELPTEXT: 'To pomaga elektrykom z Eaton i innym spoza twojej firmy szybko dotrzeć na miejsce.',
      ORGANIZATION_DETAILS: 'Do kogo powinni się zgłosić elektrycy w sprawie',
},
    MANAGE_USERS: {
      ADVANCED_INVITE_USER_ORGANIZATION_SELECTION: 'Dodaj ich do organizacji:',
      INVITE_USER_ORGANIZATION_LABEL: 'Dodaj do organizacji... *',
      USER_ROLE_ADMIN: 'Administrator',
      ADVANCED_INVITE_ADMIN: 'Administrator:',
      ADVANCED_INVITE: 'Zaawansowane Zaproszenie',
      INVITE_USER_ADVANCE: 'Zaawansowane...',
      INVITE_USER_AS: 'Jako',
      ADVANCED_INVITE_USER_SELECTION: 'Wybierz nowego lub istniejącego użytkownika:',
      INVITE_USER_EMAIL_NAME: '**E-mail * **',
      INVITE_USER_EMAIL: '**E-mail * **',
      INVITE_USER_EMAIL_USER_NAME: '**E-mail lub Nazwa Użytkownika * **',
      INVITE_USER_SUBTITLE: 'Przyznaj dostęp nowym lub istniejącym użytkownikom',
      ADVANCED_INVITE_SUBTITLE: 'Przyznaj dostęp do określonych organizacji, budynków i systemów.',
      ADVANCED_INVITE_ADMIN_DESCRIPTION: 'Przyznaj pełen dostęp do wszystkiego w przypisanym poziomie.',
      ADVANCED_INVITE_LIMITED_DESCRIPTION: 'Przyznaj minimalne uprawnienia podglądu, aby użytkownik widział jedynie podstawowe informacje istotne dla swojej roli. Jest to przydatne, gdy ktoś musi monitorować tylko jeden system w budynku.',
      ADVANCED_INVITE_VIEWER_DESCRIPTION: 'Przyznaj uprawnienia podglądu do wszystkiego w przypisanym poziomie.',
      INVITATION_FAIL_HEADER: 'Zaproszenie Wygasło',
      INVITE_USER_AS_COLLEAGUE: 'Zaproś jako współpracownika',
      INVITE_USER: 'Zaproś Użytkownika',
      INVITE_SUCCESS_MESSAGE_SINGLE: 'Zaproszono {{email}} do {{organization}}.',
      INVITE_SUCCESS_MESSAGE_MULTIPLE: 'Zaproszono {{email}} do {{organizationCount}} organizacji.',
      USER_ROLE_LIMITED: 'Ograniczony',
      ADVANCED_INVITE_LIMITED: 'Ograniczony:',
      MY_DETAILS_HEADER: 'Moje Szczegóły',
      OTHER_USER_LIST_HEADER: 'Inni Użytkownicy',
      ADVANCED_INVITE_PLEASE_ASSIGN_ROLES: 'Przypisz role dla dostępu {{email}} do organizacji, budynków i systemów.',
      REMOVE_USER: 'Usuń {{name}} z "{{title}}" ?',
      INVITATION_REQUEST_ACTION: 'Zażądaj Kolejnego Zaproszenia',
      INVITE_USER_ORGANIZATION_SELECT_ALL: 'Wybierz Wszystkie',
      INVITE_USER_SEND_INVITE: 'Wyślij Zaproszenie',
      INVITATION_FAIL_BODY: 'Link zaproszenia e-mail wygasł. Proszę skontaktować się z administratorem systemu, aby uzyskać nowe zaproszenie.',
      USERS_IN_HEADER: 'Użytkownicy w',
      USER_ROLE_VIEWER: 'Przeglądający',
      ADVANCED_INVITE_VIEWER: 'Przeglądający:',
},
    ORGANIZATION_DETAILS: {
      ADDRESS: 'Adres',
      BUILDING_DETAILS: 'Szczegóły Budynku',
      DELETE_FOREVER: 'Usuń Na Zawsze',
      EDIT_BUILDING: 'Edytuj Budynek',
      EDIT_ORGANIZATION: 'Edytuj Organizację',
      EMAIL_ADDRESS: 'Adres E-mail',
      MERGE_ASSETS: 'Scal Zasoby do Innego Budynku',
      ORGANIZATION: 'Organizacja',
      ORGANIZATION_DETAILS: 'Szczegóły Organizacji',
      PHONE_NUMBER: 'Numer Telefonu',
      PRIMARY_CONTACT: 'Główny Kontakt',
      PRIMARY_CONTACT_EMAIL_ADDRESS: 'Adres E-mail Głównego Kontaktu',
      PRIMARY_CONTACT_PHONE_NUMBER: 'Numer Telefonu Głównego Kontaktu',
      SECONDARY_CONTACT: 'Drugorzędny Kontakt',
      SECONDARY_CONTACT_EMAIL_ADDRESS: 'Adres E-mail Kontaktu Drugorzędnego',
      SECONDARY_CONTACT_PHONE_NUMBER: 'Numer Telefonu Kontaktu Drugorzędnego',
      TRANSFER_BUILDINGS: 'Przenieś Budynki do Innej Organizacji.',
      USERS: 'Użytkownicy',
},
    COMMON_INPUT: {
      COMMON_ADDRESS: 'Adres',
      COMMON_ADDRESSLINE2: 'Linia Adresu 2 (Opcjonalnie)',
      COMMON_BUILDINGNAME: 'Nazwa Budynku',
      COMMON_CITY: 'Miasto',
      COMMON_COUNTRY: 'Kraj',
      COMMON_OPTIONALDESC: 'Opis (Opcjonalnie)',
      COMMON_EMAIL_ADDRESS: 'Adres E-mail',
      COMMON_NAME: 'Nazwa Organizacji',
      COMMON_PHONENUMBER: 'Numer Telefonu',
      VALID_ADDRESS: 'Wprowadź prawidłowy adres',
      VALID_PHONE_ERROR: 'Wprowadź prawidłowy numer telefonu',
      VALID_POSTAL_CODE: 'Wprowadź prawidłowy kod pocztowy',
      VALID_CITY_ERROR: 'Wprowadź prawidłowe miasto',
      VALID_COMPANY_ERROR: 'Wprowadź prawidłową firmę',
      VALID_FIRSTNAME_ERROR: 'Wprowadź prawidłowe imię',
      VALID_LASTNAME_ERROR: 'Wprowadź prawidłowe nazwisko',
      VALID_VERIFICATION_CODE: 'Wprowadź prawidłowy kod weryfikacyjny',
      COMMON_POSTALCODE: 'Kod Pocztowy',
},
    TOAST_MSG: {
      CREATE_CUSTOMER_ERROR_CODE_9069: 'Adres jest nieprawidłowy lub długość nie powinna przekraczać 250 znaków.',
      CREATE_CUSTOMER_ERROR_CODE_9070: 'Adres2 jest nieprawidłowy lub długość nie powinna przekraczać 250 znaków.',
      INVITE_TECHNICIAN_ERROR_CODE_9130: 'Prawa Administratora są wymagane, aby zaprosić użytkownika',
      INVITE_USER_ERROR_CODE_9130: 'Prawa Administratora są wymagane, aby zaprosić użytkownika.',
      TOAST_ERROR_MERGE_ASSET_9213: 'Prawa Administratora są wymagane do scalania zasobów.',
      TOAST_SUCCESS_BUILDING_CREATE: 'Budynek został utworzony pomyślnie',
      BUILDING_LIST_API_FAILURE: 'Niepowodzenie listy budynków',
      BUILDING_TRANSFER_FAILURE: 'Wystąpił błąd podczas przenoszenia budynku',
      BUILDING_TRANSFER_SUCCESS: 'Przenoszenie budynku zakończone sukcesem',
      TOAST_SUCCESS_BUILDING_UPDATE: 'Budynek został zaktualizowany pomyślnie',
      INVITE_USER_ERROR_CODE_9143: 'Nie można obniżyć poziomu roli użytkownika.',
      CREATE_CUSTOMER_ERROR_CODE_9072: 'Miasto jest nieprawidłowe lub długość nie powinna przekraczać 50 znaków',
      CREATE_CUSTOMER_ERROR_CODE_9164: 'Nazwa firmy jest nieprawidłowa. Należy pamiętać, że nazwa firmy nie może mieć więcej niż 255 znaków.',
      CREATE_CUSTOMER_ERROR_CODE_9040: 'Kod kraju firmy jest nieprawidłowy',
      CREATE_CUSTOMER_ERROR_CODE_9170: 'Nazwa firmy już dostępna.',
      CREATE_CUSTOMER_ERROR_CODE_9023: 'Numer telefonu firmy jest nieprawidłowy lub długość powinna wynosić od 8 do 10',
      CREATE_CUSTOMER_ERROR_CODE_9073: 'Kod kraju jest nieprawidłowy lub jego długość nie powinna przekraczać 4 znaków.',
      CREATE_CUSTOMER_ERROR_CODE_9068: 'Kraj jest nieprawidłowy lub jego długość nie powinna przekraczać 50 znaków.',
      CREATE_MAINTAINANCE_API_FAILURE: 'Nie udało się utworzyć interfejsu API dla konserwacji',
      TOAST_SUCCESS_CUSTOMER_CREATED: 'Pomyślnie utworzono klienta',
      CUSTOMER_DETAIL_SUCCESS: 'Szczegóły klienta pobrano pomyślnie',
      TOAST_ERROR_GET_CUSTOMER_INFO: 'Niepowodzenie w pobraniu szczegółów klienta',
      CREATE_CUSTOMER_ERROR_CODE_9225: 'Numer Klienta już istnieje.',
      CREATE_CUSTOMER_ERROR_CODE_9172: 'Numer Klienta jest nieprawidłowy lub jego długość powinna wynosić od 8 do 16 znaków.',
      CREATE_MAINTAINANCE_ERROR_CODE_9078: 'Opis jest nieprawidłowy lub jego długość nie powinna przekraczać 255 znaków.',
      DEVICE_LIST_API_FAILURE: 'Niepowodzenie listy urządzeń',
      ACKNOWLEDGE_LOG_SUCCESS: 'Szczegóły dziennika urządzenia potwierdzone pomyślnie',
      CREATE_CUSTOMER_ERROR_CODE_9043: 'Adres e-mail jest nieprawidłowy lub jego długość nie powinna przekraczać 75 znaków.',
      INVITE_TECHNICIAN_ERROR_CODE_9043: 'Adres e-mail jest nieprawidłowy lub jego długość nie powinna przekraczać 75 znaków.',
      INVITE_USER_ERROR_CODE_9043: 'Adres e-mail jest nieprawidłowy lub jego długość nie powinna przekraczać 75 znaków.',
      INVITE_TECHNICIAN_ERROR_CODE_9136: 'Nieważny! Dane wejściowe nie odpowiadają roli użytkownika',
      INVITE_USER_ERROR_CODE_9136: 'Nieważny! Dane wejściowe nie odpowiadają roli użytkownika',
      INVITE_TECHNICIAN_ERROR_CODE_9127: 'Identyfikator jest zduplikowany lub nieprawidłowy.',
      INVITE_USER_ERROR_CODE_9127: 'Identyfikator jest zduplikowany lub nieprawidłowy.',
      TOAST_ERROR_BUILDING_UPDATE: 'Nie udało się zaktualizować budynku',
      CREATE_MAINTAINANCE_ERROR_CODE_9219: 'Nazwa pliku jest nieprawidłowa lub jej długość nie powinna przekraczać 50 znaków.',
      TOAST_ERROR_GET_PASS_DETAILS: 'Nie udało się pobrać szczegółów PAAS API',
      REMOVE_ACCESS_ERROR_CODE_3057: 'Nieprawidłowe dane wejściowe.',
      REMOVE_ACCESS_ERROR_CODE_3059: 'Nieprawidłowy typ encji. Proszę podać prawidłowy typ encji.',
      TOAST_ERROR_LINK_CUSTOMER_9203: 'Nieprawidłowy typ umowy serwisowej',
      REMOVE_ACCESS_ERROR_CODE_2007: 'Nieprawidłowy identyfikator użytkownika, proszę podać prawidłowy GUID',
      INVITE_TECHNICIAN_ERROR_CODE_9159: 'Zaproszony i zapraszający użytkownik nie mogą być tym samym.',
      INVITE_USER_ERROR_CODE_9159: 'Zaproszony i zapraszający użytkownik nie mogą być tym samym.',
      UPDATE_LOG_COMMENTS_SUCCESS: 'Komentarze dziennika zaktualizowane pomyślnie',
      ACKNOWLEDGE_LOG_API_FAILURE: 'Potwierdzenie dzienników nieudane',
      CREATE_MAINTAINANCE_SUCCESS: 'Działania konserwacyjne utworzone pomyślnie',
      TOAST_ERROR_MERGE_ASSET_9214: 'Brak zasobów do połączenia',
      CREATE_MAINTAINANCE_ERROR_CODE_9221: 'Liczba dokumentów powinna wynosić maksymalnie 3',
      TOAST_SUCCESS_ORG_CREATE: 'Organizacja utworzona pomyślnie',
      TOAST_ERROR_ORG_UPDATE: 'Niepowodzenie Organizacji',
      TOAST_SUCCESS_ORG_UPDATE: 'Organizacja zaktualizowana pomyślnie',
      CREATE_CUSTOMER_ERROR_CODE_9074: 'Numer telefonu jest nieprawidłowy lub długość powinna wynosić od 8 do 10 cyfr.',
      TOAST_ERROR_MESSAGE: 'Uzupełnij wszystkie szczegóły przed wysłaniem',
      CREATE_MAINTAINANCE_ERROR_CODE_9220: 'Podaj prawidłowy identyfikator użytkownika technika przypisanego do sprawy',
      TOAST_ERROR_MERGE_ASSET_9048: 'Podaj prawidłowy identyfikator budynku',
      CREATE_CUSTOMER_ERROR_CODE_9167: 'Podaj prawidłowy typ kontaktu',
      CREATE_MAINTAINANCE_ERROR_CODE_9185: 'Podaj prawidłowy identyfikator klienta',
      TOAST_ERROR_MERGE_ASSET_9210: 'Podaj prawidłowy identyfikator budynku docelowego',
      CREATE_MAINTAINANCE_ERROR_CODE_9217: 'Podaj prawidłowy link',
      CREATE_CUSTOMER_ERROR_CODE_9163: 'Podaj prawidłową nazwę lub długość nie większą niż 24 znaki',
      CREATE_MAINTAINANCE_ERROR_CODE_9215: 'Podaj prawidłowy typ żądania',
      CREATE_MAINTAINANCE_ERROR_CODE_9228: 'Podaj prawidłową datę usługi',
      CREATE_MAINTAINANCE_ERROR_CODE_9216: 'Podaj prawidłowy typ usługi',
      CREATE_MAINTAINANCE_ERROR_CODE_9050: 'Podaj prawidłowy identyfikator systemu',
      CREATE_CUSTOMER_ERROR_CODE_9071: 'Kod pocztowy jest nieprawidłowy lub długość powinna wynosić od 4 do 10 znaków.',
      CREATE_CUSTOMER_ERROR_CODE_9165: 'Komentarz głównego kontaktu jest nieprawidłowy lub długość powinna być mniejsza lub równa 255 znaków.',
      CREATE_CUSTOMER_ERROR_CODE_9175: 'Kod kraju głównego kontaktu jest nieprawidłowy lub długość powinna być mniejsza lub równa 4 znaki.',
      CREATE_CUSTOMER_ERROR_CODE_9150: 'Imię głównego kontaktu jest nieprawidłowe lub długość powinna wynosić od 1 do 50 znaków.',
      CREATE_CUSTOMER_ERROR_CODE_9151: 'Nazwisko głównego kontaktu jest nieprawidłowe lub długość powinna wynosić od 1 do 50 znaków.',
      CREATE_CUSTOMER_ERROR_CODE_9173: 'Numer telefonu głównego kontaktu jest nieprawidłowy lub długość powinna wynosić od 8 do 10 cyfr.',
      REMOVE_ACCESS_SUCCESS: 'Użytkownik pomyślnie usunięty',
      TOAST_ERROR_MERGE_ASSET_9004: 'Nie znaleziono zażądanych danych',
      CREATE_CUSTOMER_ERROR_CODE_9166: 'Komentarz kontaktu drugorzędnego jest nieprawidłowy lub długość powinna być mniejsza lub równa 255 znaków.',
      CREATE_CUSTOMER_ERROR_CODE_9076: 'Kod kraju kontaktu drugorzędnego jest nieprawidłowy lub długość powinna być mniejsza lub równa 4 znaki.',
      CREATE_CUSTOMER_ERROR_CODE_9176: 'Drugi kod kraju, kontaktu drugorzędnego jest nieprawidłowy lub długość powinna być mniejsza lub równa 4 znaki.',
      CREATE_CUSTOMER_ERROR_CODE_9077: 'E-mail drugorzędny jest nieprawidłowy lub długość powinna być mniejsza lub równa 75 znaków.',
      CREATE_CUSTOMER_ERROR_CODE_9152: 'Imię kontaktu drugorzędnego jest nieprawidłowe lub długość powinna wynosić od 1 do 50 znaków.',
      CREATE_CUSTOMER_ERROR_CODE_9153: 'Nazwisko kontaktu drugorzędnego jest nieprawidłowe lub długość powinna wynosić od 1 do 50 znaków.',
      CREATE_CUSTOMER_ERROR_CODE_9147: 'Numer telefonu drugorzędnego jest nieprawidłowy lub długość powinna wynosić od 8 do 10 cyfr.',
      CREATE_CUSTOMER_ERROR_CODE_9174: 'Numer telefonu drugorzędnego jest nieprawidłowy lub długość powinna wynosić od 8 do 10 cyfr.',
      CREATE_MAINTAINANCE_ERROR_CODE_9009: 'Token bezpieczeństwa nie może być pusty ani nie może być wpisane zero.',
      CREATE_MAINTAINANCE_ERROR_CODE_9222: 'Uprawnienia Menedżera Serwisu są wymagane do utworzenia operacji konserwacyjnej',
      CREATE_MAINTAINANCE_ERROR_CODE_9162: 'Numer SLA jest nieprawidłowy lub długość powinna wynosić od 6 do 12 znaków.',
      INVITE_TECHNICIAN_ERROR_CODE_9158: 'Niektóre jednostki mają ograniczoną rolę od zaproszonych ról.',
      INVITE_USER_ERROR_CODE_9158: 'Niektóre jednostki mają ograniczoną rolę od zaproszonych ról.',
      INVITE_TECHNICIAN_ERROR_CODE_9160: 'Niektóre jednostki mają ograniczoną rolę w żądaniu zaproszenia.',
      INVITE_USER_ERROR_CODE_9160: 'Niektóre jednostki mają ograniczoną rolę w żądaniu zaproszenia.',
      TOAST_ERROR_MERGE_ASSET_9211: 'Identyfikatory budynków źródłowych i docelowych są takie same.',
      TOAST_ERROR_MERGE_ASSET_9212: 'Budynek źródłowy i docelowy nie są w tej samej organizacji.',
      TOAST_ERROR_LINK_CUSTOMER_9204: 'System już powiązany z ważnym SLA',
      INVITE_USER_ERROR_CODE_9223: 'Obecny użytkownik może wysyłać zaproszenia tylko do zwykłych użytkowników.',
      INVITE_USER_ERROR_CODE_9224: 'Obecny użytkownik nie może wysyłać zaproszeń do Menedżera Serwisu ani Menedżera PAAS.',
      CREATE_MAINTAINANCE_ERROR_CODE_9218: 'Rozmiar pliku przekracza 2 MB lub plik nie jest w formacie PDF, JPEG lub PNG.',
      REMOVE_ACCESS_ERROR_CODE_9001: 'Nieautoryzowany dostęp.',
      CREATE_CUSTOMER_ERROR_CODE_9001: 'Nieautoryzowany dostęp.',
      CREATE_MAINTAINANCE_ERROR_CODE_9001: 'Nieautoryzowany dostęp.',
      CREATE_CUSTOMER_ERROR_CODE_9000: 'Nieautoryzowany dostęp do funkcji.',
      UPDATE_LOG_COMMENTS_API_FAILURE: 'Nie udało się zaktualizować komentarzy w logu.',
      REMOVE_ACCESS_ERROR_CODE_3060: 'Użytkownik nie może usunąć swojego własnego dostępu.',
      TOAST_ERROR_UPDATE_USER_DETAILS: 'Aktualizacja szczegółów użytkownika nie powiodła się.',
      INVITE_USER_ERROR_CODE_9142: 'Użytkownik został zaproszony na tę samą rolę.',
      INVITE_TECHNICIAN_SUCCESS: 'Zaproszenie użytkownika wysłane pomyślnie.',
      TOAST_ERROR_MERGE_ASSET_9044: 'Hasło użytkownika jest nieprawidłowe lub długość powinna wynosić od 8 do 16 znaków.',
      INVITE_TECHNICIAN_ERROR_CODE_9190: 'Typ roli użytkownika jest nieprawidłowy.',
      INVITE_USER_ERROR_CODE_9190: 'Typ roli użytkownika jest nieprawidłowy.',
      TOAST_SUCCESS_UPDATE_USER_DETAILS: 'Użytkownik zaktualizowany pomyślnie.',
      UPDATE_MAINTAINANCE_SUCCESS: 'Proces aktualizacji zakończony sukcesem',
      UPDATE_MAINTAINANCE_ERROR_CODE_9001: 'Nieautoryzowany dostęp.',
      UPDATE_MAINTAINANCE_ERROR_CODE_9009: 'Token bezpieczeństwa nie może być pusty ani null.',
      UPDATE_MAINTAINANCE_ERROR_CODE_9078: 'Opis jest nieprawidłowy lub jego długość powinna być mniejsza lub równa 255 znaków.',
      UPDATE_MAINTAINANCE_ERROR_CODE_9222: 'Do wykonania tej operacji wymagane są prawa Menedżera Serwisu lub Technika.',
      UPDATE_MAINTAINANCE_ERROR_CODE_9227: 'Podaj prawidłowy identyfikator konserwacji.',
      UPDATE_MAINTAINANCE_ERROR_CODE_9245: 'Działanie konserwacyjne już ma ten sam bieżący status zgłoszenia, co wymagany do aktualizacji.',
      UPDATE_MAINTAINANCE_ERROR_CODE_9246: 'Limit ponownego otwarcia działania konserwacyjnego został osiągnięty.',
      UPDATE_MAINTAINANCE_API_FAILURE: 'Nie udało się zaktualizować API konserwacji.',
      TICKET_CLOSED_SUCCESS: 'Zgłoszenie serwisowe zostało pomyślnie zamknięte.',
},
    MY_ORGANIZATION_DETAILS: {
      ADDRESS_Line1: 'Linia Adresu 1',
      ADMINS: 'Administratorzy',
      DELETE_FOREVER: 'Usuń Na Zawsze',
      DESCRIPTION: 'Opis (Opcjonalnie)',
      EDIT_BUILDING: 'Edytuj Budynek',
      EDIT_ORGANIZATION: 'Edytuj Organizację',
      NAME_DESCRIPTION: 'Nazwa i Opis',
      SAVE_ORGANIZATION: 'Zapisz Organizację',
      TRANSFER_BULDING_ANOTHER_ORGANIZATION: 'Przenieś Budynki do innej Organizacji.',
      VIEWER: 'Przeglądający',
},
    INVITE_USER: {
      ADMIN: 'Administrator',
      ADVANCE_INVITATION: 'Zaawansowane zaproszenie',
      ADVANCE_INVITE: 'Zaawansowane...',
      ADVANCE_INVITE_CLOSE: 'Czy na pewno chcesz opuścić zaawansowane zaproszenie?',
      AS_ADMIN: 'Jako Administrator',
      AS_VIEWER: 'Jako Podglądający',
      BUILDING_ACCESS: 'Dostęp do Budynku',
      ENTER_USER_EMAIL: 'E-mail lub Nazwa Użytkownika',
      GRANT_ACCESS_HEADER: 'Przyznaj dostęp nowym lub istniejącym użytkownikom.',
      ADVANCE_DES_CONTENT: 'Przyznaj dostęp użytkownikom do określonych organizacji, budynków i systemów.',
      GRANT_ADMIN_ACCESS: 'Przyznaj pełen dostęp do wszystkiego w przypisanym poziomie.',
      GRANT_VIEW_ACCESS: 'Przyznaj uprawnienia podglądu do wszystkiego w przypisanym poziomie.',
      SEND_INVITE_FAILURE: 'Wysłanie zaproszenia nie powiodło się',
      SEND_INVITE_SUCCESS: 'Zaproszenie wysłane pomyślnie',
      INVITATION_ACCEPTED: 'Zaproszenie zaakceptowane pomyślnie.',
      INVITATION_DENIED: 'Zaproszenie odrzucone.',
      INVITE_AND_ASSIGN: 'Zaproś i Przypisz',
      INVITE_AS_COLLEGUE: 'Zaproś jako współpracownika',
      INVITE_USER: 'Zaproś Użytkownika',
      LIMITED: 'Ograniczony',
      GRANT_LIMITED_ACCESS: 'Minimalne uprawnienia, przydatne dla użytkownika, który musi monitorować tylko jeden system w budynku.',
      NOBUILDING_AVAILABLE: 'Brak Dostępnych Budynków',
      NOSYSTEMS_AVAILABLE: 'Brak Dostępnych Systemów',
      ORGANIZATION_ACCESS: 'Dostęp do Organizacji',
      SELECT_ORGANIZATION: 'Wybierz Organizację',
      PRIVILEGES: 'Uprawnienia',
      RECEIVED: 'Otrzymano',
      SEND_INVITE: 'Wyślij Zaproszenie',
      SENT_BY: 'Wysłane przez',
      SYSTEM_ACCESS: 'Dostęp do Systemu',
      VIEWER: 'Przeglądający',
      ERROR_MESSAGE: 'Twoje żądanie zakończyło się niepowodzeniem.',
},
    DISCLAMIER: {
      OVERVIEW: 'Liczba Alarmów przedstawia wszystkie aktywne alarmy',
      TIMELINE: 'Wyświetlane alarmy przedstawiają wszystkie alarmy z ostatnich 90 dni',
},
    LUMINARY_DETAILS: {
      ALL_ATSD: 'Wszystkie ATSD',
      ALL_CIRCUIT: 'Wszystkie Obwody',
      ALL_STATUSES: 'Wszystkie Statusy',
      ATSD: 'ATSD #',
      CIRCUIT: 'Obwód',
      LUMINAIRE_ADDRESS: 'Adres Oprawy Awaryjnej',
      MODEL: 'Model',
      TYPE: 'Typ.',
      TESTS: 'Testy',
      CIRCUIT_TITLE: 'Nr Obwodu',
      DURATION_TEST_DURATION: 'Czas trwania testu czasu podtrzymania',
      PREVIOUS_DURATION_TEST_STARTED: 'Poprzedni Test Czasu Trwania Rozpoczęty',
      PREVIOUS_FUNCTIONAL_TEST_STARTED: 'Poprzedni Test Funkcjonalny Rozpoczęty',
},
    SEARCH: {
      ALL_BUILDINGS: 'Wszystkie Budynki',
      ALL_GATEWAYS: 'Wszystkie Bramki',
      ALL_ORGANIZATIONS: 'Wszystkie Organizacje',
      ALL_STATUSES: 'Wszystkie Statusy',
      ALL_SYSTEMS: 'Wszystkie Systemy',
      ALL_TYPES: 'Wszystkie Typy',
},
    CUSTOMER_DETAILS: {
      ALL_USERS: 'Wszyscy Użytkownicy',
      DELETE_SLA: 'Czy na pewno chcesz usunąć umowę konserwacyjną?',
      BACK_UP_PHONE: 'Telefon Zapasowy',
      BUYER_HEADER: 'Kupujący',
      BUYER: 'Kupujący',
      CONTACT_TYPE: 'Typ Kontaktowy',
      CONTACT_PERSON_ON_SITE: 'OsobaKontaktowaNaMiejscu',
      CUSTOMER_HEADER_SUBTITLE: 'Klient',
      CUSTOMER_ID: 'ID Klienta',
      CUSTOMER_NAME: 'Nazwa Klienta',
      CUSTOMER_DETAILS_HEADER: 'Nazwa i Adres Klienta',
      CUSTOMER_NAME_LABEL: 'Nazwa lub numer klienta',
      CUSTOMER_NUMBER: 'Numer Klienta',
      DELETE_CUSTOMER: 'Usuń Klienta',
      LUMINARY_INFO: 'Czy ta umowa obejmuje monitorowanie opraw oświetleniowych?',
      EDIT_CUSTOMER_INFO: 'Edytuj Informacje o Kliencie',
      CREATE_CUSTOMER_HEADER: 'Edytuj Informacje o Kliencie',
      EDIT_PLATFORM_INFO: 'Edytuj Informacje o Platformie',
      EDIT_SLA_DETAILS: '-',
      EXPIRES: 'Wygasa',
      IMAGES: 'Obrazy',
      INCLUDE_LUM_MONITORING: 'Uwzględnij monitorowanie opraw oświetleniowych',
      SLA_DETAILS_TEXT: 'Oprawa awaryjna posiada monitoring',
      CALENDAR_HELPER_TEXT: 'mm/dd/yyyy',
      MOBILE_NUMBER: 'Numer Telefonu Komórkowego',
      LUMINARY_MONITORING_NO: 'Nie',
      NO_CUSTOMER_FOUND: 'Nie Znaleziono Klienta',
      NO_SERVICE_MANAGER_FOUND: 'Nie Znaleziono Menedżera Serwisowego',
      NO_TECHNICIAN_FOUND: 'Nie Znaleziono Technika',
      CUSTOMER_NUMBER_HELPER_TEXT: 'Tylko litery i cyfry',
      SLA_NUMBER_HELPER_TEXT: 'Tylko litery i cyfry',
      OFFICE_NUMBER: 'Numer Biura',
      IMAGE_REQUIREMENTS: 'PNG, JPG (100x100px), 2 MB Max.',
      PHONE_NUMBERS_HEADER: 'Główne i Zapasowe Numery Telefonów',
      PRIMARY_CONTACT_INFO: 'Informacje o Głównym Kontakcie',
      PROJECT_LEAD: 'LiderProjektu',
      REMOVE_IMAGE: 'Usuń Obraz',
      SECONDARY_CONTACT_INFO: 'Informacje o Kontakcie Drugorzędnym',
      FILE_RESOLUTION_ERROR: 'Wybrany plik nie spełnia wymaganej rozdzielczości',
      FILE_SIZE_ERROR: 'Rozmiar wybranego pliku przekracza maksymalny dopuszczalny rozmiar',
      SERVICE_MANAGER: 'Menedżer Serwisu',
      SLA_CUSTOMER_NUMBER: 'Numer Klienta SLA',
      SLA_DETAILS_HEADER: 'Szczegóły SLA',
      SLA_EXPIRATION_DATE: 'Data Wygaśnięcia SLA',
      TECH_LEAD_HEADER: 'Lider Techniczny',
      TECHNICAL_PERSON: 'Osoba Techniczna',
      UPLOAD_AVATAR_LOGO: 'Prześlij Logo Awatara',
      LUMINARY_MONITORING_YES: 'Tak',
      REQUIRED_FIELD_MESSAGE: 'Pola oznaczone gwiazdką (*) są wymagane',
},
    USER_MANAGEMENT: {
      ALL_USERS: 'Wszyscy Użytkownicy',
      INVITE_USER: 'Zaproś Użytkownika',
      YOUR_DETAILS: 'Twoje szczegóły.',
},
    USERDETAILS: {
      DELETE_USER_SUBHEADER: 'Wszystkie dane użytkownika zostaną trwale utracone.',
      RESET_PASSWORD_ERROR: 'Nie można zresetować hasła w tej chwili.',
      DELETE_USER_BUTTON_TEXT: 'Usuń Konto na Zawsze',
      DELETE_USER_FAILURE_MSG: 'Nie udało się usunąć, spróbuj ponownie później',
      DELETE_USER_POP_UP_HEADER: 'Na stałe usuń konto „{{email}}”?',
      RESET_PASSWORD_SUCCESS: 'E-mail do resetowania hasła wysłany pomyślnie.',
      EDIT_SUCCESS: 'Użytkownik zaktualizowany pomyślnie.',
      DELETE_USER_SUCCESS_MSG: 'Twoje konto zostało pomyślnie usunięte.',
},
    ATPLUS_LOGBOOK_EVENTNAME: {
      MAXIMUM_LOGIN_ATTEMPTS_EXCEDDED: 'Przekroczono Dopuszczalną Liczbę Prób Logowania',
      BATTERY_CHARGE_FAILURE: 'Wykryto Błąd Ładowania Baterii',
      BATTERY_DURATION_FAILURE: 'Wykryto Awarię Czasu Trwania Baterii',
      TLAT_PLUS_BATTERY_FAILURE: 'Awaria Baterii',
      TLAT_PLUS_BATTERY_LOW: 'Niski Poziom Baterii',
      COMMUNICATION_FAILURE: 'Wykryto Awarię Komunikacji',
      DRY_CONTACT_INPUT: 'Wejście bezpotencjałowego styku aktywowane',
      DRY_CONTACT_OUTPUT: 'Wyjście bezpotencjałowego styku aktywowane',
      MANUAL_DURATION_TEST: 'Rozpoczęcie testu czasu podtrzymania',
      MANUAL_DURATION_TEST_CANCELED: 'Zatrzymanie testu czasu podtrzymania',
      FACTORY_RESET: 'Reset do Ustawień Fabrycznych',
      FAILURE_THRESHOLD_EXCEEDED: 'Przekroczono Próg Awarii',
      FIRMWARE_UPDATE_FAILURE: 'Aktualizacja oprogramowania sprzętowego nie powiodła się',
      FIRMWARE_UPDATE_SUCCESS: 'Aktualizacja oprogramowania sprzętowego zakończona sukcesem',
      MANUAL_FUNCTION_TEST: 'Test Funkcjonalny Rozpoczęty',
      MODBUS_COMMUNICATION_FAILURE: 'Awaria Komunikacji Bramki',
      UART_COMMUNICATION_FAILURE: 'Awaria Wewnętrzna',
      LAMP_FAILURE: 'Wykryto Awarię Oprawy',
      LOCAL_MAIN_FAILURE: 'Awaria Głównego Zasilania Lokalnego',
      PASSWORD_CHANGE: 'Zmiana Hasła',
      PASSWORD_RESET: 'Resetowanie hasła',
      MANUAL_RELIGHT_COMMAND: 'Ponowne zapalenie aktywowane',
      MANUAL_REST_COMMAND: 'Tryb Spoczynku Aktywowany',
      SEARCH_ALL_LAMP_COMPLETED: 'Zakończono wyszukiwanie wszystkich opraw',
      SEARCH_NEW_LAMP_COMPLETED: 'Wyszukiwanie nowej oprawy awaryjnej zakończone',
      MANUAL_SYNCHRONIZE_TEST_TIME_COMMAND: 'Synchronizuj Czas Testów',
      ACTIVATION: 'Aktywacja Systemu Zakończona',
      SYSTEM_POWER_DOWN: 'Wyłączenie Systemu',
      SYSTEM_POWER_UP: 'Włączenie Systemu',
      DATALINE_FAILURE: 'Błąd Linii Komunikacyjnej TLAT+.',
      MANUAL_START_VISIBILITY_PLUS: 'Widoczność+ Rozpoczęta',
      MANUAL_STOP_VISIBILITY_PLUS: 'Widoczność+ Zatrzymana',
},
    MY_ORGANIZATION: {
      ALPHABET: 'Alfabet',
      CITY: 'Miasto',
      NUMBER_SYSTEM: 'Liczba Systemów',
},
    FIRMWARE_UPDATE: {
      FIRMWARE_UPDATE_ALERT_TITILE: 'Czy na pewno chcesz wyjść?',
      CURRENT_VERSION: 'Aktualna Wersja',
      FIRMWARE_ALREADY_UPDATED: 'Oprogramowanie sprzętowe zostało zaaktualizowanie',
      FIRMWARE_UPDATE_FAILED_TITLE: 'Aktualizacja oprogramowania sprzętowego nie powiodła się',
      FIRMWARE_PROGRESS_MSG: 'Trwa aktualizacja oprogramowania sprzętowego...',
      FIRMWARE_UPDATE_ALERT_SUB_TITILE: 'Aktualizacja oprogramowania sprzętowego jest nadal w toku. Czy chcesz przejść do pulpitu nawigacyjnego?',
      FIRMWARE_UPDATE_FAILED: 'Proces aktualizacji oprogramowania sprzętowego nie powiódł się. Spróbuj ponownie.',
      FIRMWARE_VERSION_UPDATED: 'Aktualizacja oprogramowania sprzętowego zakończona sukcesem',
      FIRMWARE_ALREADY_UPDATED_TEXT: 'Wersja oprogramowania sprzętowego została już zaktualizowana do najnowszej wersji',
      FIRMWARE_NOT_AVAILABLE: 'Wersja oprogramowania nie została poprawnie pobrana. Wyloguj się z aplikacji mobilnej i zaloguj, aby spróbować ponownie.',
      LATEST_VERSION: 'Najnowsza Wersja',
      LOST_BLUETOOTH_CONNECTION: 'Utracono Połączenie Bluetooth',
      ENTRY_PASSWORD: 'Wprowadź hasło systemu dla',
      RELEASED_ON: 'Zwolniono ',
      SELECT_FIRMWARE_VERSION: 'Wybierz Firmware -Version',
      SELECT_A_VERSION: 'Wybierz Wersję',
      UPDATE_TO_LATEST: 'Aktualizuj do najnowszej wersji.',
      UPLOAD_FILE: 'Prześlij Plik',
      FIRMWARE_UPDATE_TITILE: 'Zalecamy aktualizację oprogramowania firmware do najnowszej wersji.',
      FIRMWARE_UPDATEPOPUP_MSG: 'Nie masz już połączenia z',
},
    ASSETS: {
      ASSETS_DETAILS: 'Szczegóły Zasobów',
},
    SYSTEM_TYPE: {
      ATPLUS: 'AT+',
      CGLINE: 'CGLine+',
      DGS: 'DG-S',
      LPSMART: 'LPSmart',
      LPSTAR: 'LPStar',
      WIRELESS: 'Bezprzewodowe',
      ZBS: 'ZB-S',
      ATS_PLUS: 'AT-S+',
      GATEWAY: 'Bramka sieciowa',
},
    DEVICE_TYPE_VALUE: {
      AT: 'AT+',
      ATS: 'AT-S+',
      CGLINE: 'CGLINE',
      DGS: 'DG-S',
      LPSMART: 'LP-SMART',
      LPSTAR: 'LP-STAR',
      WIRELESS: 'BEZPRZEWODOWE',
      ZBS: 'ZB-S',
      ATSPLUS: 'AT+',
},
    CONTROLLER_TYPE_VALUE: {
      AT: 'AT+',
      CGLINE_PLUS: 'CGLINE+',
      DGS: 'DG-S',
      LP_SMART: 'LP-SMART',
      LP_STAR: 'LP-STAR',
      WIRELESS: 'BEZPRZEWODOWE',
      ZBS: 'ZB-S',
},
    ACTIONS: {
      BACK: 'Wróć',
      CANCEL: 'Anuluj',
      CHANGE_LANGUAGE: 'Zmień Język tutaj!',
      CLICK_BUTTON: 'Kliknij przycisk',
      UPDATE_REDUX: 'Kliknij przycisk, aby zaktualizować wartość sklepu redux!',
      CONFIRM: 'Potwierdź',
      CONTINUE: 'Kontynuuj',
      DELETE: 'Usuń',
      RESEND_VERIFICATION_EMAIL_LABEL: 'Nie otrzymałeś e-maila?',
      DISABLE: 'Wyłącz',
      DONE: 'Gotowe',
      DOWNLOAD_DATA: 'Pobierz Dane',
      EDIT: 'Edytuj',
      ENABLE: 'Włącz',
      EXTEND: 'Przedłuż',
      FINISH: 'Zakończ',
      GO_HOME: 'Przejdź do Strony Głównej',
      GO_TO_DASHBOARD: 'Przejdź do Mojego Pulpitu',
      GO_TEST: 'Przejdź do Strony Testowej',
      LOG_IN: 'Zaloguj się',
      LOG_OUT: 'Wyloguj się',
      NEXT: 'Dalej',
      OKAY: 'ok',
      QUIT: 'Wyjdź',
      REMEMBER: 'Zapamiętaj mnie',
      RETRY: 'Spróbuj Ponownie',
      SAVE: 'Zapisz',
      SAVE_ADD_ANOTHER: 'Zapisz i dodaj kolejny',
      SEND: 'Wyślij',
      RESEND: 'Wyślij Ponownie',
      RESEND_VERIFICATION_EMAIL: 'Wyślij Ponownie',
      SUBMIT: 'Prześlij',
      SUBMITCHANGES: 'Zatwierdź Zmiany',
      TRANSFER: 'Przenieś.',
      UPDATE: 'Aktualizuj.',
},
    NETWORK: {
      BAD_REQUEST_MESSAGE: 'Nieprawidłowe Żądanie',
      INTERNAL_SERVER_ERROR_MESSAGE: 'Błąd Serwera Wewnętrznego',
      NO_DATA_FOUND: 'Nie Znaleziono Danych',
      REQUEST_NOT_FOUND_MESSAGE: 'Nie Znaleziono',
      ERROR_INTERNET_CONNECTION: 'Wygląda na to, że nie masz połączenia z internetem, spróbuj ponownie.',
      SERVICE_UNAVAILABLE: 'Usługa Niedostępna',
      ERROR_NO_RESPONSE: 'Coś poszło nie tak',
      ERROR_MESSAGE_SENDING_REQUEST: 'Przepraszamy, wystąpił problem z wysłaniem twojego żądania.',
      ERROR_INVALID_REQUEST: 'Przepraszamy, twoje żądanie jest nieprawidłowe.',
      NETWORK_ALERT_SUBTITILE: 'Pulpit jest niedostępny\nponieważ nie jesteś już połączony\ndo internetu',
      ERROR_NOT_FOUND: 'Zasób nie został znaleziony.',
      ERROR_ALERT_TITLTE: 'Nie można połączyć Pulpitu.',
      UNAUTHORISED_REQUEST_MESSAGE: 'Nieautoryzowane - odmowa autoryzacji dla tego żądania.',
      ERROR_RESTRICTED_USER_ACCESS: 'Użytkownik nie ma dostępu do zasobu.',
},
    CONNECTION_TYPE_VALUE: {
      BLE: 'BLE',
      BLUETOOTH: 'Bluetooth',
      CELLULAR: 'Komórkowy',
      ETHERNET: 'Ethernet',
      MODBUS: 'Modbus',
      MQTT: 'MQTT',
      RS485: 'RS485',
      WIFI: 'Wifi',
      WIREPAS: 'Wirepas',
},
    STATUS: {
      STATUS_BLOCK: 'Zablokowane',
      BLOCKED: 'Zablokowane',
      STATUS_EMPTY: 'Pusty',
      STATUS_ERROR: 'Błąd',
      ERROR: 'Błąd',
      EVENT: 'Zdarzenie',
      DT: 'W DT',
      STATUS_DT: 'W Teście',
      INTEST: 'W Teście',
      STATUS_OFFLINE: 'Offline',
      STATUS_READY: 'Gotowy',
      READY: 'Gotowy',
      TOTAL_LUMINAIRES: 'Łączna liczba opraw.',
      TOTAL_SYSTEM: 'Łączna liczba systemów.',
      STATUS_WARNING: 'Ostrzeżenie',
      WARNING: 'Ostrzeżenie',
},
    UNSUPPORTED_BROWSER: {
      NOT_SUPPORTED: 'Przeglądarka nie jest obsługiwana',
      INCOMPATIBLE_BROWSER: 'Ta aplikacja internetowa nie jest zgodna z Twoją obecną przeglądarką.',
      RECOMMENDED_BROWSER: 'Aby móc korzystać z tego narzędzia, zalecamy uaktualnienie przeglądarki internetowej do najnowszej wersji.',
},
    ENTITY_TYPE: {
      BUILDING: 'Budynek',
      DEVICE: 'Urządzenie',
      DEVICE_TYPE: 'Typ Urządzenia',
      GATEWAY: 'Bramka sieciowa',
      LUMINARY: 'Oprawa awaryjna',
      MASTER_ROLE: 'Rola Główna',
      ORGANIZATION: 'Organizacja',
      ORGANIZATION_STATISTIC_DETAIL: 'Statystyczne Szczegóły Organizacji',
      PLATFORM: 'Platforma',
      SYSTEM: 'System',
      USER: 'Użytkownik',
},
    LOGSOURSE_DEVICE_TYPE: {
      BUILDING: 'Budynek',
      DEVICE: 'Urządzenie',
      DEVICETYPE: 'TypUrządzenia',
      GATEWAY: 'Bramka sieciowa',
      LUMINARY: 'Oprawa awaryjna',
      MASTERROLE: 'Rola Główna',
      ORGANIZATION: 'Organizacja',
      ORGANIZATIONSTATISTICALDETAIL: 'Statystyki Organizacji',
      SYSTEM: 'System',
      USER: 'Użytkownik',
},
    TECHNICIAN_DETAILS: {
      BUILD_ADMIN: 'Administrator Budynku',
      BUILD_VIEWER: 'Podgląd Budynku',
      CUST_VIEWER: 'Podgląd Klienta',
      INDIVIDUAL_DETAILS: 'Szczegóły Indywidualne',
      LIMT_ACCESS: 'Ograniczony Dostęp',
      ORG_ADMIN: 'Administrator Organizacji',
      ORG_VIEWER: 'Przeglądający Organizację',
      PASS_SERVICE_MANAGER: 'Przekaż Menedżera Serwisu',
      PROJ_OWNER: 'Właściciel Projektu',
      REMOVE_USER: 'Usuń Użytkownika',
      SERVICE_MANAGER: 'Menedżer Serwisu',
      SYSTM_ADMIN: 'Administrator Systemu',
      SYSTM_VIEWER: 'Przeglądający System',
      TECHNICIAN: 'Technik',
      USER_DETAILS: 'Szczegóły Użytkownika',
      COMPANY_DETAILS: 'Dane firmy',
      COMPANY: 'Firma',
      STATUS: 'Status',
},
    TRANSFER_BUILDING_TO_ORGANIZATION: {
      TRANSFER_SUCCESS: 'Budynek pomyślnie przeniesiony do innej organizacji',
      CONFIRM_PASSWORD: 'Potwierdź Hasło',
      INSTRUCTIONS: 'Na stałe przenieś wszystkie {{buildingCount}} budynki, w tym wszystkie {{systemCount}} bramki i {{gatewayCount}} systemy.',
      ORG_SELECT: 'Wybierz prawidłową organizację',
      INSTRUCTION_TWO: 'Wpisz hasło konta Administratora Organizacji, aby potwierdzić akcję.',
      TRANSFER: 'Przenieś.',
      HEADER_TITLE: 'Przenieś Budynek do Innej Organizacji.',
      DROPDOWN_LABEL: 'Przenieś do...',
},
    CHANGE_PASSWORD_SCREEN: {
      CHANGE_PASSWORD: 'Zmień Hasło',
      CONFIRM_PASSWORD: 'Potwierdź Hasło',
      NEW_PASSWORD: 'Nowe Hasło',
},
    MESSAGES: {
      CONGRATS: 'Gratulacje!',
      CONTACT: 'Skontaktuj się z Przedstawicielem Wsparcia Eaton',
      EMAIL_SENT: 'E-mail Wysłany',
      ERROR: 'Błąd!',
      FAILURE: 'Awaria',
      LOADING: 'Ładowanie...',
      EMAIL_ENTRY_ERROR: 'Wprowadź prawidłowy e-mail',
      SUCCESS: 'Sukces',
      WELCOME: 'Witamy!',
      LOGIN_MESSAGE: 'Jesteś zalogowany.',
},
    LANDING_SCREEN: {
      CONNECT_NOW: 'Połącz Teraz',
      CONNECT_TO_SYSTEM: 'Łączenie się z systemami',
      CONTINUE_TO_DASHBOARD: 'Kontynuuj do Pulpitu',
      DASHBOARD_UNAVAILABLE: 'Pulpit Niedostępny',
      NO_INTERNET_CONNECTION: 'Brak Połączenia z Internetem',
      VIEW_DASHBOARD: 'Pokaż Pulpit',
      IN_PROGRESS: 'Praca w toku...',
},
    USERS: {
      CREATE_NEW_CUSTOMER: 'Utwórz Nowego Klienta',
      EDIT_PLATFORM_HEADER: 'Edytuj Platformę',
      EDIT_PLATFORM_SUCCESS_200: 'Platforma Zaktualizowana Pomyślnie',
      LOADER_HELPER_TEXT: 'Proszę czekać',
      MANAGE_PLATFORM_ERROR_CODE_3047: 'Główny Menedżer Serwisu nie jest zarejestrowany w systemie BSMS. Nie można utworzyć platformy',
},
    LABELS: {
      CSV: 'CSV',
      EMAIL: 'Adres E-mail',
      EXCEL: 'Plik Excel',
      FORGOT_PASSWORD: 'Zapomniałeś swoje hasło?',
      GROUP_BY: 'Grupuj Według:',
      ITEMS_PER_PAGE: 'Elementy na stronę',
      LOGGING_IN: 'Logowanie',
      NEED_ACCOUNT: 'Potrzebujesz konta?',
      NEW_PASSWORD: 'Nowe hasło',
      PASSWORD: 'Hasło',
      PDF: 'PDF',
      SHOW: 'Pokaż:',
      SIGN_UP: 'Zarejestruj się',
      TIME_RANGE: 'Zakres Czasu:',
      TO_BE_IMPLEMENTED: 'Do zaaimplementowania',
      VIEW_ALL_EVENTS: 'Pokaż Wszystko {{count}} Wydarzeń',
      SIGN_IN_WITH_OKTA: 'Zaloguj się przez Okta',
},
    AUTO_LOGOUT_DISABLED: {
      AUTO_LOGOUT_DISABLED: 'Wyłączono',
},
    TIMELINE_EXPORT: {
      DOWNLOAD_TITLE: 'Pobierz Dane Czasowe',
      DOWNLOAD_SUBTITLE_SITE: 'Wybierz zakres dat historii alarmów, który chcesz wyeksportować.',
      DOWNLOAD_SUBTITLE_TIMELINE: 'Wybierz lokalizację i zakres dat historii alarmów, które chcesz wyeksportować.',
},
    AUTO_LOGOUT_ENABLED: {
      AUTO_LOGOUT_ENABLED: 'Włączone (Zalecane)',
},
    LEAGAL: {
      END_USER_AGREEMENT: 'Umowa Licencyjna Użytkownika Końcowego',
      LICENCE_AGREEMENT: 'Umowa Licencyjna Użytkownika Końcowego',
      LEAGAL: 'Legalne',
      MANUALS: 'INSTRUKCJE',
      OPEN_SOURCE: 'Licencje Open Source',
      INSTRUCTION_EATON_BSMS_GATEWAY: 'Instrukcje Operacyjne dla Bramki Eaton BSMS',
      QUICK_START_GUIDE: 'Podręcznik Szybkiego Startu',
      REMOTE_MONITORING_GUIDE: 'Przewodnik Zdalnego Monitorowania',
      TERMS_CONDITIONS: 'Warunki i Zasady',
},
    LEGAL: {
      EULA: 'Umowa Licencyjna Użytkownika Końcowego',
      TITLE: 'Legalne',
      OPENSOURCELICENSES: 'Licencje Open Source',
      TERMSANDCONDITIONS: 'Warunki i Zasady',
      EULA_WIRELESS: 'EULA - Eaton Wireless Controller',
      OSS: 'Open source licensing - Eaton Wireless Controller',
      OPEN_SOURCE_BSM: 'Open source licensing - Building Safety Manager',
      REACT_NATIVE: '?',
},
    EVENT_TIMELINE: {
      ERROR_LOADING_MORE_EVENTS: 'Błąd ładowania większej liczby zdarzeń',
      LOAD_MORE_EVENTS: 'Załaduj {{count}} Więcej Zdarzeń',
},
    ASSETS_SCREEN: {
      FAVORITE_LIMIT_REACHED: 'Osiągnięto limit ulubionych',
      NOBUILDINGFOUND: 'Nie Znaleziono Budynków',
      NOGATEWAYFOUND: 'Nie Znaleziono Bramki',
      NOORGANIZATIONFOUND: 'Nie Znaleziono Organizacji',
      NOREPORTFOUND: 'Nie Znaleziono Raportów',
      NOSYSTEMS: 'Nie Znaleziono Systemów',
      OTHERS: 'INNI',
      SHOW_ONLY_STARRED_BUILDING: 'Pokaż Tylko Oznaczone Budynki',
      STARRED: 'OZNACZONE',
      MARK_AS_FAV_API_SUCCESS: 'Dodano do ulubionych pomyślnie.',
      REMOVE_MARK_AS_FAV_API_SUCCESS: 'Usunięto z ulubionych pomyślnie.',
      MARK_AS_FAV_API_FAILURE_MESSAGE: 'Usuń część ulubionych elementów przed dodaniem nowych, ponieważ maksymalna liczba elementów to 10',
},
    ADDLOCATION: {
      ASTERIKSINFO: 'Pola oznaczone gwiazdką (*) są wymagane {{entity}}.',
      ADDLOCATIONINFORMATION: 'Informacje o Profilu Lokalizacji',
},
    HEADER: {
      FORGOT_PASSWORD: 'Zapomniałeś Hasła',
},
    LOGIN: {
      INVALID_CREDENTIALS: 'Kombinacja nazwy użytkownika/hasła nie została rozpoznana.',
      GENERIC_ERROR: 'Twoje żądanie nie mogło zostać przetworzone w tym momencie.',
      UNAUTHORIZED_ACCESS: 'Nieautoryzowany dostęp',
      UNAUTHORIZED_ACCESS_MESSAGE: 'Nie masz uprawnień dostępu do tej aplikacji. Proszę zarejestruj się.',
},
    TABS: {
      LIST_VIEW: 'Widok Listy',
      SUMMARY_VIEW: 'Widok Podsumowania',
},
    NAVIGATION_TABS: {
      LOGBOOK: 'DZIENNIK',
      STATUS: 'STATUS',
},
    HELPANDFEEDBACK: {
      MANUALS: 'Instrukcje',
      TITLE: 'Instrukcje Operacyjne dla Bramki Eaton BSMS',
},
    OPERATING_SYSTEM_THEME: {
      OPERATING_SYSTEM_THEME: 'Motyw Systemu Operacyjnego',
},
    EULA: {
      OTHER_LANGUAGE: 'EULA w Innym Języku',
},
    LOCATIONS: {
      SITES: 'Lokalizacje',
},
    COUNTER: 'Wartość to: {{count}}',
    RESPONSE: {
      USER_REGISTERED: 'Użytkownik może być zarejestrowany.',
},
    PASSWORD_RESET: {
      SUCCESS_MESSAGE: 'Twoje hasło zostało pomyślnie zresetowane.',
      FAILURE_MESSAGE: 'Nie udało się zresetować hasła. Spróbuj ponownie później.',
},
    LICENCE: {
       LICENCE_AGREEMENT: 'Umowa licencyjna',
      OPEN_SOURCE: 'Licencje Open Source',
      REACT_NATIVE_LICENCE: {
        MIT_LICENSE: 'MIT License',
        COPYRIGHT_TEXT: 'Prawa autorskie (c) Facebook, Inc. i podmioty stowarzyszone.',
        MIT_LICENSE_TEXT: 'Niniejszym udziela się bezpłatnego pozwolenia każdej osobie uzyskującej kopię tego oprogramowania i powiązanych plików dokumentacji („Oprogramowanie”) na rozporządzanie Oprogramowaniem bez ograniczeń, w tym, bez ograniczeń, prawa do używania, kopiowania, modyfikowania, scalania, publikowania, dystrybuowania, udzielania sublicencji i/lub sprzedaży kopii Oprogramowania, a także zezwalania osobom, którym dostarczono Oprogramowanie, na takie działanie, z zastrzeżeniem następujących warunków:',
        MIT_LICENSE_TEXT_ONE: 'Powyższa informacja o prawach autorskich oraz niniejsza informacja o pozwoleniu będą dołączone do wszystkich kopii lub istotnych części Oprogramowania.',
        MIT_LICENSE_TEXT_TWO: 'OPROGRAMOWANIE JEST DOSTARCZANE „TAKIE, JAKIE JEST”, BEZ ŻADNEJ GWARANCJI, WYRAŹNEJ LUB DOROZUMIANEJ, W TYM MIĘDZY INNYMI GWARANCJI PRZYDATNOŚCI HANDLOWEJ, PRZYDATNOŚCI DO OKREŚLONEGO CELU I NIENARUSZALNOŚCI. W ŻADNYM WYPADKU AUTORZY LUB POSIADACZE PRAW AUTORSKICH NIE PONOSZĄ ODPOWIEDZIALNOŚCI ZA ŻADNE ROSZCZENIA, SZKODY LUB INNĄ ODPOWIEDZIALNOŚĆ, CZY TO W RAMACH UMOWY, CZYNU NIEDOZWOLONEGO CZY W INNY SPOSÓB, WYNIKAJĄCE Z, Z LUB W ZWIĄZKU Z OPROGRAMOWANIEM LUB UŻYTKOWANIEM LUB INNYMI DZIAŁANIAMI ZWIĄZANYMI Z OPROGRAMOWANIEM.',
},
},
    WIRELESS_GATEWAY: {
      WIRELESS_SEARCHLUMINAIRE_HEADLINE: 'Funkcja "wyszukaj wszystkie oprawy awaryjne" utworzy nową konfigurację, wykonując następujące czynności:',
      WIRELESS_SEARCHLUMINAIRE_PAGE_CONTAINT_TEXT_ONE: 'Wyszukaj wszystkie zainstalowane i zaadresowane oprawy',
      WIRELESS_SEARCHLUMINAIRE_PAGE_CONTAINT_TEXT_TWO: 'Rozpoczęcie wyszukiwania spowoduje usunięcie z konfiguracji wszystkich obecnie zainstalowanych opraw awaryjnych',
      WIRELESS_SEARCH_ALL_LUMINARIES_WARNING: 'Jeżeli chcesz dodać wyłącznie oprawy awaryjne, skorzystaj z opcji "Wyszukaj nowe oprawy awaryjne".',
      WIRELESS_SEARCH_ALL_LUMINARIES_ACTION_NON_CANCELLABLE: 'Tej czynności nie można cofnąć.',
      WIRELESS_SEARCH_ALL_LUMINARIES_DIALOG_TEXT: 'Rozpoczęcie wyszukiwania spowoduje usunięcie z konfiguracji wszystkich obecnie zainstalowanych opraw awaryjnych z błędem',
      WIRELESS_RETRY_SEARCH: 'Ponów wyszukiwanie',
      WIRELESS_CONFIGURE_LUMINARIES: 'Konfiguruj oprawy awaryjne',
      CONFIGURE_LUMINAIRES: 'Konfiguruj oprawy awaryjne',
      ZONE_DESCRIPTION: 'Opis',
},
    STAGE_GROUP: {
      SELECT_STAGE_GROUP: 'Wybierz Stage Group',
},
    NOTIFICATION_KEYS: {
      NOTIFICATION_ALARM_BODY: 'Wystąpił błąd {{logType}} w następującym systemie',
      NOTIFICATION_HEALTH_REPORT_TITLE: 'Nowy raport dostępny - {{org}}',
      NOTIFICATION_HEALTH_REPORT_BODY: 'Nowy miesięczny raport dla {{building}} jest dostępny do przeglądania',
},
    DRY_CONTACT: {
      DRY_CONTACT: 'Bezpotencjałowy styk',
      DRY_CONTACT_STATUS: 'Status styku bezpotencjałowego',
      DEFAULT_SETTINGS: 'Domyślne Ustawienia',
      IOSTATUS: {
        START_FUNCTIONAL_TEST: 'Start funkcjonalnego testu opraw awaryjnych',
},
      START_FUNCTIONAL_TEST: 'Start funkcjonalnego testu opraw awaryjnych',
      NORMALLY_OPEN: 'Normalnie Otwarty',
      BATTERY_OPERATION: 'Praca z baterii',
},
    ACCOUNT_PREFERENCES: {
      CEST: 'Czas Środkowoeuropejski (GMT-1:00)',
},
    SLA: {
      TECHNICIAN: 'Technik',
      STATUS_TODAY: 'Dzisiaj.',
      STATUS_SCHEDULED: 'Zaplanowano',
      STATUS_DUE: 'Przeterminowane',
},
},
};
 export default resources;
